<!-- rota: /entegrasyon/dismuhasebeaktarim  (name: bilet--dis-muhasebe-aktarim) -->
<template>
  <!--
    Cerceve ve yetkilendirme tabandan gelir: v-app, baslik cubugu,
    yetkidialog ve acilistaki yetki kontrolu sayfataban.vue icinde.
    Burada yalnizca sayfanin KENDI icerigi var.
  -->
  <sayfataban
    :baslik="sayfaBasligi"
    :oncekiRota="oncekiRota"
    :durum="durum"
    ref="taban"
  >
    <onaydialog ref="onaydialog"></onaydialog>

    <v-card color="grey lighten-5" flat>
      <!-- ---------------------------------------------- filtreler -->
      <v-layout row wrap align-center>
        <v-flex xs12 sm4 md2>
          <v-select
            :items="tipler"
            label="İşlem Tipi"
            v-model="tip"
            @change="Temizle"
          ></v-select>
        </v-flex>

        <v-flex xs12 sm4 md2>
          <v-menu
            :close-on-content-click="true"
            v-model="menu1"
            transition="scale-transition"
            offset-y
            full-width
            :nudge-right="40"
            min-width="290px"
          >
            <!--
              return-masked-value ZORUNLU: Vuetify maskeyi varsayilan olarak
              v-model'e YANSITMIYOR, elle yazilinca model "01072026" gibi
              noktasiz geliyordu ve ayristirici tarihi null yapiyordu.
            -->
            <v-text-field
              slot="activator"
              :label="basEtiketi"
              v-model="basMetin"
              append-icon="event"
              mask="##.##.####"
              return-masked-value
              @blur="TarihAlindi('bas', 'basMetin')"
            ></v-text-field>
            <v-date-picker
              locale="tr"
              v-model="bas"
              @input="basMetin = TarihBicimle($event)"
              no-title
              scrollable
              actions
            >
              <v-spacer></v-spacer>
            </v-date-picker>
          </v-menu>
        </v-flex>

        <v-flex xs12 sm4 md2>
          <v-menu
            :close-on-content-click="true"
            v-model="menu2"
            transition="scale-transition"
            offset-y
            full-width
            :nudge-right="40"
            min-width="290px"
          >
            <v-text-field
              slot="activator"
              :label="bitEtiketi"
              v-model="bitMetin"
              append-icon="event"
              mask="##.##.####"
              return-masked-value
              @blur="TarihAlindi('bit', 'bitMetin')"
            ></v-text-field>
            <v-date-picker
              locale="tr"
              v-model="bit"
              @input="bitMetin = TarihBicimle($event)"
              no-title
              scrollable
              actions
            >
              <v-spacer></v-spacer>
            </v-date-picker>
          </v-menu>
        </v-flex>

        <v-flex xs12 sm4 md2>
          <v-select :items="hatlar" label="Hat" v-model="hat"></v-select>
        </v-flex>

        <v-flex xs12 sm4 md2>
          <v-text-field label="Havayolu Kodu" v-model="havayolu"></v-text-field>
        </v-flex>

        <!--
          Musteri ve satis faturasi suzgecleri YALNIZCA faturada: maliyet
          belgesi biletten, iade dekontu Iade kaydindan turer; sunucunun o
          uclari bu alanlari hic almiyor. Gorunur kalsalardi kullanici
          doldurup ayni listeyi alir, suzgecin sessizce yok sayildigini fark
          etmezdi.
        -->
        <template v-if="faturaMi">
          <v-flex xs12 sm4 md2>
            <v-text-field label="Müşteri Kodu" v-model="musteri"></v-text-field>
          </v-flex>

          <v-flex xs12 sm4 md2>
            <v-text-field label="Fatura Seri" v-model="faturaSeri"></v-text-field>
          </v-flex>

          <v-flex xs12 sm4 md2>
            <v-text-field label="Fatura No" v-model="faturaNo"></v-text-field>
          </v-flex>
        </template>

        <!--
          BSP biletlerinin maliyeti BSP mutabakatindan gelir; ayrica maliyet
          belgesi uretilmemeli. Liste suzgecidir: Filtreler() icinde gider ve
          listeFiltresi ile aktarima da tasinir.
        -->
        <v-flex xs12 sm4 md2 v-if="maliyetMi">
          <v-checkbox
            label="BSP biletlerini hariç tut"
            v-model="bspHaric"
            hide-details
          ></v-checkbox>
        </v-flex>

        <v-flex xs12 sm4 md2>
          <kaydetbutonu
            :action="Listele"
            color="primary"
            :flat="false"
            dark
          >
            <v-icon left>search</v-icon>Listele
          </kaydetbutonu>
        </v-flex>

        <v-flex xs12 sm4 md2>
          <!--
            Muhasebe kodlari tanimli degilse aktarim hicbir satira kod
            atayamaz ve dosya URETMEZ. Dugme listeden bagimsiz duruyor
            cunku kod girisi listelemeden once de gerekiyor.
          -->
          <kaydetbutonu
            :action="MuhasebeKodlariAc"
            color="warning"
            :flat="false"
            dark
          >
            <v-icon left>settings</v-icon>Muhasebe Kodları
          </kaydetbutonu>
        </v-flex>
      </v-layout>

      <!--
        -------------------------------------------------- liste
        Dort tipin de sunucu ucu var; "henuz hazir degil" yolu (uyari +
        pasif Listele) son tip de hazir olunca kaldirildi. Kosul yalnizca
        tanimsiz bir tip degerine karsi (bkz. tipAyari).
      -->
      <template v-if="tipAyari">
        <!--
          Maliyette ve iadede bazi kayitlar listeye HIC girmiyor. Yazilmazsa
          kullanici eksik listeyi tam sanip onlari hic aktarmaz.

          Sebep tek degil (cari karti yok, durum kodu tam eslesmiyor, dekont
          numarasi yok...); neden adlari tipe gore (bkz. AtlananNedenAdi).
          Sunucu nedenleri bildirdiyse neden KODUNA gore gruplanir (metin
          satirin kendi degerini tasidigi icin gruplamaya yaramaz; o metin
          ornek numaranin ipucunda); bildirmediyse (eski yanit) metin sebep
          UYDURMAZ, yalnizca numaralari sayar.
        -->
        <v-alert :value="atlananToplami > 0" type="info" outline>
          <template v-if="atlananGruplari.length > 0">
            {{ atlananToplami }} bilet listeye alınmadı:
            <div v-for="g in atlananGruplari" :key="'neden' + g.kod">
              <b>{{ g.sayi }}</b> bilet — {{ g.neden }}
              <span v-if="g.ornekler.length > 0"
                >(<span
                  v-for="(o, i) in g.ornekler"
                  :key="i"
                  :title="o.ayrinti"
                  :class="{ 'atlanan-ornek': o.ayrinti }"
                  >{{ i > 0 ? ", " : "" }}{{ o.biletNo }}</span
                ><template v-if="g.fazla > 0"> ve {{ g.fazla }} bilet daha</template>)</span
              >
            </div>
          </template>
          <template v-else>
            {{ atlananToplami }} bilet listeye alınmadı: {{ atlananBiletOzeti }}
          </template>
        </v-alert>

        <!--
          Listenin TAMAMINI etkileyen uyarilar (ornegin vergi parametresi
          yoksa KDV ayrilmiyor). Belge basina uyarilardan ayri: tek tek
          satirlarda tekrarlanmiyor, yazilmazsa hic gorulmez.
        -->
        <v-alert
          :value="genelUyarilar.length > 0"
          type="warning"
          outline
        >
          <div v-for="(u, i) in genelUyarilar" :key="i">{{ u }}</div>
        </v-alert>

        <!--
          Dosya uretildi ama damga konamadi (X-Damga-Hatasi). Snackbar birkac
          saniyede kayboluyor; bu bilgi ise kullanici ayni belgeleri ikinci
          kez gondermeden once okunmali, o yuzden kapatilana kadar durur.
        -->
        <v-alert
          :value="damgaHatasi !== ''"
          type="error"
          outline
          dismissible
          @input="damgaHatasi = ''"
        >
          {{ damgaHatasi }}
        </v-alert>

        <v-layout row wrap align-center v-if="faturalar.length > 0">
          <v-flex xs12 sm6 md4>
            <span class="grey--text text--darken-1">
              {{ suzulmusFaturalar.length }}
              <template v-if="suzulmusFaturalar.length !== faturalar.length">
                / {{ faturalar.length }}
              </template>
              {{ belgeSozcukleri.ad }} ·
              {{ secilenler.length }} seçili ·
              {{ aktarilanSayisi }} daha önce aktarılmış
            </span>

            <!--
              Filtre disinda kalan secimler de aktarilir. Tablo tam listeyi
              aldigi icin (bkz. tabloSuzgeci) arama ya da durum suzgeci secimi
              SILMIYOR; gorunmeyen secimler ise kullanicinin gozunden kacar.
              Sayiyi acikca yazmak yanlislikla fazla belge gondermeyi onluyor.
            -->
            <div v-if="gizliSecimSayisi > 0" class="orange--text text--darken-3">
              <v-icon small color="orange darken-3">warning</v-icon>
              {{ gizliSecimSayisi }} seçili {{ belgeSozcukleri.ad }}
              süzgeç dışında kaldı (ekranda görünmüyor); aktarıma ve
              <b>Entegreyi Geri Al</b>'a <b>onlar da</b> dahil edilir.
            </div>

            <!--
              Vuetify'nin baslik kutusu yalnizca O SAYFADA gorunen satirlari
              secer/birakir (data-iterable toggle: filteredItems sayfalanmis
              dilim). Kullanici "tumunu sectim" sanip diger sayfalari
              gondermedigini fark etmesin diye yaziliyor.
            -->
            <div class="grey--text caption">
              Başlıktaki kutu yalnızca bu sayfada görünen satırları seçer.
            </div>
          </v-flex>

          <v-flex xs12 sm6 md4>
            <!--
              Dugme dogrudan aktarmiyor: once secenek penceresi aciliyor.
              Istek ATMADIGI icin kaydetbutonu degil duz v-btn.
              dark yalnizca aktifken: pasif + dark dugme beyaz kart uzerinde
              beyaz yazi ile gorunmez oluyordu.
              aktarim-dugmesi: Vuetify'nin pasif rengi (yazi %26, zemin %12
              siyah) beyaz kartta okunmuyor, kullanici dugmeyi hic GORMUYOR
              sanip secim yapilinca ortaya ciktigini anlamiyordu; sinif pasif
              halde cerceve verip yaziyi koyulastiriyor (asagidaki style).
            -->
            <v-btn
              class="aktarim-dugmesi"
              :disabled="secilenler.length === 0"
              color="success"
              :dark="secilenler.length > 0"
              @click="AktarimiAc"
            >
              <v-icon left>save_alt</v-icon>Seçilenleri Aktar
            </v-btn>

            <kaydetbutonu
              class="aktarim-dugmesi"
              :action="GeriAl"
              :disabled="secilenler.length === 0"
              color="error"
              :flat="false"
              dark
            >
              <v-icon left>undo</v-icon>Entegreyi Geri Al
            </kaydetbutonu>
          </v-flex>
        </v-layout>

        <!--
          Arama ve durum suzgeci tablonun hemen ustunde: neyin suzuldugu
          boylece sezgisel. Ikisi de LISTENIN ICINDE calisir, sunucuya
          gitmez - liste zaten bellekte. Sunucu tarafi suzgecler (hat,
          havayolu, musteri, seri, no) yukaridaki filtre satirinda.
        -->
        <v-layout row wrap align-center class="mb-2">
          <v-flex xs12 sm7 md8>
            <v-text-field
              v-model="arama"
              :label="aramaEtiketi"
              append-icon="search"
              clearable
              hide-details
              single-line
            ></v-text-field>
          </v-flex>

          <v-flex xs12 sm5 md4 class="text-xs-right">
            <v-btn-toggle v-model="durumSuzgeci" mandatory>
              <v-btn
                flat
                small
                v-for="d in durumlar"
                :key="d.value"
                :value="d.value"
              >
                {{ d.text }}
              </v-btn>
            </v-btn-toggle>
          </v-flex>
        </v-layout>

        <!--
          Tek tablo, uc satir bicimi (fatura / maliyet / iade; satis ve alis
          iadesi ayni bicimi paylasir). item-key tipe gore degisir: fatura
          TamFaturaNo, maliyet ve iade belgesi sunucunun urettigi Anahtar ile
          tanimlanir. Tip degisince Temizle() secimi bosalttigi icin eski
          anahtarla kalmis secim olmaz.

          Tablo listenin TAMAMINI alir, suzmeyi kendi search/custom-filter
          yoluyla yapar. Suzulmus dizi :items'a verilseydi Vuetify 1.5'in
          items izleyicisi (data-iterable.js) yeni dizide olmayan secimleri
          v-model'den sessizce SILERDI: arama yazip silen kullanici
          sectiklerini kaybediyordu. Search degisimi secime dokunmuyor.

          aktarim-tablosu: yatay kaydirma cubugunu kaldiran daraltma
          kurallarinin tutamagi (bkz. dosyanin sonundaki style blogu).
          Sinif SART: kurallar global v-data-table'a yazilsaydi uygulamadaki
          onlarca listeyi sessizce degistirirdi.
        -->
        <v-data-table
          v-model="secilenler"
          select-all
          :item-key="tabloAnahtari"
          :headers="basliklar"
          :items="faturalar"
          :search="tabloSuzgeci"
          :custom-filter="TabloSuz"
          :loading="yukleniyor"
          :rows-per-page-items="[25, 50, 100, { text: 'Tümü', value: -1 }]"
          class="elevation-1 aktarim-tablosu"
        >
          <template v-slot:items="props">
            <td>
              <v-checkbox
                :input-value="props.selected"
                @change="props.selected = $event"
                primary
                hide-details
              ></v-checkbox>
            </td>
            <!--
              Maliyet belgesi: e-Fatura kaydi YOK (fatura detay baglantisi
              verilmez) ve karsi taraf havayolu tedarikcisinin Logo kodu,
              ArkmanNext carisi degil (cari duzenlemeye baglanmaz).
            -->
            <template v-if="maliyetMi">
              <!--
                title: hucre daraltildigi icin (bkz. style) uzun bir belge no
                uc noktaya dusebilir; tam deger ipucunda kalmali - kullanici
                kaydirma cubugundan kurtulurken degeri kaybetmemeli.
              -->
              <td :title="props.item.BelgeNo">
                <!--
                  Uyari aktarimi durdurmayabilir (bos tedarikci kodu, sifir
                  toplam, eksik muhasebe kodu) ama kullanici gondermeden
                  gormeli; ayrintisi ipucunda ve satir penceresinde.

                  Simge DEGERDEN ONCE: hucre daraltilip kirpildigi icin
                  (overflow: hidden) metinden SONRA gelen simge hucrenin
                  gorunur kutusunun DISINDA kaliyordu ve hic cizilmiyordu -
                  1280'de simgenin sol kenari 436px, hucrenin gorunur sag
                  siniri 377px olculdu. Kirpma her zaman SAGDAN oldugu icin
                  sola alinan simge her genislikte cizilir. Okuma sirasini
                  bozmuyor: simge bir durum isareti, kolonun degeri degil -
                  gozle taranan sey yine belge no ve o hemen saginda. Uyari
                  yoksa v-if hic bir sey basmadigi icin temiz satirlar
                  metin alanindan piksel kaybetmiyor.

                  title="" SART. Hucrenin kendisinde :title var (belge no) ve
                  simge o hucrenin ICINDE: bos title verilmezse simgenin
                  uzerine gelen kullanici ONCE Vuetify ipucunu (uyari listesi)
                  sonra tarayicinin yerel ipucunu (belge no) UST USTE goruyor.
                  HTML'de bos title "ust soydan ipucu ALMA" demek, yani
                  yalnizca bu simgeyi susturur; hucrenin geri kalaninda ipucu
                  aynen cikmaya devam eder.
                  Cozum :title'i bir span'e tasimak DEGIL: o zaman hucrenin uc
                  nokta bolgesinde - degerin asil okunamadigi yerde - ipucu
                  hic cikmazdi.
                -->
                <v-tooltip
                  v-if="props.item.Uyarilar && props.item.Uyarilar.length > 0"
                  bottom
                >
                  <v-icon
                    slot="activator"
                    small
                    color="orange darken-2"
                    title=""
                  >
                    warning
                  </v-icon>
                  <div v-for="(u, i) in props.item.Uyarilar" :key="i">
                    {{ u }}
                  </div>
                </v-tooltip>
                <!--
                  Belge no BILET EKRANINI aciyor (Bilet No hucresiyle ayni
                  adres ve ayni kural). Maliyet belgesinin numarasi zaten
                  havayolu kartinin FormNo'su + biletin numarasidir
                  (orn. 235 + 2522566290 = 2352522566290), yani baglantinin
                  actigi bilet belgenin kendi biletidir.

                  Satis tarihli maliyette (M) Bilet No kolonu bu yuzden hic
                  cizilmiyor - iki kolon ayni numarayi tasiyordu ve 17
                  kolonluk tabloda yer harciyordu (kullanici karari,
                  2026-09-22). Baglanti kolonla birlikte kaybolmasin diye
                  buraya tasindi. Fatura tarihli maliyette (MF) Bilet No
                  kolonu DURUYOR, orada iki baglanti da ayni bileti acar.
                -->
                <a
                  v-if="MaliyetBiletAcilabilir(props.item)"
                  target="_blank"
                  :href="MaliyetBiletAdresi(props.item)"
                  >{{ props.item.BelgeNo }}</a
                >
                <span v-else>{{ props.item.BelgeNo }}</span>
              </td>
              <!--
                Tarih hucrelerinde de title. Dolgu 24px'ken "01.09.2026"
                hucre icinde 108px yer kapliyor, 80px'lik tavana sigmiyor
                ve 1280'de "01.0..." diye kaliyordu - ipucu da olmadigi
                icin tarih HICBIR yerden okunamiyordu. Dolgu 6px'e inince
                72px'e dusup siginca kirpma kalkti, ama ipucu ucuz bir
                sigorta: tavan daraltilirsa ya da tarih bicimi uzarsa
                (orn. saat eklenirse) kirpma geri geldiginde deger yine
                okunabilir kalir.
                Ipucu EKRANDAKI bicimlenmis degeri tasir (ham ISO tarihi
                degil), yoksa kullanici ipucunda bambaska bir metin gorurdu.

                tarih-hucresi: dar ekran sarma kuralinin DISINDA tutulmasi
                icin (bkz. style'daki medya sorgusu). "01.09.2026" bosluksuz
                tek bir belirtec; sarma serbest birakilsa "01.09." / "2026"
                diye ikiye bolunur ve tarih okunakligini kaybeder. Sinif gerekli,
                cunku para hucrelerindeki .text-xs-right gibi hazir bir isaret
                tarih kolonlarinda yok.
              -->
              <td
                class="tarih-hucresi"
                :title="TarihBicimle(props.item.SatisTarihi)"
              >
                {{ TarihBicimle(props.item.SatisTarihi) }}
              </td>
              <!--
                Yalnizca fatura tarihli maliyette (faturaBilgisiVar): aralik
                bu tarihe uygulaniyor ve biletlerin cogunda satis gunuyle
                AYNI DEGIL. Hucre sayisi basliklarla birlikte degisiyor
                (maliyetFaturaBasliklari); kolon eklenip hucre unutulursa
                degerler yanlis basligin altina kayar.
              -->
              <template v-if="faturaBilgisiVar">
                <td :title="props.item.TamFaturaNo">
                  {{ props.item.TamFaturaNo }}
                </td>
                <!-- title + tarih-hucresi: bkz. satis tarihi hucresindeki not. -->
                <td
                  class="tarih-hucresi"
                  :title="TarihBicimle(props.item.FaturaTarihi)"
                >
                  {{ TarihBicimle(props.item.FaturaTarihi) }}
                </td>
              </template>
              <td>{{ props.item.HavayoluKodu }}</td>
              <!--
                Bilet No kolonu YALNIZCA fatura tarihli maliyette (MF).
                Satis tarihlisinde (M) kaldirildi: belge no zaten FormNo +
                bilet numarasi oldugu icin iki kolon ayni numarayi
                gosteriyordu ve yer harciyordu (kullanici karari,
                2026-09-22): M 15 kolondan (14 baslik + onay kutusu) 14 e
                indi, MF 17 de kaldi. Bilet ekrani baglantisi kaybolmadi,
                belge no hucresine tasindi.

                Hucre sayisi basliklarla birlikte degisiyor: kolon
                maliyetBasliklari'ndan da cikarildi, maliyetFaturaBasliklari'nda
                duruyor. Ikisi ayrisirsa degerler yanlis basligin altina kayar;
                spec bunu satir basina <td> sayarak koruyor.

                title <a> uzerinde DEGIL <td> uzerinde: kirpilan kisim
                baglantinin disinda kaliyor, ipucu orada da cikmali.
              -->
              <td v-if="biletNoKolonuVar" :title="props.item.BiletNo">
                <a
                  v-if="MaliyetBiletAcilabilir(props.item)"
                  target="_blank"
                  :href="MaliyetBiletAdresi(props.item)"
                  >{{ props.item.BiletNo }}</a
                >
                <span v-else>{{ props.item.BiletNo }}</span>
              </td>
              <!--
                Tedarikci kodu CARI KARTINA BAGLANMAZ. Havayolu kartinin
                Reserved5 / Reserved7'sinden gelir; Tekser'de bu kodlarin besi
                de gercek bir cari karta denk geliyor (THY, IATA, Pegasus,
                AJet, Gunes Ekspres) ama alan SERBEST METIN: Logo'ya yazilacak
                tedarikci kodu icin var, cari karta bagli degil. Kullanici
                oraya karsiligi olmayan bir kod yazdiginda baglanti bos cari
                karti acardi. Musteri kodu ise carinin kendisidir, baglanir.

                KALEM SIMGESI: tiklayinca havayolu kartinin o hatta ait iki
                kodunu duzenleyen pencere acilir (kullanici karari,
                2026-09-22: "tedarikci kodu kalemlerin icine girip degil,
                tablodaki hucreden girilsin"). Onceden yalnizca KALEM
                penceresinden aciliyordu; kod eksik olan belgeyi duzeltmek
                icin once kalemleri acmak gerekiyordu.

                SIMGE DEGERDEN ONCE: hucre daraltilip kirpildigi icin
                (overflow: hidden) metinden SONRA gelen simge hucrenin
                gorunur kutusunun DISINDA kalir ve hic cizilmez - ayni
                tuzak Belge No hucresindeki uyari simgesinde olculdu
                (1280'de simgenin sol kenari 436px, hucrenin gorunur sag
                siniri 377px). Kirpma her zaman SAGDAN oldugu icin sola
                alinan simge her genislikte cizilir.

                Kod BOSSA yalnizca simge kalir (kullanici karari,
                2026-09-22: "tedarikci tanimli degilse kod gir yazisina
                gerek yok"). Simge zaten tiklanacak seyin kendisi.

                kaydetbutonu: pencere sunucudan kart OKUYOR, yani bu bir API
                cagrisi; cift tikta iki istek gitmesin.
              -->
              <td class="tedarikci-hucresi" :title="props.item.TedarikciKod">
                <kaydetbutonu
                  v-if="havayoluKartiDuzenlenir"
                  :action="() => HavayoluKoduAc(props.item)"
                  icon
                  small
                  class="hucre-dugmesi"
                  title="Havayolu kartındaki tedarikçi kodlarını düzenle"
                >
                  <v-icon small>edit</v-icon>
                </kaydetbutonu>
                {{ props.item.TedarikciKod }}
              </td>
              <td :title="props.item.MusteriKodu">
                <a
                  v-if="props.item.MusteriKodu"
                  target="_blank"
                  :href="CariAdresi(props.item.MusteriKodu)"
                  >{{ props.item.MusteriKodu }}</a
                >
                <span v-else>{{ props.item.MusteriKodu }}</span>
              </td>
              <!--
                uzun-metin: yolcu adi serbest metin ve listenin en genis
                kolonu (stil kapaliyken 298px olculdu). Style onu kodlardan
                daha genis bir tavanla sinirliyor (--ad-tavani); tam ad
                title'da.
              -->
              <td class="uzun-metin" :title="props.item.YolcuAdi">
                {{ props.item.YolcuAdi }}
              </td>
              <!--
                Hat kolonu UC DEGERLI: B_Ic_Dis / I_Ic_Dis alani I, D ve B
                tasiyor. B (BSP) burada "Dış" diye gosteriliyordu, yani
                gercek dis hat biletinden ayirt edilemiyordu - oysa ekranin
                kendi suzgecinde "BSP hariç" kutusu var, ayrim urunun
                modelinde ZATEN duruyor.

                Ipucu yalnizca BSP satirinda cikar ve FARKIN NEREDE
                oldugunu soyler: hat olarak dis hattir (Reserved7/8), ama
                kodlar havayolunun kendi kartindan degil sabit "BS"
                kartindan okunur (BSP_TEKHESAP_YAZ acikken; uretimde hep
                acik). Kullanici "tedarikci kodu neden baska bir kartta"
                diye tam burada takiliyor.
              -->
              <td class="hat-hucresi" :title="HatIpucu(props.item.IcDis)">
                {{ HatAdi(props.item.IcDis) }}
              </td>
              <td>{{ props.item.BelgeDoviz || "TL" }}</td>
              <td class="text-xs-right">{{ Para(props.item.Matrah) }}</td>
              <td class="text-xs-right">{{ Para(props.item.KdvToplami) }}</td>
              <td class="text-xs-right">{{ Para(props.item.Tutar) }}</td>
            </template>
            <!--
              Iade dekontu (satis ve alis iadesi): belge DekontNo ile
              gruplaniyor. e-Fatura baglantisi yok (dekont e-Fatura degil).
              Karsi taraf kolonu tipe gore: satis iadesinde ArkmanNext
              carisi (Iade.Carikod), alis iadesinde havayolu tedarikcisinin
              Logo kodu; basliklar da ayni ayrimla (iadeBasliklari /
              alisIadeBasliklari).
            -->
            <template v-else-if="iadeMi">
              <!-- title: bkz. maliyet dalindaki belge no notu. -->
              <td :title="props.item.DekontNo">
                <!--
                  Uyari simgesi DEGERDEN ONCE ve title="": bkz. maliyet
                  satirindaki not (metinden sonra gelen simge kirpilan hucrede
                  hic cizilmiyordu; bos title da hucrenin ipucunun simgenin
                  ipucuyla ust uste binmesini onluyor).
                -->
                <v-tooltip
                  v-if="props.item.Uyarilar && props.item.Uyarilar.length > 0"
                  bottom
                >
                  <v-icon
                    slot="activator"
                    small
                    color="orange darken-2"
                    title=""
                  >
                    warning
                  </v-icon>
                  <div v-for="(u, i) in props.item.Uyarilar" :key="i">
                    {{ u }}
                  </div>
                </v-tooltip>
                {{ props.item.DekontNo }}
              </td>
              <!-- title + tarih-hucresi: bkz. maliyet dalindaki satis tarihi notu. -->
              <td
                class="tarih-hucresi"
                :title="TarihBicimle(props.item.IadeTarihi)"
              >
                {{ TarihBicimle(props.item.IadeTarihi) }}
              </td>
              <td :title="props.item.BelgeNo">{{ props.item.BelgeNo }}</td>
              <td>{{ props.item.HavayoluKodu }}</td>
              <!-- title <td> uzerinde: bkz. maliyet dalindaki bilet no notu. -->
              <td :title="props.item.BiletNo">
                <a
                  v-if="MaliyetBiletAcilabilir(props.item)"
                  target="_blank"
                  :href="MaliyetBiletAdresi(props.item)"
                  >{{ props.item.BiletNo }}</a
                >
                <span v-else>{{ props.item.BiletNo }}</span>
              </td>
              <!--
                Karsi taraf kolonu: satis iadesinde musterinin carisi
                (Iade.Carikod) - cari kartina baglanir. Alis iadesinde ayni
                kolonda havayolu kartinin Reserved5 / Reserved7'si var; o
                serbest metin bir tedarikci kodudur, cari karta bagli
                olmayabilir, bu yuzden BAGLANMAZ (bkz. maliyet satirindaki not).

                title ayni ayrimi izlemeli: IadeKarsiTaraf iki dalda da
                EKRANDA yazan degeri dondurur (satis iadesinde CariKod, alis
                iadesinde TedarikciKod), yani ipucu gosterilenle birebir.
              -->
              <td class="tedarikci-hucresi" :title="IadeKarsiTaraf(props.item)">
                <a
                  v-if="!alisIadeMi && props.item.CariKod"
                  target="_blank"
                  :href="CariAdresi(props.item.CariKod)"
                  >{{ props.item.CariKod }}</a
                >
                <!--
                  Alis iadesinde deger havayolu kartindan geliyor; maliyet
                  tablosundaki gibi kalem simgesi degerin ONUNDE durur ve
                  tiklayinca kart penceresi acilir. Satis iadesinde bu dal
                  hic calismaz (havayoluKartiDuzenlenir false): orada ayni
                  alan MUSTERI carisinin Reserved2'si ve ustteki baglanti
                  onu aciyor - havayolu karti penceresi orada YANLIS karti
                  duzelttirirdi.
                -->
                <template v-else-if="havayoluKartiDuzenlenir">
                  <kaydetbutonu
                    :action="() => HavayoluKoduAc(props.item)"
                    icon
                    small
                    class="hucre-dugmesi"
                    title="Havayolu kartındaki tedarikçi kodlarını düzenle"
                  >
                    <v-icon small>edit</v-icon>
                  </kaydetbutonu>
                  {{ props.item.TedarikciKod }}
                </template>
                <span v-else>{{ IadeKarsiTaraf(props.item) }}</span>
              </td>
              <!-- uzun-metin: unvan serbest metin; bkz. yolcu adi notu. -->
              <td class="uzun-metin" :title="props.item.Unvan">
                {{ props.item.Unvan }}
              </td>
              <td :title="props.item.MusteriKodu">
                <a
                  v-if="props.item.MusteriKodu"
                  target="_blank"
                  :href="CariAdresi(props.item.MusteriKodu)"
                  >{{ props.item.MusteriKodu }}</a
                >
                <span v-else>{{ props.item.MusteriKodu }}</span>
              </td>
              <td class="uzun-metin" :title="props.item.YolcuAdi">
                {{ props.item.YolcuAdi }}
              </td>
              <!--
                Hat kolonu UC DEGERLI: B_Ic_Dis / I_Ic_Dis alani I, D ve B
                tasiyor. B (BSP) burada "Dış" diye gosteriliyordu, yani
                gercek dis hat biletinden ayirt edilemiyordu - oysa ekranin
                kendi suzgecinde "BSP hariç" kutusu var, ayrim urunun
                modelinde ZATEN duruyor.

                Ipucu yalnizca BSP satirinda cikar ve FARKIN NEREDE
                oldugunu soyler: hat olarak dis hattir (Reserved7/8), ama
                kodlar havayolunun kendi kartindan degil sabit "BS"
                kartindan okunur (BSP_TEKHESAP_YAZ acikken; uretimde hep
                acik). Kullanici "tedarikci kodu neden baska bir kartta"
                diye tam burada takiliyor.
              -->
              <td class="hat-hucresi" :title="HatIpucu(props.item.IcDis)">
                {{ HatAdi(props.item.IcDis) }}
              </td>
              <td class="text-xs-right">{{ Para(props.item.Matrah) }}</td>
              <td class="text-xs-right">{{ Para(props.item.KdvToplami) }}</td>
              <td class="text-xs-right">{{ Para(props.item.Tutar) }}</td>
            </template>
            <template v-else>
              <!-- title <td> uzerinde: bkz. maliyet dalindaki bilet no notu. -->
              <td :title="props.item.TamFaturaNo">
                <!--
                  Fatura numarasi e-Fatura detayina baglanir. GUID E_Fatura'dan
                  gelir; kaydi olmayan ya da silinmis faturalarda bos gelir ve
                  o zaman duz metin gosterilir - acilmayacak bir baglanti
                  vermemek icin.
                -->
                <a
                  v-if="props.item.EFaturaGuid"
                  target="_blank"
                  :href="FaturaDetayAdresi(props.item)"
                  >{{ props.item.TamFaturaNo }}</a
                >
                <span v-else>{{ props.item.TamFaturaNo }}</span>
              </td>
              <!-- title + tarih-hucresi: bkz. maliyet dalindaki satis tarihi notu. -->
              <td
                class="tarih-hucresi"
                :title="TarihBicimle(props.item.FaturaTarihi)"
              >
                {{ TarihBicimle(props.item.FaturaTarihi) }}
              </td>
              <td :title="props.item.CariKod">
                <!--
                  Cari kod, cari duzenleme sayfasina baglanir. Kod bos gelirse
                  (cari karti silinmis bilet) duz metin gosterilir.
                -->
                <a
                  v-if="props.item.CariKod"
                  target="_blank"
                  :href="CariAdresi(props.item.CariKod)"
                  >{{ props.item.CariKod }}</a
                >
                <span v-else>{{ props.item.CariKod }}</span>
              </td>
              <!-- uzun-metin: unvan serbest metin; bkz. yolcu adi notu. -->
              <td class="uzun-metin" :title="props.item.Unvan">
                {{ props.item.Unvan }}
              </td>
              <!--
                Hat kolonu UC DEGERLI: B_Ic_Dis / I_Ic_Dis alani I, D ve B
                tasiyor. B (BSP) burada "Dış" diye gosteriliyordu, yani
                gercek dis hat biletinden ayirt edilemiyordu - oysa ekranin
                kendi suzgecinde "BSP hariç" kutusu var, ayrim urunun
                modelinde ZATEN duruyor.

                Ipucu yalnizca BSP satirinda cikar ve FARKIN NEREDE
                oldugunu soyler: hat olarak dis hattir (Reserved7/8), ama
                kodlar havayolunun kendi kartindan degil sabit "BS"
                kartindan okunur (BSP_TEKHESAP_YAZ acikken; uretimde hep
                acik). Kullanici "tedarikci kodu neden baska bir kartta"
                diye tam burada takiliyor.
              -->
              <td class="hat-hucresi" :title="HatIpucu(props.item.IcDis)">
                {{ HatAdi(props.item.IcDis) }}
              </td>
              <td>{{ props.item.BelgeDoviz || "TL" }}</td>
              <td class="text-xs-right">{{ Para(props.item.ToplamMatrah) }}</td>
              <td class="text-xs-right">{{ Para(props.item.ToplamKdv) }}</td>
              <td class="text-xs-right">{{ Para(props.item.ToplamNet) }}</td>
            </template>
            <td class="text-xs-right">
              <!--
                Kalemler liste yanitiyla GELMIYOR; dugme ilk aciliste
                sunucudan cekiyor (bkz. SatirlariAc). Istek attigi icin
                kaydetbutonu: cift tik ayni kalemleri iki kez istemesin.
                Onbellekteki kalemde Promise hemen cozulur.
              -->
              <kaydetbutonu
                :action="() => SatirlariAc(props.item)"
                small
                color="primary"
                class="ma-0"
              >
                {{ props.item.SatirSayisi }}
                <v-icon right small>list</v-icon>
              </kaydetbutonu>
            </td>
            <!--
              durum-hucresi: bu kolon TAVAN DISINDA kalmali (bkz. style).
              Rozetin metni degerin kendisi ve title'i yok; tavana takilinca
              ortadan biciliyor, kullanici "Aktarilmadi" yerine yarim bir
              sozcuk goruyordu.
            -->
            <td class="durum-hucresi">
              <v-chip
                small
                :color="props.item.EntegreEdildi ? 'green lighten-4' : 'grey lighten-3'"
              >
                {{ props.item.EntegreEdildi ? "Aktarıldı" : "Aktarılmadı" }}
              </v-chip>
            </td>
          </template>

          <template v-slot:no-data>
            <span class="grey--text">
              Listelemek için tarih aralığı seçip Listele düğmesine basın.
            </span>
          </template>

          <!-- Liste dolu ama arama / durum suzgecine uyan satir yok. -->
          <template v-slot:no-results>
            <span class="grey--text">
              Süzgece uyan {{ belgeSozcukleri.ad }} yok.
            </span>
          </template>
        </v-data-table>
      </template>

      <!-- ------------------------------------------------- aktarım -->
      <v-dialog v-model="aktarimDialog" max-width="560" persistent>
        <v-card>
          <v-card-title class="grey lighten-3">
            <span class="headline">Seçilenleri Aktar</span>
          </v-card-title>

          <v-card-text>
            <div class="mb-3">
              <span class="title">{{ secilenler.length }}</span>
              {{ belgeSozcukleri.ad }} aktarılacak.
              <!-- Suzgecte gorunmeyen secimler de gidiyor; son kez soyleniyor. -->
              <div v-if="gizliSecimSayisi > 0" class="orange--text text--darken-3">
                Bunların {{ gizliSecimSayisi }} tanesi şu anki süzgeçte
                görünmüyor.
              </div>
            </div>

            <!--
              Yalnizca TlAktar'i olan tipte (satis tarihli maliyet). Aciksa
              belge basligina doviz cinsi, kur ve doviz toplami yazilmaz;
              muhasebe programi belgeyi TL sayar. Her aciliste ACIK baslar
              (bkz. AktarimiAc). Fatura tarihli maliyette sunucu bu alani
              yok saydigi icin kutu da yok (bkz. tlAktarSecenegi).
            -->
            <template v-if="tlAktarSecenegi">
              <v-checkbox
                v-model="aktarimTlAktar"
                label="Faturaları TL aktar"
                hide-details
              ></v-checkbox>
              <div class="mb-2 grey--text text--darken-1">
                Açıkken dövizli belgelerin başlığına döviz cinsi, kur ve döviz
                toplamı yazılmaz; muhasebe programı belgeyi TL kabul eder.
              </div>
            </template>

            <v-checkbox
              v-model="aktarimIsaretle"
              label="Bu kayıtları 'aktarıldı' olarak işaretle"
              hide-details
            ></v-checkbox>

            <!--
              Isaret ile dosya BIRBIRINDEN BAGIMSIZ: dosya her iki durumda
              da uretilir, secenek yalnizca damgayi belirler. Kullanici
              deneme amacli dosya alip listeyi kirletmek istemeyebilir.
            -->
            <div class="mt-2 grey--text text--darken-1">
              <template v-if="aktarimIsaretle">
                {{ belgeSozcukleri.Cogul }} listede <b>Aktarıldı</b> görünecek
                ve yanlışlıkla ikinci kez gönderilmeleri önlenecek. İşareti
                sonradan <b>Entegreyi Geri Al</b> ile kaldırabilirsiniz.
              </template>
              <template v-else>
                Dosya yine de üretilir, <b>ama</b> {{ belgeSozcukleri.cogul }}
                listede <b>Aktarılmadı</b> kalır. Deneme amaçlı çıktı almak
                için uygundur.
              </template>
            </div>
          </v-card-text>

          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn flat @click="aktarimDialog = false">Vazgeç</v-btn>
            <kaydetbutonu :action="Aktar" color="success">
              <v-icon left>save_alt</v-icon>Aktar
            </kaydetbutonu>
          </v-card-actions>
        </v-card>
      </v-dialog>

      <!-- --------------------------------------- muhasebe kod tanımı -->
      <!--
        NOT: Ayni ekran entegrasyon/index.vue icinde de var. Kopya BILEREK
        birakildi - index.vue gecici, kaldirilacak. Ortak bilesene cikarmak
        yalnizca o sayfa yasayacak olsaydi anlamli olurdu.
      -->
      <v-dialog v-model="kodDialog" max-width="1100" persistent scrollable>
        <v-card>
          <v-card-title class="grey lighten-3">
            <span class="headline">Muhasebe Kodları</span>
          </v-card-title>

          <v-card-text>
            <!--
              Satis ve alis kodlari ayni tabloda durur (ayirici IsPurchase),
              iade kodlari ayri tabloda (IntegrationRefundAccountCode); sunucu
              hepsini TEK listede ve her satirda BelgeTuru ile gonderir.
              Ekranda yalnizca secili kume gosterilir; kaydetme TUM listeyi
              gonderdigi icin gorunmeyen kumedeki duzenlemeler korunur.
            -->
            <v-btn-toggle v-model="kodTur" mandatory class="mb-2 mr-3">
              <v-btn flat value="S">Satış</v-btn>
              <v-btn flat value="A">Alış</v-btn>
              <v-btn flat value="SI">Satış İadesi</v-btn>
              <v-btn flat value="AI">Alış İadesi</v-btn>
            </v-btn-toggle>

            <v-btn-toggle v-model="kodHat" mandatory class="mb-2">
              <v-btn flat value="I">İç hat</v-btn>
              <v-btn flat value="D">Dış hat</v-btn>
            </v-btn-toggle>

            <div class="mb-2 grey--text text--darken-1">
              <template v-if="kodAlisMi">
                Alış satırlarında tutar havayoluna olan borçtur;
                <b>Gider hesabı</b> alanına yazılan kod Logo'da MASTER_CODE
                olur. İç hat alışlarında bilet ve vergi satırlarının KDV'si
                ayrı yazılır; bu satırlarda <b>KDV hesabı</b> Logo'da
                GL_CODE2 olur. Dış hat alışında KDV yoktur. Alan vergisi ayrı
                bir kalem tipidir. İstisna kodu alışta kullanılmadığı için
                gösterilmez.
              </template>
              <!--
                Iade kodlarinda KDV durumu kombinasyonu ayirmiyor ve istisna
                yok. Kart kodu istege bagli: bossa yazici gelir/gider
                hesabini MASTER_CODE'a yaziyor.
              -->
              <template v-else-if="kodIadeMi">
                {{ kodTur === "AI" ? "Alış iadesi" : "Satış iadesi" }}
                satırlarında <b>{{ kodHesapEtiketi }}</b> Logo'da GL_CODE1
                olur. <b>Kart kodu (MASTER_CODE)</b> boş bırakılırsa yerine
                {{ kodTur === "AI" ? "gider" : "gelir" }} hesabı yazılır.
                <b>KDV hesabı</b> yalnızca iç hatta %18 / %20 KDV'li
                satırlarda kullanılır. {{ kodHesapEtiketi }} boş bırakılan
                satır silinir.
              </template>
              <template v-else>
                Gelir kodu boş bırakılan satır silinir, yani o kalem tanımsız
                kalır.
              </template>
              <br />
              Kaydet sekiz kümedeki (satış / alış / satış iadesi / alış
              iadesi × iç/dış) değişikliklerin TAMAMINI birlikte gönderir;
              küme değiştirmek yaptığınız düzenlemeyi kaybettirmez.
            </div>

            <v-progress-linear
              v-if="kodYukleniyor"
              indeterminate
            ></v-progress-linear>

            <v-data-table
              :headers="kodBasliklari"
              :items="kodlarFiltreli"
              hide-actions
              class="elevation-1"
            >
              <template v-slot:items="props">
                <!--
                  Hucreler kodBasliklari ile AYNI kosullarda: KDV durumu ve
                  istisna yalnizca satista, kart kodu yalnizca iadede.

                  maxlength kolon boylari: gelir / kart / KDV kodu
                  nvarchar(30), istisna kodu nvarchar(10)
                  (IntegrationAccountCode, IntegrationRefundAccountCode).
                  Sunucu asan degeri HIC yazmadan 400 ile reddediyor (mesaji
                  tabanin Hata'si gosterir); kutu sinirlamasaydi
                  kullanici sekiz kumeyi doldurup kaydederken tek bir uzun
                  kod yuzunden hicbirini kaydedemezdi.
                -->
                <td>{{ KodSatirTipiAdi(props.item.SatirTipi) }}</td>
                <td v-if="kodSatisMi">
                  {{ props.item.KdvliMi ? "KDV li" : "KDV siz" }}
                </td>
                <td>
                  <v-text-field
                    v-model="props.item.GelirKodu"
                    maxlength="30"
                    hide-details
                    class="mt-0 pt-0"
                    single-line
                  ></v-text-field>
                </td>
                <td v-if="kodIadeMi">
                  <v-text-field
                    v-model="props.item.MasterKodu"
                    maxlength="30"
                    hide-details
                    class="mt-0 pt-0"
                    single-line
                  ></v-text-field>
                </td>
                <!-- KDV hesabi alista da var: ic hat alis satirinin KDV'si. -->
                <td>
                  <v-text-field
                    v-model="props.item.KdvKodu"
                    maxlength="30"
                    hide-details
                    class="mt-0 pt-0"
                    single-line
                  ></v-text-field>
                </td>
                <td v-if="kodSatisMi">
                  <v-text-field
                    v-model="props.item.MuafiyetKodu"
                    maxlength="10"
                    hide-details
                    class="mt-0 pt-0"
                    single-line
                  ></v-text-field>
                </td>
              </template>
            </v-data-table>
          </v-card-text>

          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn flat @click="kodDialog = false">Vazgeç</v-btn>
            <kaydetbutonu
              :action="MuhasebeKodlariKaydet"
              :disabled="kodYukleniyor"
            />
          </v-card-actions>
        </v-card>
      </v-dialog>

      <!-- ------------------------------------- kalemin muhasebe kodu -->
      <v-dialog v-model="kalemKodDialog" max-width="620" persistent>
        <v-card v-if="kalemKodSatiri">
          <v-card-title class="grey lighten-3">
            <span class="headline">Kalem Muhasebe Kodu</span>
          </v-card-title>

          <v-card-text>
            <div class="mb-3">
              <div class="grey--text caption">KOMBİNASYON</div>
              <!--
                Belge turu de kombinasyonun parcasi: ayni kalem tipi ve hat
                icin satis, alis, satis iadesi ve alis iadesi kodu ayri.
                Iadede tur adi kalemin KodBelgeTuru'ndan (bkz.
                kalemKodIadeAdi), degilse onceki gibi KodAlisMi'den. Alista
                ve iadede KDV durumu kombinasyonu ayirmiyor (sunucu KodKdvli'yi
                hep false gonderiyor), bu yuzden yalnizca satista yaziliyor.
              -->
              <!--
                Kalem tipi satirin KENDI tipi degil, kodun ALINDIGI
                kombinasyonun tipi (bkz. KodSatirTipi): dis hat alisinda alan
                vergisi kodunu Vergi satirindan aliyor. Satirin adi yazilsaydi
                kullanici "Alan vergisi"ni duzelttigini sanir, kayit ise
                Vergi kombinasyonuna giderdi.
              -->
              <div class="title">
                {{ kalemKodIadeAdi ? kalemKodIadeAdi : kalemKodSatiri.KodAlisMi ? "Alış" : "Satış" }} ·
                {{ kalemKodTipAdi }} ·
                {{ HatAdi(kalemKodSatiri.UcusTipi, true) }}
                <template v-if="kalemKodBelgeTuru === 0">
                  · {{ kalemKodSatiri.KodKdvli ? "KDV li" : "KDV siz" }}
                </template>
              </div>
              <div v-if="kalemKodTipiFarkli" class="mt-1 grey--text text--darken-2">
                Bu satır bir <b>{{ KodSatirTipiAdi(kalemKodSatiri.Tip) }}</b>
                kalemi, ancak muhasebe kodunu
                <b>{{ kalemKodTipAdi }}</b> kombinasyonundan alıyor. Buraya
                yazdığınız kod o kombinasyona kaydedilir.
              </div>
            </div>

            <!--
              En kritik bilgi: kod kaleme degil kombinasyona ait. Yazilmazsa
              kullanici tek faturayi duzelttigini sanip digerlerinin de
              degistigini sonradan fark eder.
            -->
            <v-alert :value="true" type="info" outline class="mb-3">
              Kod bu <b>kaleme</b> değil, yukarıdaki <b>kombinasyona</b>
              aittir. Kaydettiğinizde aynı kombinasyondaki <b>bütün</b>
              satırlar bu kodu kullanır — {{ belgeSozcukleri.icindekiler }}.
            </v-alert>

            <!--
              Alanlar satira YAZILAN koddan degil kombinasyonun KAYITLI
              kodundan dolar (bkz. KalemKoduAc). Kombinasyonun kendi kaydi
              yoksa sunucu cozucunun dustugu kaydi gonderiyor; kullanici
              gordugu degerin nereden geldigini bilmeli.
            -->
            <div
              v-if="kalemKodSatiri.KodKaydiVar === false"
              class="mb-3 grey--text text--darken-2"
            >
              <template v-if="kalemKodKayitliDegerVar">
                Bu kombinasyonun kendi kaydı yok; alanlarda aktarımda
                kullanılan yedek kayıt görünüyor. Kaydederseniz bu
                kombinasyon için ayrı kayıt açılır.
              </template>
              <template v-else>
                Bu kombinasyon için kayıtlı kod yok.
              </template>
            </div>

            <!--
              GL_CODE1. Alis iadesi kalemi de KodAlisMi tasiyor (Tur 1), yani
              etiket iadede de dogru: satis iadesi gelir, alis iadesi gider.

              maxlength'ler kod ekranindaki izgarayla ayni kolon boylari
              (kodlar 30, istisna kodu 10, istisna nedeni 200): sunucu asan
              degeri yazmadan 400 ile reddediyor, kutu yazarken sinirlar.
            -->
            <v-text-field
              :label="kalemKodSatiri.KodAlisMi ? 'Gider hesabı' : 'Gelir hesabı'"
              v-model="kalemKod.GelirKodu"
              maxlength="30"
              hint="Boş bırakılırsa tanım silinir ve kalem kodsuz kalır."
              persistent-hint
            ></v-text-field>

            <!--
              Yalnizca iade kodunda (IntegrationRefundAccountCode.MasterCode).
              Istege bagli: bos birakilirsa yazici MASTER_CODE'a gelir/gider
              hesabini yaziyor.
            -->
            <v-text-field
              v-if="kalemKodIadeMi"
              label="Kart kodu (MASTER_CODE)"
              v-model="kalemKod.MasterKodu"
              :hint="kalemKodMasterIpucu"
              persistent-hint
              maxlength="30"
            ></v-text-field>

            <!--
              Alista ve iadede KDV hesabi her zaman gosterilir: ic hat alis
              satirinin ve ic hat %18 / %20 iade satirinin KDV'si bu hesaba
              (GL_CODE2) yazilir. Satista yalnizca KDV'li kombinasyonda
              anlamli.
            -->
            <v-text-field
              v-if="kalemKodBelgeTuru !== 0 || kalemKodSatiri.KodKdvli"
              label="KDV hesabı"
              v-model="kalemKod.KdvKodu"
              maxlength="30"
              :hint="kalemKodKdvIpucu"
              :persistent-hint="kalemKodBelgeTuru !== 0"
            ></v-text-field>

            <!--
              Istisna yalnizca satista kullaniliyor (alista ve iadede yok).
              Gizli olsa da kayitli deger kayitta AYNEN geri gider (bkz.
              KalemKoduKaydet): sunucu satiri silip yeniden yaziyor,
              gonderilmeyen alan silinirdi.
            -->
            <v-text-field
              v-if="kalemKodBelgeTuru === 0"
              label="İstisna kodu"
              v-model="kalemKod.MuafiyetKodu"
              maxlength="10"
            ></v-text-field>

            <v-text-field
              v-if="kalemKodBelgeTuru === 0"
              label="İstisna nedeni"
              v-model="kalemKod.MuafiyetNedeni"
              maxlength="200"
            ></v-text-field>
          </v-card-text>

          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn flat @click="kalemKodDialog = false">Vazgeç</v-btn>
            <kaydetbutonu :action="KalemKoduKaydet" />
          </v-card-actions>
        </v-card>
      </v-dialog>

      <!-- ------------------- havayolu kartının tedarikçi hesap kodları -->
      <!--
        Belgenin KALEM penceresinden aciliyor ve yalnizca BELGENIN HATTINA
        ait iki alani gosteriyor. Kullanici karari (2026-09-22): "ekranda
        kalemler sayesinde zaten ic/dis oldugunu anlariz, kalemin icinden
        tiklayarak SADECE ILGILI ALANI degistirsin". Dort alani birden
        gostermek (ve kaydetmek) kullanicinin bakmadigi oteki hattin iki
        kodunu sessizce ezerdi; sunucu ucu de bu yuzden tek hat aliyor.
      -->
      <v-dialog v-model="hyolDialog" max-width="620" persistent>
        <v-card>
          <v-card-title class="grey lighten-3">
            <span class="headline">{{ hyolBasligi }}</span>
          </v-card-title>

          <v-card-text>
            <v-progress-linear
              v-if="hyolYukleniyor"
              indeterminate
            ></v-progress-linear>

            <template v-else-if="hyolKart">
              <div class="mb-3">
                <div class="grey--text caption">HAVAYOLU KARTI</div>
                <div class="title">
                  {{ hyolKart.Kod }} · {{ hyolKart.Ad || "—" }}
                </div>
                <div class="grey--text text--darken-1">
                  Form no {{ hyolKart.FormNo || "—" }}
                </div>
              </div>

              <!--
                BSP bileti (B_Ic_Dis = 'B') DIS HAT alanlarini okur
                (LogoAlisFatBiletEntUnit.pas:2112-2118). Yazilmasaydi
                kullanici "ic hat" sanip yanlis kolonu doldururdu; ekranda
                hattin nereden geldigi baska turlu gorunmuyor.
              -->
              <div v-if="hyolBspMi" class="mb-3 grey--text text--darken-2">
                Bu belge <b>BSP</b> bileti; Logo'ya yazılan tedarikçi
                <b>dış hat</b> alanlarından okunur.
              </div>

              <!--
                KART KODU BILETIN KODU OLMAYABILIR: BSP bilette "BS",
                acente bilette acente kodu (AlisFaturaDonusturucu.
                HavayoluAnahtari). Ustteki baslik zaten kart kodunu
                yaziyor, ama kullanici belgede "QR" gorup burada "BS"
                bulunca yanlis pencereyi actigini saniyordu; fark
                ACIKCA soyleniyor.
              -->
              <div
                v-if="hyolKartFarkli"
                class="mb-3 orange--text text--darken-3"
              >
                Biletin havayolu <b>{{ hyolBiletKodu }}</b>, tedarikçi
                kodları ise <b>{{ hyolKod }}</b> kartından okunuyor;
                düzenlenen kart <b>{{ hyolKod }}</b>.
              </div>

              <!--
                Havayolu tablosunda SirketKodu KOLONU YOK: kart tenant
                genelinde ortak. Metin sunucudan geliyor (yanitin Uyari
                alani); sunucu eski ise yerel karsiligi gosterilir.
              -->
              <v-alert :value="true" type="info" outline class="mb-3">
                {{ hyolUyariMetni }}
              </v-alert>

              <!--
                maxlength 25: Havayolu.reserved5-8 varchar(25). Sunucu asan
                degeri HIC yazmadan 400 ile reddediyor; kutu sinirlamasaydi
                kullanici kaydete basana kadar bunu ogrenemezdi.

                Etiketler HATTA gore (hyolTedarikciEtiketi /
                hyolMuhasebeEtiketi): ic hatta Reserved5-6, dis hatta ve
                BSP'de Reserved7-8. Oteki hattin alanlari CIZILMEZ.
              -->
              <v-text-field
                :label="hyolTedarikciEtiketi"
                v-model="hyolForm.TedarikciKodu"
                maxlength="25"
                hint="Boş bırakılırsa kayıtlı kod silinir ve belge ARP_CODE'suz çıkar."
                persistent-hint
              ></v-text-field>

              <v-text-field
                :label="hyolMuhasebeEtiketi"
                v-model="hyolForm.MuhasebeKodu"
                maxlength="25"
                hint="Boş bırakılırsa kayıtlı kod silinir ve belge GL_CODE'suz çıkar."
                persistent-hint
              ></v-text-field>
            </template>

            <!--
              Sunucu bulunamayan kodu listeye HIC koymuyor (uc sozlesmesi);
              bos liste "kart yok" demek. Bos bir form acilsaydi kullanici
              kod girip kaydete basar ve 404 alirdi.
            -->
            <div v-else class="red--text">
              '{{ hyolKod }}' kodlu havayolu kartı bulunamadı. Kart
              tanımlanmadan bu belgenin tedarikçi kodu yazılamaz.
            </div>
          </v-card-text>

          <v-card-actions>
            <v-spacer></v-spacer>
            <!--
              Kaydetmeden kapatmak yazilanlari kaybettirir ve ONAY SORMAZ:
              yikici bir islem degil, kart degismeden kaliyor.
            -->
            <v-btn flat @click="hyolDialog = false">Vazgeç</v-btn>
            <kaydetbutonu
              :action="HavayoluKoduKaydet"
              :disabled="hyolYukleniyor || !hyolKart"
            />
          </v-card-actions>
        </v-card>
      </v-dialog>

      <!-- ------------------------------------------- satır ayrıntısı -->
      <v-dialog v-model="satirDialog" max-width="1150px" scrollable>
        <v-card v-if="satirFatura">
          <v-card-title class="grey lighten-3 py-3">
            <div v-if="maliyetMi" style="width: 100%">
              <div class="headline">{{ satirFatura.BelgeNo }}</div>
              <div class="grey--text text--darken-2 mt-1">
                Satış {{ TarihBicimle(satirFatura.SatisTarihi) }} ·
                {{ satirFatura.HavayoluKodu }} / {{ satirFatura.BiletNo }} ·
                {{ HatAdi(satirFatura.IcDis, true) }} ·
                {{ satirFatura.BiletSayisi }} bilet
                <span v-if="satirFatura.BelgeDoviz">
                  · {{ satirFatura.BelgeDoviz }} kur
                  {{ Para(satirFatura.BelgeKur) }}
                </span>
              </div>
              <!--
                Fatura tarihli maliyette belgeyi listeye SOKAN tarih budur
                (satis tarihi ustte duruyor, ikisi cogu bilette farkli gun).
                Bos gelemez - sunucu o tipte faturasiz bileti hic
                listelemiyor; yine de "—" ile korunuyor ki eksik alan bos bir
                satir gibi gorunmesin.
              -->
              <div v-if="faturaBilgisiVar" class="grey--text text--darken-2">
                Fatura {{ satirFatura.TamFaturaNo || "—" }} ·
                {{ TarihBicimle(satirFatura.FaturaTarihi) }}
              </div>
              <!--
                Tedarikci carisi belgenin kendi alani DEGIL, HAVAYOLU
                KARTININ alani: ic hat Reserved5 (ARP_CODE) / Reserved6
                (GL_CODE), dis hat ve BSP Reserved7 / Reserved8
                (LogoAlisFatBiletEntUnit.pas:2014-2018 ic, :2112-2118 dis;
                geri dusme YOK). Kart kodsuzsa belge bos ARP_CODE / GL_CODE
                ile cikar ve Logo onu reddeder - yukaridaki belge uyarisi da
                bunu soyluyor.

                BURADA DUZENLENMEZ, yalnizca gosterilir: duzeltme LISTEDEKI
                tedarikci hucresinden aciliyor (kullanici karari,
                2026-09-22). Kalem penceresindeki kalem simgesi kaldirildi;
                kodu eksik belgeyi duzeltmek icin once kalemleri acmak
                gerekiyordu, oysa eksik kod listede zaten gorunuyor.
              -->
              <div class="grey--text text--darken-2">
                Tedarikçi {{ satirFatura.TedarikciKod || "—" }}
                (muhasebe {{ satirFatura.TedarikciMuhasebeKod || "—" }})
                · Müşteri {{ satirFatura.MusteriKodu }} ·
                {{ satirFatura.YolcuAdi }} / {{ satirFatura.Parkur }}
              </div>
              <!--
                Satis faturasi bos olabilir: bilet henuz faturalanmamis.
                Maliyet belgesi bundan bagimsiz uretiliyor; bos oldugu acikca
                yazilir ki eksik veri sanilmasin.
              -->
              <div class="grey--text text--darken-2">
                <template v-if="satirFatura.SatisFaturaNo">
                  Satış faturası {{ satirFatura.SatisFaturaNo }}
                </template>
                <template v-else>Satış faturası henüz kesilmemiş</template>
              </div>
            </div>
            <!--
              Iade dekontu. Karsi taraf kodu (TedarikciKod = Logo ARP_CODE)
              satis iadesinde carinin, alis iadesinde havayolunun Logo kodu;
              etiketi ona gore (iadeKarsiTarafEtiketi).
            -->
            <div v-else-if="iadeMi" style="width: 100%">
              <div class="headline">Dekont {{ satirFatura.DekontNo }}</div>
              <div class="grey--text text--darken-2 mt-1">
                İade {{ TarihBicimle(satirFatura.IadeTarihi) }} ·
                Belge {{ satirFatura.BelgeNo }} ·
                {{ satirFatura.HavayoluKodu }} / {{ satirFatura.BiletNo }} /
                form {{ satirFatura.FormNo }} ·
                {{ HatAdi(satirFatura.IcDis, true) }} ·
                {{ satirFatura.BiletSayisi }} bilet
              </div>
              <div class="grey--text text--darken-2">
                Cari {{ satirFatura.CariKod || "—" }} {{ satirFatura.Unvan }} ·
                Müşteri {{ satirFatura.MusteriKodu }} ·
                {{ satirFatura.YolcuAdi }} / {{ satirFatura.Parkur }}
              </div>
              <!--
                Karsi taraf kodu BURADA DUZENLENMEZ, yalnizca gosterilir:
                duzeltme LISTEDEKI karsi taraf hucresinden aciliyor
                (kullanici karari, 2026-09-22) ve yalnizca alis iadesinde,
                cunku orada deger havayolunun kartindan (Reserved5/7)
                geliyor. Satis iadesinde ayni alan MUSTERI carisinin
                Reserved2'sidir (DisMuhasebeAktarimi.Iade
                IadeBelgeUyarilari) - havayolu karti penceresi o belgede
                yanlis karti duzelttirirdi.
              -->
              <div class="grey--text text--darken-2">
                {{ iadeKarsiTarafEtiketi }} {{ satirFatura.TedarikciKod || "—" }}
                (muhasebe {{ satirFatura.TedarikciMuhasebeKod || "—" }})
                · KDV %{{ satirFatura.KdvOrani || 0 }}
              </div>
              <!--
                Satis faturasi biletin satirindan; bilet satiri faturasizsa
                bos gelir. Bos oldugu acikca yazilir, eksik veri sanilmasin.
              -->
              <div class="grey--text text--darken-2">
                <template v-if="satirFatura.SatisFaturaNo">
                  Satış faturası {{ satirFatura.SatisFaturaNo }}
                </template>
                <template v-else>Biletin satış faturası yok</template>
              </div>
            </div>
            <div v-else style="width: 100%">
              <div class="headline">{{ satirFatura.TamFaturaNo }}</div>
              <div class="grey--text text--darken-2 mt-1">
                {{ TarihBicimle(satirFatura.FaturaTarihi) }} ·
                {{ satirFatura.CariKod }} {{ satirFatura.Unvan }} ·
                {{ HatAdi(satirFatura.IcDis, true) }}
                <span v-if="satirFatura.BelgeDoviz">
                  · {{ satirFatura.BelgeDoviz }} kur
                  {{ Para(satirFatura.BelgeKur) }}
                </span>
              </div>
            </div>
            <v-spacer></v-spacer>
            <v-chip
              small
              :color="satirFatura.EntegreEdildi ? 'green lighten-4' : 'grey lighten-2'"
            >
              {{ satirFatura.EntegreEdildi ? "Aktarıldı" : "Aktarılmadı" }}
            </v-chip>
          </v-card-title>

          <v-card-text>
            <!--
              Toplamlar satirBelgesi'nden: fatura ozeti ile maliyet / iade
              ozeti ayni toplamlari farkli adlarla tasiyor, eslestirme tek
              yerde.
            -->
            <v-layout row wrap class="mb-3">
              <v-flex xs12 sm4 class="pa-2">
                <div class="grey--text caption">MATRAH</div>
                <div class="title">{{ Para(satirBelgesi.ToplamMatrah) }}</div>
              </v-flex>
              <v-flex xs12 sm4 class="pa-2">
                <div class="grey--text caption">
                  KDV
                  <span v-if="!faturaMi && satirFatura.KdvOrani">
                    (%{{ satirFatura.KdvOrani }})
                  </span>
                </div>
                <div class="title">{{ Para(satirBelgesi.ToplamKdv) }}</div>
              </v-flex>
              <v-flex xs12 sm4 class="pa-2">
                <div class="grey--text caption">
                  {{ faturaMi ? "GENEL TOPLAM" : "TOPLAM" }}
                </div>
                <div class="title font-weight-bold">
                  {{ Para(satirBelgesi.ToplamNet) }}
                </div>
              </v-flex>
            </v-layout>

            <!-- Belge uyarilari maliyet ve iade ozetinde; faturada yok. -->
            <v-alert
              v-if="!faturaMi"
              :value="(satirFatura.Uyarilar || []).length > 0"
              type="warning"
              outline
              class="mb-3"
            >
              <div v-for="(u, i) in satirFatura.Uyarilar" :key="i">{{ u }}</div>
              <!--
                Uyari ile duzeltme arasindaki bag. Kodsuz belge uyarisi
                (ARP_CODE / GL_CODE bos) burada okunuyor, duzeltme ise
                LISTEDEKI tedarikci hucresinde (kullanici karari,
                2026-09-22); bir satirlik yonlendirme olmasaydi kullanici
                uyariyi okuyup ne yapacagini bilemezdi. Metin duzeltmenin
                GERCEKTE oldugu yeri gostermeli - eski metin kalem
                penceresindeki simgeyi tarif ediyordu, o simge artik yok.
                Yalnizca carisi havayolu kartindan gelen tiplerde: satis
                iadesinde ayni uyari MUSTERI carisini isaret ediyor.
              -->
              <div v-if="havayoluKartiDuzenlenir" class="mt-2">
                Tedarikçi kodları <b>havayolu kartından</b> gelir; listede
                <b>Tedarikçi</b> sütunundaki değere tıklayarak
                düzeltebilirsiniz.
              </div>
            </v-alert>

            <!--
              Tipe gore dagilim. Serit genislikleri yuzdedir; hangi kalemin
              faturayi olusturdugu rakam okumadan gorulsun diye.
            -->
            <div class="caption grey--text mb-1">TİPE GÖRE DAĞILIM</div>
            <div class="satir-serit mb-2">
              <div
                v-for="d in satirDagilimi"
                :key="d.tip"
                class="satir-serit-parca"
                :class="d.renk"
                :style="{ width: d.yuzde + '%' }"
                :title="d.ad + ': ' + Para(d.tutar)"
              ></div>
            </div>
            <div class="mb-4">
              <v-chip
                v-for="d in satirDagilimi"
                :key="'c' + d.tip"
                small
                :class="d.renk + ' white--text'"
              >
                {{ d.ad }} · {{ Para(d.tutar) }} ({{ d.adet }})
              </v-chip>
            </div>

            <div class="caption grey--text mb-1">KALEMLER</div>

            <v-progress-linear
              v-if="kalemYukleniyor"
              indeterminate
            ></v-progress-linear>

            <!--
              alis: maliyet ve alis iadesi. istisnasiz: istisna kolonu
              satis iadesinde de yok (istisna yalnizca satis faturasinda).
            -->
            <kalemtablosu
              v-else-if="satirFatura.Satirlar"
              :fatura="satirBelgesi"
              :alis="kalemAlis"
              :istisnasiz="kalemIstisnasiz"
              @kod-duzenle="KalemKoduAc"
            ></kalemtablosu>

            <span v-else class="grey--text">Kalem bulunamadı.</span>
          </v-card-text>

          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn flat @click="satirDialog = false">Kapat</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </v-card>
  </sayfataban>
</template>

<script>
/**
 * Dis muhasebe aktarimi: faturalari (satis), bilet maliyet belgelerini
 * (alis) ya da iade dekontlarini (satis iadesi / alis iadesi) listeler,
 * kullanici istediklerini secer, yalnizca secilenler aktarilir.
 *
 * Bu sayfa HEDEFTEN BAGIMSIZDIR. Cagirdigi uclar (DisMuhasebeAktarim/...) Logo,
 * Luka, Netsis ve Eta icin aynidir; hedefe ozgu olan tek sey sunucudaki
 * yazicidir. Bu yuzden ekranda "Logo" yazmaz.
 *
 * Bugunku entegrasyon sayfasindan (entegrasyon/index.vue) farki: orasi tarih
 * araligini verip TUM araligi tek dosyaya yaziyor; burada kullanici once
 * gorur, sonra secer.
 */
import sayfataban from "@/components/app/customcomp/sayfataban.vue";
import helpers from "@/components/app/customcomp/helpers.js";
import tool from "@/components/app/coper/tools.js";
import onaydialog from "@/components/app/customcomp/onaydialog.vue";
import kaydetbutonu from "@/components/app/customcomp/kaydetbutonu.vue";
import kalemtablosu from "@/components/app/entegrasyon/kalemtablosu.vue";
import kalemrenkleri from "@/components/app/entegrasyon/kalemrenkleri.js";
import muhasebekodturu from "@/components/app/entegrasyon/muhasebekodturu.js";

/**
 * Islem tipine gore sunucu uclari ve indirilen dosyanin adi.
 *
 * TEK yer: Listele, SatirlariAc/KalemleriCek, Aktar ve GeriAl ucu buradan
 * okur. Uc adi metotlara dagilsaydi yeni bir tip eklenirken biri eski uca
 * gitmeye devam ederdi - ornegin maliyet secimi fatura damgasini kaldirirdi.
 *
 * Satis iadesi (I) ile alis iadesi (AI) AYNI uclara gider; ikisini sunucu
 * istekteki Tur alanindan ayiriyor (bkz. TIP_AYARLARI istekEki). Dosya adi
 * farkli: kullanici iki ZIP'i karistirmasin.
 *
 * Iki maliyet tipi (M ve MF) de AYNI Maliyet uclarina gider; ikisini sunucu
 * istekteki TarihOlcutu alanindan ayiriyor (M gondermez = 0, MF 1). Delphi
 * tarafinda bunlar iki ayri dugme: "Maliyet Entegre (Satis Tarihine Gore)"
 * (LogoAlisFatBiletEntUnit.pas) ve "(Fatura Tarihine Gore)"
 * (LogoAlisFatEntUnit.pas). Dosya adi yine farkli.
 */
const UCLAR = {
  F: {
    liste: "DisMuhasebeAktarim/FaturaListesi",
    kalem: "DisMuhasebeAktarim/FaturaKalemleri",
    aktar: "DisMuhasebeAktarim/FaturaAktar",
    geriAl: "DisMuhasebeAktarim/EntegreKaldir",
    dosya: "DisMuhasebeAktarim.zip",
  },
  M: {
    liste: "DisMuhasebeAktarim/MaliyetListesi",
    kalem: "DisMuhasebeAktarim/MaliyetKalemleri",
    aktar: "DisMuhasebeAktarim/MaliyetAktar",
    geriAl: "DisMuhasebeAktarim/MaliyetEntegreKaldir",
    dosya: "DisMuhasebeMaliyet.zip",
  },
  MF: {
    liste: "DisMuhasebeAktarim/MaliyetListesi",
    kalem: "DisMuhasebeAktarim/MaliyetKalemleri",
    aktar: "DisMuhasebeAktarim/MaliyetAktar",
    geriAl: "DisMuhasebeAktarim/MaliyetEntegreKaldir",
    dosya: "DisMuhasebeMaliyetFatura.zip",
  },
  I: {
    liste: "DisMuhasebeAktarim/IadeListesi",
    kalem: "DisMuhasebeAktarim/IadeKalemleri",
    aktar: "DisMuhasebeAktarim/IadeAktar",
    geriAl: "DisMuhasebeAktarim/IadeEntegreKaldir",
    dosya: "DisMuhasebeIade.zip",
  },
  AI: {
    liste: "DisMuhasebeAktarim/IadeListesi",
    kalem: "DisMuhasebeAktarim/IadeKalemleri",
    aktar: "DisMuhasebeAktarim/IadeAktar",
    geriAl: "DisMuhasebeAktarim/IadeEntegreKaldir",
    dosya: "DisMuhasebeAlisIade.zip",
  },
};

/** Atlanan bilet uyarisinda adiyla yazilan en fazla bilet sayisi. */
const ATLANAN_ORNEK_SAYISI = 10;

/**
 * Nedene gore gruplanmis uyarida HER nedenin altinda yazilan en fazla bilet
 * sayisi. Tek listedekinden az: birden fazla neden alt alta yaziliyor.
 */
const ATLANAN_NEDEN_ORNEK_SAYISI = 5;

/** Sunucu nedeni bos biraktiginda ya da hic bildirmediginde yazilan ad. */
const ATLANAN_NEDEN_YOK = "nedeni bildirilmedi";

/**
 * Atlanan bilet neden KODLARININ sabit adlari, tipe gore. Maliyette sunucuda
 * AlisAtlanmaNedeni; iadede IadeListesi sozlesmesinin NedenKodu'su. Ayni kod
 * iki tipte farkli neden demek (maliyette 1 "durumu S/Ia degil", iadede 1
 * "dekont numarasi yok"); tabloyu tip secer (TIP_AYARLARI nedenAdlari).
 *
 * Gruplama sunucunun Neden METNIYLE yapilmiyor: metin satirin kendi degerini
 * tasiyor ("cari hesap karti yok (musteri '120.01.01.044')"), metinle
 * gruplanan tek bir neden musteri kodu basina ayri satira bolunuyordu.
 * 0 ve eksik kod ATLANAN_NEDEN_YOK'a duser.
 */
const MALIYET_NEDEN_ADLARI = {
  1: "durumu S/Ia değil",
  2: "acente bileti",
  3: "cari hesap kartı yok",
  // Yalnizca fatura tarihli maliyette (MF) olusur: o sorgu faturalanmis
  // bileti istiyor (LogoAlisFatEntUnit.pas:7200-7204 FaturaNo bos ya da 0
  // olan satiri atliyor). Satis tarihli maliyet (M) bu kodu hic gondermez.
  4: "fatura numarası yok",
};

const IADE_NEDEN_ADLARI = {
  1: "dekont numarası yok",
  2: "cari hesap kartı yok",
  3: "bilet satırı yok",
  4: "havayolu kartı yok",
};

/**
 * Ekrandaki "fatura" sozcugunun belge cinsine gore karsiliklari.
 *
 * Turkcede ek unlu uyumuyla degistigi icin (faturanin / belgenin /
 * dekontun) sozcuk koke ek yapistirilarak uretilmiyor, hazir bicimler
 * tutuluyor.
 */
const SOZCUKLER = {
  fatura: {
    ad: "fatura",
    cogul: "faturalar",
    Cogul: "Faturalar",
    tamlayan: "faturanın",
    belirtme: "faturaları",
    icindekiler: "bu faturadakiler de, diğer faturalardakiler de",
  },
  belge: {
    ad: "belge",
    cogul: "belgeler",
    Cogul: "Belgeler",
    tamlayan: "belgenin",
    belirtme: "belgeleri",
    icindekiler: "bu belgedekiler de, diğer belgelerdekiler de",
  },
  dekont: {
    ad: "dekont",
    cogul: "dekontlar",
    Cogul: "Dekontlar",
    tamlayan: "dekontun",
    belirtme: "dekontları",
    icindekiler: "bu dekonttakiler de, diğer dekontlardakiler de",
  },
};

/**
 * Islem tiplerinin TUM farklari. Sayfanin metotlari ve computed'lari tipe
 * gore dallanmaz, buradan okur; yeni bir tip yeni bir girdi demek (ve
 * UCLAR'da uclari). Sablondaki satir / pencere bicimi ise tipin GRUBUNA
 * gore (faturaMi / maliyetMi / iadeMi): hucreler ve baglantilar veriyle
 * ifade edilemeyecek kadar farkli.
 *
 * Alanlar:
 *   grup             "fatura" | "maliyet" | "iade" (sablon dallari)
 *   kodTur           Muhasebe Kodlari ekraninin acilistaki kumesi
 *   basliklar        tablonun baslik dizisinin data() adi
 *   tabloAnahtari    satirin tekil alani (item-key, secim tasima)
 *   sozcukler        SOZCUKLER girdisi
 *   tarihEtiketleri  [baslangic, bitis]; null ise i18n'deki genel etiket
 *   aramaEtiketi     arama kutusunun etiketi
 *   aramaAlanlari    listede aranan alanlar (etiketle ayni liste)
 *   istekEki         liste / kalem / aktar / geri al isteklerinin HEPSINE
 *                    eklenen alanlar (iadede Tur, fatura tarihli maliyette
 *                    TarihOlcutu); yoksa null
 *   zarf             liste yaniti zarfsa alan adlari { belgeler,
 *                    atlananSayisi, atlananNumaralari }; dizi ise null
 *   bosListeMesaji   liste bos geldiginde
 *   secimAlanlari    Secimler'deki kimlik alanlari (sirasiyla)
 *   kalemSuzgecleri  kalem istegine eklenen LISTE suzgecleri
 *   kalemSatirAlanlari
 *                    kalem istegine SATIRIN kendisinden kopyalanan ek
 *                    alanlar (MF'de FaturaTarihi); suzgec degil, belgeye
 *                    ait deger oldugu icin anlik goruntuden alinmaz
 *   geriAlTumSuzgec  geri al listenin tum suzgeclerini mi (true) yoksa
 *                    yalnizca tarihleri mi gonderir
 *   tlAktar          aktarimda TlAktar secenegi var mi
 *   faturaBilgisi    listede ve satir penceresinde biletin FATURA no /
 *                    fatura tarihi gosterilir mi (belgeyi fatura tarihine
 *                    gore ureten tipte; bkz. MF)
 *   biletNoKolonu    listede ayri bir Bilet No kolonu cizilir mi. Satis
 *                    tarihli maliyette (M) FALSE: belge no zaten FormNo +
 *                    bilet numarasi, iki kolon ayni seyi gosteriyordu.
 *                    faturaBilgisi ile ayni degerlere sahip olsa da AYRI:
 *                    biri "fatura no / tarihi da goster", oteki "bilet no
 *                    kolonu ciz" demek; tek bayraga baglanirsa ileride biri
 *                    degistiginde oteki sessizce bozulur
 *   alis, istisnasiz kalem tablosunun bayraklari
 *   havayoluKarti    belgenin tedarikci carisi HAVAYOLU KARTINDAN mi geliyor
 *                    (Reserved5/6 ic hat, Reserved7/8 dis hat ve BSP).
 *                    Yalnizca o tiplerde kalem penceresinden kart kodu
 *                    duzenlenebilir. "alis" bayragiyla ayni degerlere sahip
 *                    olsa da AYRI: alis, kalem tablosunun kolonlarini
 *                    belirliyor - ikisini tek bayrakta birlestirmek, ileride
 *                    biri degistiginde otekini sessizce bozardi.
 *   damga            X-Damgalanan-Bilet sayisinin mesajdaki sozcugu; null
 *                    ise mesaj onceki (fatura) bicimde, uyari sayisi yok
 *   etkilenen        geri al yanitindaki sayinin alani ve sozcugu
 *   nedenAdlari      atlanan kayit neden adlari
 *   kodlaTazelenir   kod kaydindan sonra LISTE de tazelenir mi (belge
 *                    uyarilari listeyle geliyor)
 */
const TIP_AYARLARI = {
  F: {
    grup: "fatura",
    kodTur: "S",
    basliklar: "faturaBasliklari",
    tabloAnahtari: "TamFaturaNo",
    sozcukler: SOZCUKLER.fatura,
    tarihEtiketleri: null,
    aramaEtiketi: "Listede ara (fatura no, cari kod, ünvan)",
    aramaAlanlari: ["TamFaturaNo", "FaturaSeri", "FaturaNo", "CariKod", "Unvan"],
    istekEki: null,
    zarf: null,
    bosListeMesaji: "Seçilen aralıkta fatura bulunamadı.",
    secimAlanlari: ["FaturaSeri", "FaturaNo", "FaturaTarihi"],
    kalemSuzgecleri: [],
    kalemSatirAlanlari: [],
    geriAlTumSuzgec: false,
    tlAktar: false,
    faturaBilgisi: false,
    alis: false,
    istisnasiz: false,
    // Satis faturasinin carisi MUSTERI kartidir, havayolu karti degil.
    havayoluKarti: false,
    damga: null,
    etkilenen: null,
    nedenAdlari: MALIYET_NEDEN_ADLARI,
    kodlaTazelenir: false,
  },
  M: {
    grup: "maliyet",
    kodTur: "A",
    basliklar: "maliyetBasliklari",
    tabloAnahtari: "Anahtar",
    sozcukler: SOZCUKLER.belge,
    tarihEtiketleri: ["Satış Tarihi (başlangıç)", "Satış Tarihi (bitiş)"],
    aramaEtiketi:
      "Listede ara (belge no, bilet no, havayolu, tedarikçi, müşteri, yolcu)",
    aramaAlanlari: [
      "BelgeNo",
      "BiletNo",
      "HavayoluKodu",
      "TedarikciKod",
      "MusteriKodu",
      "YolcuAdi",
    ],
    istekEki: null,
    zarf: {
      belgeler: "Belgeler",
      atlananSayisi: "AtlananBiletSayisi",
      atlananNumaralari: "AtlananBiletler",
    },
    bosListeMesaji: "Seçilen aralıkta maliyet belgesi bulunamadı.",
    secimAlanlari: ["HavayoluKodu", "BiletNo", "SatisTarihi", "Anahtar"],
    kalemSuzgecleri: ["Hat", "BspHaric"],
    kalemSatirAlanlari: [],
    geriAlTumSuzgec: true,
    tlAktar: true,
    faturaBilgisi: false,
    biletNoKolonu: false,
    alis: true,
    istisnasiz: false,
    havayoluKarti: true,
    damga: "bilet",
    etkilenen: { alan: "EtkilenenBilet", sozcuk: "bilet" },
    nedenAdlari: MALIYET_NEDEN_ADLARI,
    kodlaTazelenir: true,
  },
  /**
   * Maliyet, biletin FATURA tarihine gore (Delphi LogoAlisFatEntUnit.pas).
   * M ile ayni belge, ayni uclar, ayni secim alanlari; fark istekteki
   * TarihOlcutu: sunucu tarih araligini B_Satis_Tar yerine B_Fatura_Tar'a
   * uyguluyor, faturasiz bileti hic listelemiyor (neden kodu 4) ve belgeleri
   * fatura numarasina gore siraliyor.
   *
   * Damga M ile ORTAK (Bilet.alisentegre): bir bilet iki tipten biriyle
   * aktarildiginda otekinde de "Aktarıldı" gorunur. Bilerek boyle - ayni
   * bilet icin iki alis belgesi uretilmemeli; varsayilan "Aktarılmayanlar"
   * suzgeci bunu gorunur kiliyor.
   *
   * TL aktar YOK: Delphi'nin bu ekraninda o kutu hic yok, sunucu da bu
   * tipte TlAktar'i yok sayiyor (belge her zaman CURRSEL_TOTALS 1 yaziliyor).
   * Gorunseydi kullanici etkisi olmayan bir secenek isaretlerdi.
   */
  MF: {
    grup: "maliyet",
    kodTur: "A",
    basliklar: "maliyetFaturaBasliklari",
    tabloAnahtari: "Anahtar",
    sozcukler: SOZCUKLER.belge,
    tarihEtiketleri: ["Fatura tarihi (başlangıç)", "Fatura tarihi (bitiş)"],
    aramaEtiketi:
      "Listede ara (fatura no, belge no, bilet no, havayolu, tedarikçi, müşteri, yolcu)",
    aramaAlanlari: [
      "TamFaturaNo",
      "BelgeNo",
      "BiletNo",
      "HavayoluKodu",
      "TedarikciKod",
      "MusteriKodu",
      "YolcuAdi",
    ],
    istekEki: { TarihOlcutu: 1 },
    zarf: {
      belgeler: "Belgeler",
      atlananSayisi: "AtlananBiletSayisi",
      atlananNumaralari: "AtlananBiletler",
    },
    bosListeMesaji: "Seçilen aralıkta fatura tarihli maliyet belgesi bulunamadı.",
    // M ile AYNI: belgenin kimligi yine biletin kendisi (havayolu + bilet no
    // + SATIS tarihi + Anahtar). Fatura tarihi belgeyi tekillestirmiyor, bir
    // faturada cok bilet var.
    secimAlanlari: ["HavayoluKodu", "BiletNo", "SatisTarihi", "Anahtar"],
    kalemSuzgecleri: ["Hat", "BspHaric"],
    kalemSatirAlanlari: ["FaturaTarihi"],
    geriAlTumSuzgec: true,
    tlAktar: false,
    faturaBilgisi: true,
    biletNoKolonu: true,
    alis: true,
    istisnasiz: false,
    havayoluKarti: true,
    damga: "bilet",
    etkilenen: { alan: "EtkilenenBilet", sozcuk: "bilet" },
    nedenAdlari: MALIYET_NEDEN_ADLARI,
    kodlaTazelenir: true,
  },
  I: {
    grup: "iade",
    kodTur: "SI",
    basliklar: "iadeBasliklari",
    tabloAnahtari: "Anahtar",
    sozcukler: SOZCUKLER.dekont,
    tarihEtiketleri: ["İade tarihi (başlangıç)", "İade tarihi (bitiş)"],
    aramaEtiketi:
      "Listede ara (dekont no, belge no, bilet no, havayolu, cari, ünvan, müşteri, yolcu)",
    aramaAlanlari: [
      "DekontNo",
      "BelgeNo",
      "BiletNo",
      "HavayoluKodu",
      "CariKod",
      "Unvan",
      "MusteriKodu",
      "YolcuAdi",
    ],
    istekEki: { Tur: 0 },
    zarf: {
      belgeler: "Belgeler",
      atlananSayisi: "AtlananSayisi",
      atlananNumaralari: null,
    },
    bosListeMesaji: "Seçilen aralıkta iade dekontu bulunamadı.",
    secimAlanlari: ["Anahtar", "DekontNo", "IadeTarihi"],
    // Sunucu kalemleri dekontu LISTENIN istegiyle yeniden kurarak uretiyor.
    // Yalnizca Hat giderken dekont tek gunde ve havayolusuz kuruluyordu:
    // ayni DekontNo'da baska havayolunun satiri (listede / aktarimda yok)
    // pencerede gorunuyor, gun sinirini asan dekontun ikinci gunu ise
    // gorunmuyordu. Havayolunun nerede uygulandigi sunucuda
    // (DisMuhasebeIadeAktarimIstegi.AnaSorguHavayolu; satis iadesinde ic hat,
    // LogoIadeEntUnit.pas:925-931).
    kalemSuzgecleri: ["Hat", "BaslangicTarihi", "BitisTarihi", "HavayoluKodu"],
    kalemSatirAlanlari: [],
    geriAlTumSuzgec: true,
    tlAktar: false,
    faturaBilgisi: false,
    alis: false,
    istisnasiz: true,
    // Satis iadesinde ARP_CODE, MUSTERI carisinin Reserved2'sinden geliyor
    // (LogoIadeEntUnit.pas:1824-1837) - havayolu karti penceresi burada
    // yanlis karti duzelttirirdi.
    havayoluKarti: false,
    damga: "iade kaydı",
    etkilenen: { alan: "EtkilenenSatir", sozcuk: "iade kaydı" },
    nedenAdlari: IADE_NEDEN_ADLARI,
    kodlaTazelenir: true,
  },
  AI: {
    grup: "iade",
    kodTur: "AI",
    basliklar: "alisIadeBasliklari",
    tabloAnahtari: "Anahtar",
    sozcukler: SOZCUKLER.dekont,
    tarihEtiketleri: ["İade tarihi (başlangıç)", "İade tarihi (bitiş)"],
    aramaEtiketi:
      "Listede ara (dekont no, belge no, bilet no, havayolu, cari, tedarikçi, ünvan, müşteri, yolcu)",
    // Tedarikci de aranir: bu tipte tabloda cari yerine o kolon gorunuyor.
    aramaAlanlari: [
      "DekontNo",
      "BelgeNo",
      "BiletNo",
      "HavayoluKodu",
      "CariKod",
      "TedarikciKod",
      "Unvan",
      "MusteriKodu",
      "YolcuAdi",
    ],
    istekEki: { Tur: 1 },
    zarf: {
      belgeler: "Belgeler",
      atlananSayisi: "AtlananSayisi",
      atlananNumaralari: null,
    },
    bosListeMesaji: "Seçilen aralıkta alış iadesi dekontu bulunamadı.",
    secimAlanlari: ["Anahtar", "DekontNo", "IadeTarihi"],
    // Satis iadesiyle ayni sebep (bkz. I). Alis iadesinde havayolu HER hatta
    // uygulaniyor (LogoAlisIadeEntUnit.pas:571-574), yani eksikligi her
    // havayolu suzgecli listede baska havayolunun kalemlerini gosteriyordu.
    kalemSuzgecleri: ["Hat", "BaslangicTarihi", "BitisTarihi", "HavayoluKodu"],
    kalemSatirAlanlari: [],
    geriAlTumSuzgec: true,
    tlAktar: false,
    faturaBilgisi: false,
    alis: true,
    istisnasiz: true,
    // Alis iadesinde karsi taraf HAVAYOLU kartindan geliyor
    // (LogoAlisIadeEntUnit.pas:1381-1603), maliyetle ayni kolonlar.
    havayoluKarti: true,
    damga: "iade kaydı",
    etkilenen: { alan: "EtkilenenSatir", sozcuk: "iade kaydı" },
    nedenAdlari: IADE_NEDEN_ADLARI,
    kodlaTazelenir: true,
  },
};

/**
 * Kalem satirinin kombinasyonun KAYITLI kodunu tasiyan alanlari (sunucu
 * FaturaSatirOzeti.Kayitli*). Sirasi kalemKod'daki alanlarla ayni:
 * GelirKodu, KdvKodu, MuafiyetKodu, MuafiyetNedeni. Iade kaleminde bunlara
 * KayitliMasterKodu eklenir (bkz. KayitliKodlar); satis/alis formu o alani
 * tasimaz.
 */
const KAYITLI_KOD_ALANLARI = [
  "KayitliGelirKodu",
  "KayitliKdvKodu",
  "KayitliMuafiyetKodu",
  "KayitliMuafiyetNedeni",
];

/** Kalem kod penceresinin bos formu. */
const bosKalemKodu = () => ({
  GelirKodu: "",
  KdvKodu: "",
  MuafiyetKodu: "",
  MuafiyetNedeni: "",
});

/**
 * Havayolu kartindaki tedarikci hesap kodlarinin HATTA gore karsiliklari.
 *
 * Anahtar sunucunun Hat degeri: 0 ic hat, 1 dis hat ve BSP. Kolon adlari
 * (Reserved5-8) etikette YAZILIYOR, cunku kullanici ayni kartta Delphi
 * ekranindaki alanlari da goruyor ve hangisini duzelttigini bilmeli.
 *
 * kart*: sunucunun okuma ucunun alan adlari; form bunlardan doluyor.
 * Oteki hattin alanlari PENCEREDE HIC gosterilmez (kullanici karari
 * 2026-09-22), bu yuzden kayit da yalnizca bu hatti gonderir.
 */
const HYOL_HATLARI = {
  0: {
    ad: "İç hat",
    tedarikciKolonu: "Reserved5",
    muhasebeKolonu: "Reserved6",
    kartTedarikci: "IcHatTedarikciKodu",
    kartMuhasebe: "IcHatMuhasebeKodu",
  },
  1: {
    ad: "Dış hat",
    tedarikciKolonu: "Reserved7",
    muhasebeKolonu: "Reserved8",
    kartTedarikci: "DisHatTedarikciKodu",
    kartMuhasebe: "DisHatMuhasebeKodu",
  },
};

/**
 * Sunucu yanitinda Uyari gelmezse gosterilen yerel karsiligi (eski sunucu).
 * Uyari GORUNMEK ZORUNDA: Havayolu tablosunda SirketKodu kolonu yok, yani
 * girilen kod ayni musterinin butun sirketlerini etkiliyor.
 */
const HYOL_ORTAK_KART_UYARISI =
  "Havayolu kartı tüm şirketlerde ortaktır: buraya girilen kod, aynı " +
  "müşterinin diğer şirketlerinin aktarımını da değiştirir.";

export default {
  components: { sayfataban, onaydialog, kaydetbutonu, kalemtablosu },

  // Yetki yoksa taban buraya dondurur. Tabanin kendisi ogrenemez cunku
  // beforeRouteEnter yalnizca ROTA bileseninde calisir; bu sayfa rota
  // bileseni oldugu icin degeri o alip prop olarak veriyor.
  beforeRouteEnter(to, from, next) {
    next((vm) => {
      vm.oncekiRota = from.path;
    });
  },

  data() {
    // YEREL gun: toISOString() UTC verdigi icin Turkiye'de gece yarisi ile
    // 03:00 arasinda bir onceki gunu gosteriyordu.
    let bugun = helpers.bugunIso();

    return {
      oncekiRota: null,

      // Hedef ERP'nin adi. Aktar()'daki istek.Hedef = 0 ile AYNI hedefi
      // anlatir; sunucu su an yalnizca Logo'yu kabul ediyor. Baslikta
      // gorunmesi disinda bir isi yok - ikinci bir hedef eklendiginde
      // (Hedef secilebilir hale geldiginde) bu da secime bagli bir
      // computed'e donusmeli.
      hedefAdi: "Logo",

      // "F" fatura (satis), "M" maliyet (bilet alis belgesi, SATIS
      // tarihine gore), "MF" ayni belge FATURA tarihine gore, "I" iade
      // (satis iadesi dekontu), "AI" alis iadesi. Tipin uclari UCLAR'da,
      // geri kalan farklari TIP_AYARLARI'nda (dosyanin basi).
      tip: "F",
      // Bir donem her tipte "hazir" bayragi vardi (sunucusu olmayan tip
      // secilebilir ama listelenemezdi). Iade de hazir olunca hazir olmayan
      // tip kalmadi ve o yol kaldirildi; yeni bir tip sunucusuyla birlikte
      // eklenir.
      // "Maliyet" adi "Maliyet (Satış Tarihi)" oldu: ikinci maliyet tipi
      // eklenince tek basina hangi tarihe gore aktarildigini soylemiyordu.
      // Deger "M" DEGISMEDI - entegrasyon/index.vue'deki "?tip=M" kisayolu
      // ve kullanicilarin kayitli baglantilari calismaya devam etsin.
      tipler: [
        { text: "Fatura", value: "F" },
        { text: "Maliyet (Satış Tarihi)", value: "M" },
        { text: "Maliyet (Fatura Tarihi)", value: "MF" },
        { text: "İade", value: "I" },
        { text: "Alış İadesi", value: "AI" },
      ],

      // Listede arama. Sunucuya GITMEZ; bkz. sablondaki not.
      arama: "",

      // Aktarilma durumuna gore suzgec. Bu da istemci tarafinda: damga
      // fatura duzeyinde bellekte hesaplaniyor (biletlerin TUMU damgaliysa
      // fatura aktarilmis sayiliyor), dolayisiyla SQL'e itmenin kazanci
      // olmazdi.
      // Varsayilan AKTARILMAYANLAR: olagan is akisi henuz aktarilmamis
      // faturalari gondermek. Tumu ile baslamak, zaten aktarilmis
      // faturalari da secip ikinci kez gondermeyi kolaylastiriyordu.
      durumSuzgeci: "N",
      durumlar: [
        { text: "Tümü", value: "T" },
        { text: "Aktarılmayanlar", value: "N" },
        { text: "Aktarılanlar", value: "A" },
      ],

      // Kalem uzerinden kod duzenleme penceresi.
      kalemKodDialog: false,
      kalemKodSatiri: null,
      kalemKod: bosKalemKodu(),

      // Havayolu kartinin tedarikci hesap kodlari penceresi (kalem
      // penceresinden aciliyor).
      hyolDialog: false,
      hyolYukleniyor: false,
      // Acildigi andaki belgeden DONDURULAN degerler. satirFatura'dan
      // okunmuyorlar: kayit sonrasi tazeleme satirFatura'yi YENI nesneyle
      // degistiriyor (bkz. SecimiTasi) ve pencere o anda hala acik olabilir;
      // dondurulmasaydi baslik ve gonderilen Hat kayit sirasinda degisebilirdi.
      hyolKod: "",
      // Belgenin HAM havayolu kodu; hyolKod ondan farkli olabilir (BSP ->
      // "BS", acente -> acente kodu). Yalnizca farki anlatan not icin.
      hyolBiletKodu: "",
      hyolIcDis: "",
      hyolHat: 0,
      // Sunucudan okunan kart; null = kart bulunamadi (ya da henuz okunmadi).
      hyolKart: null,
      hyolUyari: "",
      hyolForm: { TedarikciKodu: "", MuhasebeKodu: "" },
      // Pencere acilirken KAYITLI olan iki kod. Kaydetmeden once bununla
      // karsilastiriliyor: dolu bir kodu bosaltmak silme demek ve onay ister.
      hyolKayitli: { TedarikciKodu: "", MuhasebeKodu: "" },

      // Muhasebe kod tanimi penceresi.
      kodDialog: false,
      kodYukleniyor: false,
      kodlar: [],
      kodHat: "I",
      kodTur: "S",

      // Kalem kod penceresinde alis KDV hesabinin ipucu.
      alisKdvIpucu:
        "İç hat alışlarında KDV bu hesaba yazılır; dış hatta kullanılmaz.",
      // Ayni pencerede iade KDV hesabinin ipucu: yazici VatCode'u yalnizca
      // ic hat %18 / %20 satirina yaziyor.
      iadeKdvIpucu:
        "Yalnızca iç hat %18 / %20 KDV'li iade satırlarında bu hesaba yazılır.",

      // Son aktarimda dosya uretildi ama damga konamadiysa kullaniciya
      // gosterilen mesaj (X-Damga-Hatasi); yoksa bos. Bkz. Aktar.
      damgaHatasi: "",

      // Liste isteklerinin sira numarasi. Her istek ve Temizle bir artirir;
      // yaniti geldiginde numara degismisse yanit ESKIDIR ve islenmez (bkz.
      // ListeIste).
      listeIstekNo: 0,

      // Aktarim secenek penceresi. Isaretleme VARSAYILAN ACIK: olagan
      // kullanim aktarip damgalamak, damgasiz cikti istisna.
      aktarimDialog: false,
      aktarimIsaretle: true,
      // Yalnizca satis tarihli maliyet (ayar.tlAktar): dovizli belge TL
      // olarak yazilsin mi. Varsayilan ACIK ve her aciliste yeniden acilir
      // (bkz. AktarimiAc).
      aktarimTlAktar: true,

      // Kalemler liste yanitiyla GELMIYOR, acildiginda cekiliyor.
      kalemYukleniyor: false,

      // Satir penceresi. Fatura nesnesinin KENDISI tutulur (kopyasi degil):
      // pencere yalnizca okuyor, kopyalamak listedeki kayitla pencereyi
      // ayristirir ve tazelemeden sonra eski veriyi gostermeye devam ederdi.
      satirDialog: false,
      satirFatura: null,

      bas: bugun,
      bit: bugun,
      basMetin: null,
      bitMetin: null,
      menu1: false,
      menu2: false,

      hat: 2,
      hatlar: [
        { text: "Hepsi", value: 2 },
        { text: "İç Hat", value: 0 },
        { text: "Dış Hat", value: 1 },
      ],
      havayolu: null,
      musteri: null,
      faturaSeri: null,
      faturaNo: null,
      // Yalnizca maliyet listesinin suzgeci; bkz. Filtreler().
      bspHaric: false,

      // Listedeki satirlar. Adi tarihsel: maliyette MaliyetOzeti, iadede
      // IadeOzeti tasir.
      faturalar: [],
      secilenler: [],
      yukleniyor: false,

      // Maliyet / iade listesine ALINMAYAN kayitlar (cari karti yok, durum
      // kodu tam eslesmiyor, dekont numarasi yok vb.). Sunucu sayiyi ve
      // numaralari ayri veriyor; liste kirpilmis gelebilir diye sayi
      // numaralardan turetilmiyor. (Adlar tarihsel: iadede sayi
      // AtlananSayisi'ndan gelir, numara listesi yok.)
      atlananBiletSayisi: 0,
      atlananBiletler: [],
      // Ayni kayitlar nedeniyle: maliyette [{ BiletNo, HavayoluKodu,
      // NedenKodu, Neden }], iadede [{ BiletNo, FormNo, Sirano, DekontNo,
      // NedenKodu, Neden }]. Eski maliyet yanitinda YOK; o zaman bos kalir
      // ve uyari nedensiz metne duser.
      atlananlar: [],

      // Maliyet / iade listesinin tamamini etkileyen uyarilar (GenelUyarilar).
      genelUyarilar: [],

      /**
       * Ekrandaki listeyi URETEN filtreler.
       *
       * Aktarim ve geri alma bu anlik goruntuyu kullanir, formun o anki
       * degerlerini DEGIL: secim listedeki faturalara ait, dolayisiyla
       * sunucunun da ayni kume uzerinde islemesi gerekir. Kullanici
       * listeledikten sonra tarihi daraltip Aktar'a basarsa, form
       * degerleriyle gidildiginde secilenlerin bir kismi kumenin disinda
       * kalir ve sessizce daha az fatura aktarilirdi.
       */
      listeFiltresi: null,

      // Tablo basliklari tipe gore; secim basliklar computed'inda. Sira
      // sablondaki hucre sirasiyla AYNI olmali.
      faturaBasliklari: [
        { text: "Fatura No", value: "TamFaturaNo" },
        { text: "Tarih", value: "FaturaTarihi" },
        { text: "Cari Kod", value: "CariKod" },
        { text: "Ünvan", value: "Unvan" },
        { text: "Hat", value: "IcDis" },
        { text: "Döviz", value: "BelgeDoviz" },
        { text: "Matrah", value: "ToplamMatrah", align: "right" },
        { text: "KDV", value: "ToplamKdv", align: "right" },
        { text: "Net", value: "ToplamNet", align: "right" },
        { text: "Satır", value: "SatirSayisi", align: "right" },
        { text: "Durum", value: "EntegreEdildi" },
      ],
      // Bilet No kolonu BILEREK YOK: belge no zaten havayolu kartinin
      // FormNo'su + biletin numarasi (235 + 2522566290 = 2352522566290),
      // yani iki kolon ayni numarayi gosteriyordu. Kullanici karari
      // (2026-09-22); bilet ekrani baglantisi belge no hucresine tasindi.
      // Aramada BiletNo alani DURUYOR (aramaAlanlari): kullanici elindeki
      // bilet numarasini yapistirip belgeyi bulabilmeli.
      maliyetBasliklari: [
        { text: "Belge No", value: "BelgeNo" },
        { text: "Satış Tarihi", value: "SatisTarihi" },
        { text: "Havayolu", value: "HavayoluKodu" },
        { text: "Tedarikçi", value: "TedarikciKod" },
        { text: "Müşteri", value: "MusteriKodu" },
        { text: "Yolcu", value: "YolcuAdi" },
        { text: "Hat", value: "IcDis" },
        { text: "Döviz", value: "BelgeDoviz" },
        { text: "Matrah", value: "Matrah", align: "right" },
        { text: "KDV", value: "KdvToplami", align: "right" },
        { text: "Tutar", value: "Tutar", align: "right" },
        { text: "Kalem", value: "SatirSayisi", align: "right" },
        { text: "Durum", value: "EntegreEdildi" },
      ],
      // Fatura tarihli maliyet (MF): maliyet kolonlari + biletin fatura no /
      // fatura tarihi. Aralik bu tarihe uygulandigi icin kullanici hangi
      // satirin neden listeye girdigini gormeli; satis tarihi de duruyor,
      // ikisi cogu bilette FARKLI gun.
      maliyetFaturaBasliklari: [
        { text: "Belge No", value: "BelgeNo" },
        { text: "Satış Tarihi", value: "SatisTarihi" },
        { text: "Fatura No", value: "TamFaturaNo" },
        { text: "Fatura Tarihi", value: "FaturaTarihi" },
        { text: "Havayolu", value: "HavayoluKodu" },
        { text: "Bilet No", value: "BiletNo" },
        { text: "Tedarikçi", value: "TedarikciKod" },
        { text: "Müşteri", value: "MusteriKodu" },
        { text: "Yolcu", value: "YolcuAdi" },
        { text: "Hat", value: "IcDis" },
        { text: "Döviz", value: "BelgeDoviz" },
        { text: "Matrah", value: "Matrah", align: "right" },
        { text: "KDV", value: "KdvToplami", align: "right" },
        { text: "Tutar", value: "Tutar", align: "right" },
        { text: "Kalem", value: "SatirSayisi", align: "right" },
        { text: "Durum", value: "EntegreEdildi" },
      ],
      // Iade dekontu (IadeOzeti). Iki dizi yalnizca karsi taraf kolonunda
      // ayrisiyor: satis iadesinde cari, alis iadesinde tedarikci.
      iadeBasliklari: [
        { text: "Dekont No", value: "DekontNo" },
        { text: "İade Tarihi", value: "IadeTarihi" },
        { text: "Belge No", value: "BelgeNo" },
        { text: "Havayolu", value: "HavayoluKodu" },
        { text: "Bilet No", value: "BiletNo" },
        { text: "Cari", value: "CariKod" },
        { text: "Ünvan", value: "Unvan" },
        { text: "Müşteri", value: "MusteriKodu" },
        { text: "Yolcu", value: "YolcuAdi" },
        { text: "Hat", value: "IcDis" },
        { text: "Matrah", value: "Matrah", align: "right" },
        { text: "KDV", value: "KdvToplami", align: "right" },
        { text: "Tutar", value: "Tutar", align: "right" },
        { text: "Kalem", value: "SatirSayisi", align: "right" },
        { text: "Durum", value: "EntegreEdildi" },
      ],
      alisIadeBasliklari: [
        { text: "Dekont No", value: "DekontNo" },
        { text: "İade Tarihi", value: "IadeTarihi" },
        { text: "Belge No", value: "BelgeNo" },
        { text: "Havayolu", value: "HavayoluKodu" },
        { text: "Bilet No", value: "BiletNo" },
        { text: "Tedarikçi", value: "TedarikciKod" },
        { text: "Ünvan", value: "Unvan" },
        { text: "Müşteri", value: "MusteriKodu" },
        { text: "Yolcu", value: "YolcuAdi" },
        { text: "Hat", value: "IcDis" },
        { text: "Matrah", value: "Matrah", align: "right" },
        { text: "KDV", value: "KdvToplami", align: "right" },
        { text: "Tutar", value: "Tutar", align: "right" },
        { text: "Kalem", value: "SatirSayisi", align: "right" },
        { text: "Durum", value: "EntegreEdildi" },
      ],

      // Snackbar tabanda; sayfa yalnizca durum nesnesini tutar.
      durum: tool.NewSatatus(),
    };
  },

  computed: {
    /**
     * Sayfa basligi: taban ad + hedef ERP + "Test" isareti.
     *
     * "(Test)" ibaresi entegrasyon/index.vue'deki tipitems listesindeki
     * "Logo Fatura(Test)" gibi girdilerle AYNI kural: bu sayfa da henuz
     * deneme asamasinda, eski toplu aktarim ekraninin (index.vue)
     * yerini almadi.
     */
    sayfaBasligi() {
      return "Dış Muhasebe Aktarımı — " + this.hedefAdi + " (Test)";
    },

    /**
     * Secili tipin ayarlari (TIP_AYARLARI); tanimsiz tip degerinde null.
     * Tip yalnizca secim kutusundan ve dogrulanmis ?tip= adresinden
     * geliyor, null'a karsi korunan yer liste blogu ve istek atan
     * metotlar.
     */
    tipAyari() {
      return Object.prototype.hasOwnProperty.call(TIP_AYARLARI, this.tip)
        ? TIP_AYARLARI[this.tip]
        : null;
    },

    /**
     * Ayar okuyan computed'ler icin: tanimsiz tipte fatura ayari. Yalnizca
     * GORUNUM icin (etiket, sozcuk, baslik); istek atan yollar tipAyari'na
     * ve uclar'a bakar, tanimsiz tipte istek atmaz.
     */
    gorunumAyari() {
      return this.tipAyari || TIP_AYARLARI.F;
    },

    /** Secili tip fatura (satis) mi. */
    faturaMi() {
      return this.gorunumAyari.grup === "fatura";
    },

    /** Secili tip maliyet (bilet alis belgesi) mi. */
    maliyetMi() {
      return this.tipAyari !== null && this.tipAyari.grup === "maliyet";
    },

    /** Secili tip iade dekontu (satis ya da alis iadesi) mi. */
    iadeMi() {
      return this.tipAyari !== null && this.tipAyari.grup === "iade";
    },

    /** Secili tip alis iadesi mi (karsi taraf tedarikci): alis tarafi iade. */
    alisIadeMi() {
      return this.iadeMi && this.tipAyari.alis === true;
    },

    /** Secili tipin sunucu uclari; tanimsiz tipte null. */
    uclar() {
      return UCLAR[this.tip] || null;
    },

    /** Tablonun kolonlari; satir sablonundaki dal ile ayni kosul. */
    basliklar() {
      return this[this.gorunumAyari.basliklar];
    },

    /**
     * Satiri tekil tanimlayan alan: tablonun item-key'i ve gizli secim
     * sayimi bunu kullanir.
     *
     * Maliyette BiletNo yetmiyor: ayni numara farkli havayolunda ya da
     * farkli satis gununde tekrar edebilir. Iadede DekontNo da yetmiyor
     * (ayni dekont numarasi farkli gunde). Anahtar'i sunucu uretiyor.
     */
    tabloAnahtari() {
      return this.gorunumAyari.tabloAnahtari;
    },

    /** Ekrandaki "fatura" sozcugunun tipe gore karsiliklari (SOZCUKLER). */
    belgeSozcukleri() {
      return this.gorunumAyari.sozcukler;
    },

    /**
     * Tarih alanlarinin etiketi. Maliyette aralik biletin SATIS tarihine
     * (M) ya da FATURA tarihine (MF), iadede IADE tarihine (Iade.Iade_Tar)
     * uygulaniyor. Etiket yanlissa ay sonu faturalanan biletler yanlis ayda
     * aranir - iki maliyet tipini birbirinden ayiran tek gorunur sey de bu.
     */
    basEtiketi() {
      let e = this.gorunumAyari.tarihEtiketleri;
      return e ? e[0] : this.$t("Starting-Date");
    },

    bitEtiketi() {
      let e = this.gorunumAyari.tarihEtiketleri;
      return e ? e[1] : this.$t("End-Date");
    },

    /** Arama kutusunun etiketi: aranan alanlari soyler. */
    aramaEtiketi() {
      return this.gorunumAyari.aramaEtiketi;
    },

    /**
     * Iade penceresinde Logo cari kodunun (TedarikciKod) etiketi: satis
     * iadesinde carinin, alis iadesinde havayolunun Logo kodu.
     */
    iadeKarsiTarafEtiketi() {
      return this.alisIadeMi ? "Tedarikçi" : "Logo cari";
    },

    /**
     * Aktarim penceresinde TL aktar secenegi gorunur mu.
     *
     * Kosul "maliyetMi" DEGIL ayarin kendisi (tlAktar): fatura tarihli
     * maliyet de maliyet grubunda ama o tipte sunucu TlAktar'i yok sayiyor
     * (Delphi LogoAlisFatEntUnit.pas'ta boyle bir kutu yok). Gorunseydi
     * kullanici hicbir sey degistirmeyen bir secenegi isaretlerdi.
     */
    tlAktarSecenegi() {
      return this.gorunumAyari.tlAktar === true;
    },

    /**
     * Listede ve satir penceresinde biletin FATURA no / tarihi gosterilsin
     * mi (TIP_AYARLARI faturaBilgisi). Yalnizca belgeyi fatura tarihine gore
     * ureten tipte: aralik o tarihe uygulandigi icin kullanici satirin neden
     * listede oldugunu gormeli.
     */
    faturaBilgisiVar() {
      return this.gorunumAyari.faturaBilgisi === true;
    },

    /**
     * Listede ayri bir Bilet No kolonu cizilir mi (TIP_AYARLARI
     * biletNoKolonu). Satis tarihli maliyette (M) cizilmez: belge no zaten
     * FormNo + bilet numarasi oldugu icin iki kolon ayni numarayi
     * gosteriyordu (kullanici karari, 2026-09-22).
     *
     * gorunumAyari uzerinden okunuyor, tipAyari degil: tanimsiz tipte
     * gorunum fatura ayarina dusuyor ve orada bu kolon zaten yok.
     */
    biletNoKolonuVar() {
      return this.gorunumAyari.biletNoKolonu === true;
    },

    /** Kalem tablosunun alis bayragi: maliyet ve alis iadesi. */
    kalemAlis() {
      return this.gorunumAyari.alis;
    },

    /** Kalem tablosunda istisna kolonu gizli mi (iadelerde). */
    kalemIstisnasiz() {
      return this.gorunumAyari.istisnasiz;
    },

    /**
     * Kalem penceresinden havayolu kartinin tedarikci kodu duzenlenebilir mi
     * (TIP_AYARLARI havayoluKarti).
     *
     * Yalnizca carisi HAVAYOLU KARTINDAN gelen belgelerde: maliyet (M / MF)
     * ve alis iadesi (AI). Satis faturasinda (F) ve satis iadesinde (I)
     * ARP_CODE musteri carisinden geliyor; orada acilsaydi kullanici
     * havayolu kartini degistirip belgenin duzeldigini sanirdi.
     *
     * gorunumAyari DEGIL tipAyari okunuyor: tanimsiz tipte pencere hic
     * acilmamali, fatura ayarina dusmek onu gizlice acardi.
     */
    havayoluKartiDuzenlenir() {
      return this.tipAyari !== null && this.tipAyari.havayoluKarti === true;
    },

    /** Acik havayolu penceresinin hat tanimi; tanimsiz hatta ic hat. */
    hyolHatTanimi() {
      return HYOL_HATLARI[this.hyolHat] || HYOL_HATLARI[0];
    },

    /**
     * Pencerenin basligi: hangi kart ve HANGI HAT duzenleniyor
     * (orn. "TK — Dış hat tedarikçi kodları"). Hat basliga yaziliyor cunku
     * ekranda iki alan var ve ikisi de "tedarikci kodu": hangi kolona
     * gittikleri yalnizca buradan ve etiketlerden anlasiliyor.
     */
    hyolBasligi() {
      return (
        (this.hyolKod || "—") +
        " — " +
        this.hyolHatTanimi.ad +
        " tedarikçi kodları"
      );
    },

    /** Belge BSP bileti mi (B_Ic_Dis = 'B'): dis hat alanlari duzenlenir. */
    hyolBspMi() {
      return this.hyolIcDis === "B";
    },

    /**
     * Duzenlenen kart biletin kendi havayolundan FARKLI mi (BSP -> "BS",
     * acente -> acente kodu). Fark varsa pencere bunu acikca yaziyor:
     * kullanici belgede baska bir kod gorup yanlis karti actigini saniyordu.
     */
    hyolKartFarkli() {
      let bilet = (this.hyolBiletKodu || "").trim();
      return bilet !== "" && bilet !== (this.hyolKod || "").trim();
    },

    /** Tedarikci cari kodu alaninin etiketi: hat + kart kolonu + Logo alani. */
    hyolTedarikciEtiketi() {
      return (
        this.hyolHatTanimi.ad +
        " tedarikçi cari kodu (" +
        this.hyolHatTanimi.tedarikciKolonu +
        " → ARP_CODE)"
      );
    },

    /** Tedarikci muhasebe kodu alaninin etiketi. */
    hyolMuhasebeEtiketi() {
      return (
        this.hyolHatTanimi.ad +
        " tedarikçi muhasebe kodu (" +
        this.hyolHatTanimi.muhasebeKolonu +
        " → GL_CODE)"
      );
    },

    /** Ortak kart uyarisi: sunucununki, yoksa yerel karsiligi. */
    hyolUyariMetni() {
      return this.hyolUyari || HYOL_ORTAK_KART_UYARISI;
    },

    /**
     * Atlanan biletlerin kisa dokumu: ilk birkac numara ve kalanin sayisi.
     *
     * Kalan, sunucunun verdigi SAYIDAN hesaplaniyor: numara listesi
     * kirpilmis gelirse de toplam dogru gorunsun.
     */
    atlananBiletOzeti() {
      let numaralar = this.atlananBiletler || [];
      let gosterilen = numaralar.slice(0, ATLANAN_ORNEK_SAYISI);
      let kalan = this.atlananBiletSayisi - gosterilen.length;

      let metin = gosterilen.join(", ");
      if (kalan > 0) metin += (metin ? " " : "") + "ve " + kalan + " bilet daha";

      return metin;
    },

    /**
     * Atlanan bilet uyarisinda yazilan toplam.
     *
     * Sunucunun SAYISI esas; nedenli liste ondan uzun gelirse (sayi alani
     * olmayan bir yanit) liste boyu alinir ki uyari hic cikmamazlik etmesin.
     */
    atlananToplami() {
      let liste = this.atlananlar || [];
      return Math.max(Number(this.atlananBiletSayisi) || 0, liste.length);
    },

    /**
     * Atlanan biletler NEDEN KODUNA gore:
     * [{ kod, neden, sayi, ornekler: [{ biletNo, ayrinti }], fazla }],
     * kalabalik neden once.
     *
     * Nedenli liste yoksa BOS doner; sablon o zaman neden yazmayan metne
     * duser. Eskiden tek neden (cari karti yok) yaziliyordu, oysa durum kodu
     * tam eslesmeyen biletler de atlaniyor - uydurma bir neden kullaniciyi
     * olmayan bir cari kartini aramaya gonderir.
     *
     * Grup adi koddan gelen SABIT metin (tipin nedenAdlari tablosu, bkz.
     * AtlananNedenAdi). Sunucunun
     * Neden metni satirin degerini tasidigi icin gruplamada kullanilmaz;
     * ornek numaranin ipucu (ayrinti) olur. ornekler ilk
     * ATLANAN_NEDEN_ORNEK_SAYISI numara, fazla grubun geri kalani.
     *
     * Toplam nedenli listeden buyukse (liste kirpilmis) fark "nedeni
     * bildirilmedi" grubuna eklenir; gruplarin toplami basliktaki sayiyi
     * tutsun.
     */
    atlananGruplari() {
      let liste = this.atlananlar || [];
      if (liste.length === 0) return [];

      let gruplar = [];
      let dizin = {};

      // Ilk goruldugu sirada: esit sayida nedenler sunucunun sirasini korur.
      let grup = (kod) => {
        if (!dizin[kod]) {
          dizin[kod] = { kod: kod, sayi: 0, ornekler: [] };
          gruplar.push(dizin[kod]);
        }
        return dizin[kod];
      };

      liste.forEach((a) => {
        let g = grup(this.AtlananNedenKodu(a));
        let biletNo = a ? String(a.BiletNo || "").trim() : "";
        let ayrinti = a ? String(a.Neden || "").trim() : "";

        g.sayi += 1;
        if (biletNo) g.ornekler.push({ biletNo: biletNo, ayrinti: ayrinti || null });
      });

      let kalan = this.atlananToplami - liste.length;
      if (kalan > 0) grup(0).sayi += kalan;

      return gruplar
        .map((g, sira) => {
          let ornekler = g.ornekler.slice(0, ATLANAN_NEDEN_ORNEK_SAYISI);

          return {
            kod: g.kod,
            neden: this.AtlananNedenAdi(g.kod),
            sayi: g.sayi,
            // Numara yoksa "ve N bilet daha" de yazilmaz: parantezin
            // icinde tek basina anlamsiz kalir.
            ornekler: ornekler,
            fazla: ornekler.length > 0 ? g.sayi - ornekler.length : 0,
            sira: sira,
          };
        })
        .sort((a, b) => b.sayi - a.sayi || a.sira - b.sira)
        .map((g) => ({
          kod: g.kod,
          neden: g.neden,
          sayi: g.sayi,
          ornekler: g.ornekler,
          fazla: g.fazla,
        }));
    },

    /**
     * Satir penceresinin okudugu ortak bicim: Satirlar, SatirSayisi ve
     * ToplamMatrah / ToplamKdv / ToplamNet.
     *
     * Fatura ozeti bu bicimde geliyor ve OLDUGU GIBI donuyor. Maliyet ve
     * iade ozeti ayni toplamlari Matrah / KdvToplami / Tutar adlariyla
     * tasiyor; kalemtablosu'nu modellere gore dallandirmak yerine eslestirme
     * burada yapiliyor. Satirlar dizisi kopyalanmiyor, satirdaki onbellegin
     * kendisi.
     */
    satirBelgesi() {
      let b = this.satirFatura;
      if (!b || this.faturaMi) return b;

      return {
        Satirlar: b.Satirlar,
        SatirSayisi: b.SatirSayisi,
        ToplamMatrah: b.Matrah,
        ToplamKdv: b.KdvToplami,
        ToplamNet: b.Tutar,
      };
    },

    /**
     * Aramaya ve durum suzgecine uyan satirlar; kural ListeyiSuz'de.
     *
     * Sayac ve gizli secim sayimi bunu kullanir. Tablo AYNI kurali kendi
     * custom-filter'i uzerinden uygular (bkz. tabloSuzgeci), yani ekrandaki
     * satirlar ile buradaki kume ayni yerden turuyor.
     */
    suzulmusFaturalar() {
      return this.ListeyiSuz(
        this.faturalar,
        this.durumSuzgeci,
        this.AramaAnahtari(this.arama)
      );
    },

    /**
     * Tablonun search prop'u: durum suzgeci + "|" + sadelestirilmis arama;
     * hicbir suzgec yoksa null.
     *
     * NEDEN search: suzulmus dizi :items'a verilince Vuetify 1.5.24'un items
     * izleyicisi (mixins/data-iterable.js) v-model'i yeni dizide kalan
     * anahtarlara indiriyor ve arama / durum degisince secim SESSIZCE
     * siliniyordu. Tablo tam listeyi alip search ile suzdugunde items hic
     * degismez, secim korunur; search degisimi yalnizca ilk sayfaya doner.
     *
     * Iki suzgec de bu TEK degere kodlaniyor: Vuetify custom-filter'i
     * yalnizca search degisince yeniden sayfalandiriyor ve ona ne
     * verdiyse onu iletiyor (bkz. TabloSuz). null iken custom-filter hic
     * cagrilmaz. Vuetify'nin kendi aramasi kullanilmiyor: o kaydin BUTUN
     * alanlarinda (GUID, Satirlar'in "[object Object]" hali...) arardi.
     */
    tabloSuzgeci() {
      let a = this.AramaAnahtari(this.arama);
      let durum = this.durumSuzgeci;

      if (!a && durum === "T") return null;

      return durum + "|" + a;
    },

    /**
     * Secili olup suzgece UYMAYAN (ekranda gorunmeyen) satir sayisi.
     *
     * Tablo tam listeyi aldigi icin bu secimler suzgec degisince SILINMIYOR
     * ve aktarimla geri almada gonderiliyor; sayi ekranda ve aktarim
     * penceresinde yaziliyor ki gorunmeyen secimler sessizce dosyaya
     * girmesin.
     */
    gizliSecimSayisi() {
      // Suzgec YOKKEN gorunmeyen secim de olamaz; erken cikmak buyuk
      // listelerde sozluk kurmaktan kurtariyor.
      if (this.suzulmusFaturalar === this.faturalar) return 0;

      // Tablonun kendi anahtariyla: maliyette TamFaturaNo yok.
      let anahtar = this.tabloAnahtari;

      let gorunen = {};
      this.suzulmusFaturalar.forEach((f) => {
        gorunen[f[anahtar]] = true;
      });

      return this.secilenler.filter((f) => !gorunen[f[anahtar]]).length;
    },

    /** Kod ekraninda alis kumesi mi secili (alis iadesi DEGIL). */
    kodAlisMi() {
      return this.kodTur === "A";
    },

    /** Kod ekraninda satis kumesi mi secili (satis iadesi DEGIL). */
    kodSatisMi() {
      return this.kodTur === "S";
    },

    /**
     * Kod ekraninda secili kumenin belge turu (0 satis, 1 alis, 2 satis
     * iadesi, 3 alis iadesi); bkz. muhasebekodturu.js.
     */
    kodBelgeTuru() {
      return muhasebekodturu.KodTuruBelgeTuru(this.kodTur);
    },

    /** Kod ekraninda iade kumelerinden biri mi secili. */
    kodIadeMi() {
      return muhasebekodturu.IadeTuruMu(this.kodBelgeTuru);
    },

    /**
     * Kod ekraninda GL_CODE1 kolonunun adi: alis ve alis iadesinde gider,
     * satis ve satis iadesinde gelir hesabi.
     */
    kodHesapEtiketi() {
      return this.kodTur === "A" || this.kodTur === "AI" ? "Gider hesabı" : "Gelir hesabı";
    },

    /**
     * Kalem kod penceresinin DUZENLEDIGI kombinasyonun kalem tipi; pencere
     * kapaliyken null. Kural KalemKodTipi'nde.
     */
    kalemKodTipi() {
      return this.kalemKodSatiri ? this.KalemKodTipi(this.kalemKodSatiri) : null;
    },

    /**
     * Kalem kod penceresinin kombinasyonunun belge turu (0 satis, 1 alis,
     * 2 satis iadesi, 3 alis iadesi); pencere kapaliyken null.
     *
     * Kalemin KodBelgeTuru'ndan, yoksa (eski sunucu) KodAlisMi'den - o
     * sunucuda iade kalemi zaten yok. Hangi alanlarin gorundugu ve
     * kaydin hangi tabloya gittigi bundan okunur.
     */
    kalemKodBelgeTuru() {
      return this.kalemKodSatiri ? muhasebekodturu.KalemBelgeTuru(this.kalemKodSatiri) : null;
    },

    /** Pencere bir iade kombinasyonunu mu duzenliyor. */
    kalemKodIadeMi() {
      return muhasebekodturu.IadeTuruMu(this.kalemKodBelgeTuru);
    },

    /**
     * Pencere basligindaki iade turu adi; satis/alis kombinasyonunda BOS
     * (baslik o zaman onceki gibi KodAlisMi'den "Satış" / "Alış" yazar).
     */
    kalemKodIadeAdi() {
      if (this.kalemKodBelgeTuru === 2) return "Satış İadesi";
      if (this.kalemKodBelgeTuru === 3) return "Alış İadesi";
      return "";
    },

    /** Kart kodu (MASTER_CODE) alaninin ipucu: bossa ne yazildigi. */
    kalemKodMasterIpucu() {
      return this.kalemKodBelgeTuru === 3
        ? "Boş bırakılırsa gider hesabı yazılır."
        : "Boş bırakılırsa gelir hesabı yazılır.";
    },

    /** KDV hesabi alaninin ipucu, belge turune gore; satista yok. */
    kalemKodKdvIpucu() {
      if (this.kalemKodBelgeTuru === 1) return this.alisKdvIpucu;
      if (this.kalemKodIadeMi) return this.iadeKdvIpucu;
      return "";
    },

    /**
     * Kombinasyonun adi. Kod ekranindaki satirin adiyla AYNI kaynaktan
     * (KodSatirTipiAdi): kullanici pencerede gordugu adi kod ekraninda da
     * bulabilmeli. Satirin TipAdi kullanilmiyor - o satirin kendi tipi.
     */
    kalemKodTipAdi() {
      return this.kalemKodTipi === null ? "" : this.KodSatirTipiAdi(this.kalemKodTipi);
    },

    /**
     * Kod satirin kendi tipinden FARKLI bir kombinasyondan mi geliyor
     * (ornegin dis hat alis alan vergisi -> Vergi). Pencere bunu ayrica
     * aciklar.
     */
    kalemKodTipiFarkli() {
      return this.kalemKodTipi !== null && this.kalemKodTipi !== this.kalemKodSatiri.Tip;
    },

    /**
     * Sunucu kombinasyon icin herhangi bir kayitli deger gonderdi mi.
     * KodKaydiVar false iken bu, degerlerin cozucunun dustugu YEDEK kayittan
     * geldigini soyler; pencere bunu ayrica yazar.
     */
    kalemKodKayitliDegerVar() {
      let s = this.kalemKodSatiri;
      if (!s) return false;

      return KAYITLI_KOD_ALANLARI.some((alan) => String(s[alan] || "").trim() !== "");
    },

    /**
     * Kod tablosunun basliklari.
     *
     * Alista KDV HESABI VAR: ic hat alislarinda bilet ve vergi satirinin
     * KDV'si ayriliyor ve bu hesaba (Logo'da GL_CODE2) yaziliyor. Alista
     * YOK olanlar: KDV durumu kolonu (alis kombinasyonu KDV'ye gore
     * ayrilmiyor) ve istisna kodu (alista kullanilmiyor). Gelir kolonu
     * alista "Gider hesabi" adini alir - Logo'da MASTER_CODE'a karsilik
     * geliyor.
     *
     * IADE kumelerinde (satis / alis iadesi): KDV durumu yok (sunucu
     * KdvliMi'yi hep false gonderiyor), istisna yok; buna karsilik Kart
     * kodu (MASTER_CODE) var. Gelir/gider kolonu orada GL_CODE1.
     *
     * Satis 5, alis 3, iadeler 4 kolon; sablondaki hucreler ayni
     * kosullara bagli (kodSatisMi / kodIadeMi).
     */
    kodBasliklari() {
      let b = [{ text: "Kalem", value: "SatirTipi", sortable: false }];

      if (this.kodSatisMi)
        b.push({ text: "KDV", value: "KdvliMi", sortable: false });

      b.push({ text: this.kodHesapEtiketi, value: "GelirKodu", sortable: false });

      if (this.kodIadeMi)
        b.push({ text: "Kart kodu (MASTER_CODE)", value: "MasterKodu", sortable: false });

      b.push({ text: "KDV hesabı", value: "KdvKodu", sortable: false });

      if (this.kodSatisMi)
        b.push({ text: "İstisna kodu", value: "MuafiyetKodu", sortable: false });

      return b;
    },

    /**
     * Ekranda gosterilecek kod satirlari: secili hat VE secili tur.
     *
     * Veritabanindan bosluk dolgulu / kucuk harfli gelebildigi icin IcDis
     * kirpilip buyuk harfe cevriliyor. Tur satirin BelgeTuru'ndan; onu
     * tasimayan eski kayit AlisMi'den turetilir (AlisMi de yoksa satis).
     */
    kodlarFiltreli() {
      return this.kodlar.filter(
        (k) =>
          (k.IcDis || "").trim().toUpperCase() === this.kodHat &&
          muhasebekodturu.SatirBelgeTuru(k) === this.kodBelgeTuru
      );
    },

    /**
     * Acik faturanin kalemlerinin TIPE gore dagilimi.
     *
     * Serit genisligi ve rozetler bundan turer. Tutar mutlak degerle
     * paylastirilir: iskonto negatif geliyor ve negatif genislik seridi
     * bozardi; isaret rozetteki rakamda zaten gorunuyor.
     */
    satirDagilimi() {
      if (!this.satirFatura || !this.satirFatura.Satirlar) return [];

      let gruplar = {};

      this.satirFatura.Satirlar.forEach((s) => {
        let g = gruplar[s.Tip];
        if (!g) {
          g = gruplar[s.Tip] = {
            tip: s.Tip,
            ad: s.TipAdi,
            renk: kalemrenkleri.TipRengi(s.Tip),
            tutar: 0,
            adet: 0,
          };
        }
        g.tutar += Number(s.Tutar) || 0;
        g.adet += 1;
      });

      let liste = Object.keys(gruplar).map((k) => gruplar[k]);

      let toplam = liste.reduce((t, g) => t + Math.abs(g.tutar), 0);

      liste.forEach((g) => {
        // Toplam sifirsa (tamamen bedelsiz fatura) esit paylastirilir;
        // sifira bolmek NaN genislik uretirdi.
        g.yuzde = toplam > 0 ? (Math.abs(g.tutar) / toplam) * 100 : 100 / liste.length;
      });

      return liste.sort((a, b) => Math.abs(b.tutar) - Math.abs(a.tutar));
    },

    aktarilanSayisi() {
      return this.faturalar.filter((f) => f.EntegreEdildi).length;
    },
  },

  // Yetki kontrolu tabanin mounted'inda; burada yalnizca sayfaya ozgu
  // hazirlik var. Iki mounted da calisir, once tabaninki.
  mounted() {
    this.basMetin = this.TarihBicimle(this.bas);
    this.bitMetin = this.TarihBicimle(this.bit);
    this.RotaTipiniSec();
  },

  methods: {
    /**
     * Adres satirindaki ?tip= degerini secer (entegrasyon/index.vue alis
     * secilince "?tip=M" ile aciyor; ?tip=MF fatura tarihli maliyeti,
     * ?tip=I ve ?tip=AI iadeyi acar).
     *
     * YALNIZCA secim kutusundaki VE ayari olan bir tip kabul edilir:
     * bilinmeyen bir deger sessizce yok sayilir ve varsayilan (Fatura)
     * kalir - kotu bir baglanti sayfayi calismaz bir tipte acmamali.
     * Buyuk/kucuk harf duzeltilmez ("ai" bilinmeyen sayilir).
     */
    RotaTipiniSec() {
      let sorgu = this.$route && this.$route.query ? this.$route.query.tip : null;
      if (typeof sorgu !== "string") return;

      let bulunan = this.tipler.find(
        (x) => x.value === sorgu && Object.prototype.hasOwnProperty.call(TIP_AYARLARI, x.value)
      );
      if (!bulunan || bulunan.value === this.tip) return;

      this.tip = bulunan.value;
      // Acilista liste bos; yine de tip degisiminin tek yolu Temizle'den
      // gecsin ki ileride mounted'a baska bir sey eklenince unutulmasin.
      this.Temizle();
    },

    /**
     * Tarih alanindan cikildiginda metni modele yazar.
     *
     * Metin cozulemezse model DEGISMEZ ve alan mevcut tarihe geri doner.
     * Yarim yazilmis ya da silinmis bir metin iyi bir tarihi silmemeli:
     * tarih araligi listenin on sarti, null kalirsa sorgu hic calismaz.
     */
    TarihAlindi(alan, metinAlani) {
      let cozulen = this.TarihAyristir(this[metinAlani]);

      if (cozulen) this[alan] = cozulen;
      else this[metinAlani] = this.TarihBicimle(this[alan]);
    },

    // Tarih cevirileri helpers'ta; entegrasyon/index.vue'da da ayni isi
    // yapan yerel kopyalar var, oradaki kod bu isin disinda birakildi.
    TarihBicimle(tarih) {
      return helpers.isoTarihiBicimle(tarih);
    },

    TarihAyristir(metin) {
      return helpers.isoTariheCevir(metin);
    },

    Para(deger) {
      if (deger === null || deger === undefined) return "";
      return Number(deger).toLocaleString("tr-TR", {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2,
      });
    },

    /**
     * Tip degisince eski liste ekranda kalmasin; yanlis secim yapilmasin.
     *
     * Listeye bagli HER sey sifirlanir: arama (fatura numarasi maliyet
     * listesinde anlamsiz), acik satir penceresi, kalem kod penceresi
     * (eski tipin kaydini gosterir, kaydedince yanlis kombinasyona
     * yazardi), havayolu kart penceresi (eski belgenin kartini ve HATTINI
     * tasiyor), atlanan kayit bilgisi, listenin genel uyarilari ve damga
     * uyarisi. Satis iadesinden alis iadesine gecis de tip degisimi:
     * satirlar ayni bicimde ama Tur'u, kodlari ve damga kolonu farkli.
     *
     * Aktarim penceresi de kapanir: acik kalirsa eski tipin secimiyle
     * degil ama yeni tipin BOS secimiyle "0 ... aktarilacak" gosterirdi.
     */
    Temizle() {
      this.faturalar = [];
      this.secilenler = [];
      this.listeFiltresi = null;
      this.arama = "";
      // Suren bir liste istegi varsa yaniti ListeIste'de atilacak (sira
      // numarasi degisti); gosterge onu beklemesin.
      this.listeIstekNo += 1;
      this.yukleniyor = false;

      this.satirDialog = false;
      this.satirFatura = null;
      this.aktarimDialog = false;

      this.kalemKodDialog = false;
      this.kalemKodSatiri = null;
      this.kalemKod = bosKalemKodu();

      // Havayolu kart penceresi de kapanir: kalem penceresinin ustunde
      // aciliyor ve ustteki kapandiginda tek basina ortada kalirdi; icindeki
      // hat ve kod ise artik listede olmayan bir belgeye aitti.
      this.hyolDialog = false;
      this.hyolYukleniyor = false;
      this.hyolKart = null;
      this.hyolKod = "";
      this.hyolBiletKodu = "";
      this.hyolIcDis = "";
      this.hyolHat = 0;
      this.hyolUyari = "";
      this.hyolForm = { TedarikciKodu: "", MuhasebeKodu: "" };
      this.hyolKayitli = { TedarikciKodu: "", MuhasebeKodu: "" };

      this.atlananBiletSayisi = 0;
      this.atlananBiletler = [];
      this.atlananlar = [];
      this.genelUyarilar = [];
      this.damgaHatasi = "";
    },

    /**
     * Listenin sunucu suzgecleri, secili tipe gore.
     *
     * Sunucu bos/bosluk degeri "filtre yok" sayiyor. Maliyet ve iade uclari
     * musteri ve satis faturasi suzgeclerini TANIMIYOR (belge biletten /
     * Iade kaydindan turuyor); gondermemek alanlari ekranda gizlemekle
     * tutarli. Maliyet ayrica BspHaric aliyor. Iade istegine Tur, fatura
     * tarihli maliyete TarihOlcutu eklenir (istekEki); anlik goruntuye
     * (listeFiltresi) de girdigi icin aktarim ve geri alma ayni degerle
     * gider.
     */
    Filtreler() {
      let istek = {
        BaslangicTarihi: this.bas,
        BitisTarihi: this.bit,
        Hat: this.hat,
        HavayoluKodu: (this.havayolu || "").trim() || null,
      };

      if (this.maliyetMi) {
        istek.BspHaric = this.bspHaric === true;
        // Ek burada da EKLENIR: TarihOlcutu gitmezse sunucu araligi SATIS
        // tarihine uygular ve ekran fatura tarihi diyerek baska bir liste
        // gosterirdi. M'de ek yok, istek harfiyen ONCEKI bicimde kalir.
        return this.IstekEkiEkle(istek);
      }

      if (!this.faturaMi) return this.IstekEkiEkle(istek);

      istek.MusteriKodu = (this.musteri || "").trim() || null;
      istek.FaturaSeri = (this.faturaSeri || "").trim() || null;
      istek.FaturaNo = (this.faturaNo || "").trim() || null;

      return istek;
    },

    /**
     * Secili tipin HER istege eklenen alanlarini (istekEki; iadede Tur,
     * fatura tarihli maliyette TarihOlcutu) verilen nesneye yazar ve nesneyi
     * dondurur. Faturada ve satis tarihli maliyette ek yok, nesne degismez.
     *
     * Deger her istekte AYARDAN yazilir, anlik goruntuden okunmaz: ayni
     * uclari paylasan iki tip var (satis / alis iadesi ve iki maliyet),
     * yanlis deger otekinin belgelerini aktarir ve OBUR damgayi degistirirdi.
     */
    IstekEkiEkle(istek) {
      let ek = this.tipAyari ? this.tipAyari.istekEki : null;
      return ek ? Object.assign(istek, ek) : istek;
    },

    /**
     * Kalemin kodunu duzenleme penceresini acar.
     *
     * Form kombinasyonun KAYITLI kodlariyla dolar (bkz. KayitliKodlar);
     * satirin kendisi DEGISTIRILMEZ, cunku kaydedilmeden once
     * vazgecilebilir.
     */
    KalemKoduAc(satir) {
      this.kalemKodSatiri = satir;
      this.kalemKod = this.KayitliKodlar(satir);
      this.kalemKodDialog = true;
    },

    /**
     * Kalem kod penceresinin ilk degerleri: kombinasyonun SUNUCUDA KAYITLI
     * kodlari (FaturaSatirOzeti.Kayitli*).
     *
     * Satira YAZILAN kodlar (MuhasebeKod, KdvMuhasebeKod...) kullanilamaz:
     * alis satirinda KdvMuhasebeKod yalnizca orani 18/20 olan satirda dolu,
     * %0 / %1 / %8 ya da Ercan satirinda bos geliyor. Pencere o bos degerle
     * acilip yalnizca gider kodu duzeltilince kayit, ayni kombinasyonu
     * kullanan %20'lik satirlarin KDV hesabini (VatCode) SILIYORDU - sunucu
     * satiri silip gelen degerlerle yeniden yaziyor. Kayitli degerle dolan
     * form dokunulmayan alani aynen geri gonderir.
     *
     * Eski sunucu Kayitli* gondermiyor; o zaman satirin alanlarina dusulur
     * (onceki davranis). "Yeni sunucu" karari KodKaydiVar'a da bakiyor:
     * ArkmanNext JSON'da null alanlari YAZMIYOR (NullValueHandling.Ignore),
     * kaydi olmayan kombinasyonda Kayitli* hepsi eksik gelir; KodKaydiVar
     * ise bool oldugu icin her zaman gelir. Yalnizca Kayitli*'a bakilsaydi
     * kaydi olmayan kombinasyon eski yola duser ve satirin degerleriyle
     * acilirdi.
     *
     * IADE kombinasyonunda form bir alan daha tasir: MasterKodu, kayitli
     * KayitliMasterKodu'ndan (null ise JSON'da yok, bos metin olur). Satis
     * ve alis formu o alani TASIMAZ; kayit istegi de yalnizca iadede
     * gonderir (bkz. KalemKoduKaydet).
     */
    KayitliKodlar(satir) {
      let yeniSunucu =
        typeof satir.KodKaydiVar === "boolean" ||
        KAYITLI_KOD_ALANLARI.some((alan) => satir[alan] !== undefined);

      let degerler = yeniSunucu
        ? KAYITLI_KOD_ALANLARI.map((alan) => satir[alan])
        : [satir.MuhasebeKod, satir.KdvMuhasebeKod, satir.MuafiyetKodu, satir.MuafiyetNedeni];

      let form = bosKalemKodu();
      Object.keys(form).forEach((alan, i) => {
        form[alan] = degerler[i] || "";
      });

      if (muhasebekodturu.IadeTuruMu(muhasebekodturu.KalemBelgeTuru(satir)))
        form.MasterKodu = satir.KayitliMasterKodu || "";

      return form;
    },

    /**
     * Kalemin kodunun ALINDIGI kombinasyonun kalem tipi.
     *
     * Satirin kendi tipi (Tip) ile ayni olmak zorunda degil: dis hat
     * alisinda alan vergisi (9) kodunu Vergi (1) kombinasyonundan aliyor.
     * Tip'e yazilsaydi kaydedilen kod hic kullanilmaz, kalem yine eski
     * kodla aktarilirdi. Sunucu bunu KodSatirTipi ile bildiriyor.
     *
     * Alan SAYI degilse (KodSatirTipi'ni tasimayan eski yanit) Tip'e
     * dusulur - o yanitlarda pencere zaten boyle calisiyordu.
     */
    KalemKodTipi(satir) {
      return typeof satir.KodSatirTipi === "number" ? satir.KodSatirTipi : satir.Tip;
    },

    /**
     * Kalemin kombinasyonuna kod yazar.
     *
     * Kombinasyonun kalem tipi satirin Tip'i DEGIL, KalemKodTipi: kod
     * baska bir kombinasyondan geliyorsa kayit oraya gitmeli.
     *
     * TEK satir gonderilir ve bu GUVENLIDIR: sunucu her satiri kendi
     * anahtariyla (kalem tipi + hat + KDV + alis) silip yeniden yaziyor,
     * istekte olmayan kombinasyonlara DOKUNMUYOR. Tum listeyi gondermek
     * yalnizca kod ekraninda gerekli - orada kullanici gormedigi kumeleri
     * de duzenlemis olabiliyor.
     *
     * Gonderilen DORT kod alani da pencerenin degerleridir, gorunmeyenler
     * dahil (alista istisna, KDV'siz satista KDV hesabi): pencere kayitli
     * degerlerle acildigi icin (bkz. KayitliKodlar) dokunulmayan alan
     * kayitli degerini korur. Sabit bos gondermek - eskiden istisna
     * nedeni hep "" gidiyordu - sunucuda o alani siler.
     *
     * Kaydettikten sonra kodu kullanan her sey yeniden cekilir: kalem
     * kodlari sunucudaki cozucuden geliyor ve cozucunun KDV ayrimi
     * yapilmamis kombinasyonlar icin bir yedek dali var
     * (CariBazliKodCozucu.Eslesme). Yerel olarak yamamak o dalin etkiledigi
     * satirlari kacirirdi. Ne tazelendigi KodlarDegisti'de.
     *
     * IADE kombinasyonu: satira BelgeTuru (2 / 3) ve MasterKodu eklenir;
     * sunucu kaydi BelgeTuru ile iade tablosuna yonlendiriyor, yoksa
     * AlisMi'den satis/alis sayip YANLIS tabloya yazardi. KdvliMi iadede
     * her zaman false (iade kombinasyonu KDV'ye gore ayrilmiyor). Satis ve
     * alis satiri ONCEKI bicimde gider: BelgeTuru yoksa sunucu AlisMi'den
     * turetiyor.
     */
    KalemKoduKaydet() {
      let satir = this.kalemKodSatiri;
      if (!satir) return Promise.resolve();

      let kirp = (deger) => (deger || "").trim();
      let belgeTuru = muhasebekodturu.KalemBelgeTuru(satir);
      let iade = muhasebekodturu.IadeTuruMu(belgeTuru);

      let kayit = {
        SatirTipi: this.KalemKodTipi(satir),
        IcDis: satir.UcusTipi,
        KdvliMi: iade ? false : satir.KodKdvli,
        AlisMi: iade ? belgeTuru === 3 : satir.KodAlisMi,
        GelirKodu: kirp(this.kalemKod.GelirKodu),
        KdvKodu: kirp(this.kalemKod.KdvKodu),
        MuafiyetKodu: kirp(this.kalemKod.MuafiyetKodu),
        MuafiyetNedeni: kirp(this.kalemKod.MuafiyetNedeni),
      };

      if (iade) {
        kayit.BelgeTuru = belgeTuru;
        kayit.MasterKodu = kirp(this.kalemKod.MasterKodu);
      }

      let istek = [kayit];

      return tool
        .api_post(this, "DisMuhasebeAktarim/MuhasebeKodKaydet", istek)
        .then(
          () => {
            this.kalemKodDialog = false;
            this.Uyar("Muhasebe kodu kaydedildi.");

            return this.KodlarDegisti(true);
          },
          (response) => {
            this.Hata(response, istek, "Muhasebe kodu kaydedilemedi");
          }
        );
    },

    /**
     * Cekilmis kalemleri unutur.
     *
     * Muhasebe kodu kombinasyon bazli oldugu icin bir kod degisikligi ayni
     * kombinasyondaki BUTUN faturalarin kalemlerini etkiliyor; hangileri
     * oldugunu bilmek yerine hepsi bir daha aciliste taze cekiliyor.
     */
    KalemOnbelleginiBosalt() {
      this.faturalar.forEach((f) => {
        if (f.Satirlar) this.$set(f, "Satirlar", null);
      });
    },

    /**
     * Muhasebe kodu kaydedildikten sonra (kalem penceresi ya da kod ekrani)
     * ekrandaki bilgiyi tazeler.
     *
     * Onbellek HER tipte bosaltilir: kod kombinasyon bazli, ayni
     * kombinasyondaki butun satirlarin kalemleri degisti. Onbellek listedeki
     * satir nesnelerinde durdugu ve liste tek tipin satirlarini tuttugu icin
     * bu, iki tipin onbellegini de kapsar (tip degisince Temizle listeyi
     * zaten atiyor).
     *
     * MALIYET ve IADE (kodlaTazelenir): liste de tazelenir. Belgelerin
     * Uyarilar'i (eksik kod, eksik KDV hesabi) listeyle geliyor;
     * tazelenmezse satir penceresi yeni kodu gosterirken ustundeki uyari ve
     * listedeki turuncu simge hala "kod eksik" der. Tazeleme FORMU degil
     * listeyi ureten filtreyi kullanir ve secimi korur (bkz. ListeyiTazele).
     *
     * FATURA: listede kod bilgisi yok; yalnizca acik satirin kalemleri
     * yeniden cekilir. kalemPenceresinden true ise kayit o pencereden
     * geldi ve satirFatura aciktir; kod ekranindan gelince yalnizca pencere
     * gercekten aciksa cekilir.
     */
    KodlarDegisti(kalemPenceresinden) {
      this.KalemOnbelleginiBosalt();

      if (this.tipAyari && this.tipAyari.kodlaTazelenir && this.listeFiltresi)
        return this.ListeyiTazele();

      let acik = kalemPenceresinden ? this.satirFatura : this.satirDialog && this.satirFatura;

      return acik ? this.KalemleriCek(this.satirFatura) : Promise.resolve();
    },

    /**
     * Belgenin ham IcDis degerinden (B_Ic_Dis / I_Ic_Dis) sunucunun Hat
     * degeri: 0 ic hat, 1 dis hat.
     *
     * Kural sunucudakiyle BIREBIR: AlisFaturaDonusturucu.IcHatMi yalnizca
     * "I" degerini ic hat sayiyor, kirpmiyor ve buyuk/kucuk harfe bakmiyor.
     * BSP bileti ("B") bu yuzden DIS hat alanlarina duser ve bu Delphi ile
     * de ayni (LogoAlisFatBiletEntUnit.pas:2112-2118). Burada daha hosgorulu
     * bir kural yazilsaydi ekran bir hattin kodunu duzelttigini soyler,
     * aktarim otekini okurdu.
     */
    HavayoluHatti(icDis) {
      return icDis === "I" ? 0 : 1;
    },

    /**
     * Havayolu kartinin tedarikci kodu penceresini acar ve karti sunucudan
     * DAR uctan okur (yalnizca dort hesap kolonu + ad / form no).
     *
     * ACILAN KART BELGENIN HAM HAVAYOLU KODU DEGILDIR: aktarim baslik
     * ARP_CODE / GL_CODE'unu AlisFaturaDonusturucu.HavayoluAnahtari ile
     * secilen karttan okuyor - acente bilette acente kodu, BSP bilette
     * (B_Ic_Dis = 'B') sabit "BS". Sunucu bu kodu ayri alanda veriyor
     * (MaliyetOzeti / IadeOzeti.HavayoluKartKodu) ve belge uyarisi da onu
     * yaziyor. Ham kodla acilsaydi BSP belgesinde kullanici BASKA bir
     * kartin - kart TENANT GENELINDE ORTAK - kodunu ezer, belge yine
     * kodsuz kalirdi.
     *
     * Alan hic gelmezse (eski sunucu) ham koda dusuluyor: BSP disindaki
     * belgelerde ikisi zaten ayni, BSP'de eski davranis surer ama pencere
     * hic acilmamasindan iyidir.
     *
     * Hat ve kart kodu ACILISTA donduruluyor (hyolHat / hyolKod): kayitten
     * sonra liste tazeleniyor ve satirFatura yeni nesneyle degisiyor; canli
     * okunsaydi kayit sirasinda pencere baska bir belgenin hattini
     * gonderebilirdi.
     *
     * Hata dalinda pencere KAPANIR: acik birakilsaydi "kart bulunamadi"
     * metni gorunur ve kullanici gercek sebebi (sunucu hatasi) kaybederdi.
     *
     * BELGE PARAMETREYLE gelir: pencere artik LISTEDEKI tedarikci
     * hucresinden aciliyor (kullanici karari, 2026-09-22), yani satirin
     * hangisi oldugunu yalnizca cagiran biliyor. Eskiden acik kalem
     * penceresinin belgesi (satirFatura) okunuyordu; oradan okunmaya devam
     * edilseydi listeden acilan pencere BASKA bir belgenin kartini
     * duzenletirdi - ya da kalem penceresi hic acilmadiysa hicbir sey
     * yapmazdi.
     *
     * kaydetbutonu :action'dan Promise bekliyor; zincir donduruluyor.
     */
    HavayoluKoduAc(belge) {
      if (!belge || !this.havayoluKartiDuzenlenir) return Promise.resolve();

      let hamKod = (belge.HavayoluKodu || "").trim();
      let kod = (belge.HavayoluKartKodu || "").trim() || hamKod;
      if (kod === "") {
        // Sunucu bos kodu 400 ile reddediyor; istek atmadan soylemek daha
        // acik.
        this.Uyar("Belgede havayolu kodu yok; kart açılamıyor.");
        return Promise.resolve();
      }

      this.hyolKod = kod;
      this.hyolBiletKodu = hamKod;
      this.hyolIcDis = belge.IcDis || "";
      this.hyolHat = this.HavayoluHatti(belge.IcDis);
      this.hyolKart = null;
      this.hyolUyari = "";
      this.hyolForm = { TedarikciKodu: "", MuhasebeKodu: "" };
      this.hyolKayitli = { TedarikciKodu: "", MuhasebeKodu: "" };
      this.hyolYukleniyor = true;
      this.hyolDialog = true;

      let istek = { Kodlar: [kod] };

      return tool
        .api_post(this, "DisMuhasebeAktarim/HavayoluKodlari", istek)
        .then(
          (response) => {
            this.hyolYukleniyor = false;

            let govde = response.data || {};
            this.hyolUyari = govde.Uyari || "";

            // Bulunamayan kod listeye HIC girmiyor (uc sozlesmesi), yani
            // bos liste "kart yok" demek.
            let kart = (govde.Kartlar || [])[0] || null;
            this.hyolKart = kart;

            if (kart) {
              let tanim = this.hyolHatTanimi;
              this.hyolForm = {
                TedarikciKodu: kart[tanim.kartTedarikci] || "",
                MuhasebeKodu: kart[tanim.kartMuhasebe] || "",
              };

              // Kaydetmeden once "bosaltiliyor mu" sorusuna bu kopya
              // bakiyor; formun kendisi kullanici yazdikca degisiyor.
              this.hyolKayitli = {
                TedarikciKodu: this.hyolForm.TedarikciKodu,
                MuhasebeKodu: this.hyolForm.MuhasebeKodu,
              };
            }
          },
          (response) => {
            this.hyolYukleniyor = false;
            this.hyolDialog = false;
            this.Hata(response, istek, "Havayolu kartı okunamadı");
          }
        );
    },

    /**
     * Kartin YALNIZCA acik hattina ait iki kodunu kaydeder.
     *
     * Istek sunucunun dar ucunun sozlesmesi: { Kod, Hat, TedarikciKodu,
     * MuhasebeKodu }. Oteki hattin kolonlari ISTEKTE YOK, dolayisiyla
     * dokunulmuyor - pencerede gorunmeyen bir alani gondermek onu
     * bosaltirdi.
     *
     * Kart okunamadiysa (bulunamadi) istek atilmaz: sunucu 404 dondururdu.
     *
     * DOLU bir kodu bosaltmak SILME sayilir ve once onay alinir: kartta
     * SirketKodu kolonu yok, yani kod musterinin BUTUN sirketlerinde
     * siliniyor ve o kartla ureyen her belge ARP_CODE / GL_CODE'suz cikiyor.
     * Yeni deger girmek ya da zaten bos alani bos birakmak onay istemez -
     * her kayitta soran bir pencere okunmaz olurdu.
     *
     * Kayittan sonra KodlarDegisti calisir, cunku kodlar CIKTIYI degistirir:
     * liste yeniden cekilir (belgenin TedarikciKod / TedarikciMuhasebeKod
     * alanlari ve "ARP_CODE bos" uyarilari listeyle geliyor) ve acik kalem
     * penceresi yeni belge nesnesine tasinir (bkz. SecimiTasi). Yerel olarak
     * yamamak ayni kartla ureyen DIGER belgeleri eski uyariyla birakirdi.
     */
    HavayoluKoduKaydet() {
      if (!this.hyolKart) return Promise.resolve();

      let kirp = (deger) => (deger || "").trim();

      let istek = {
        Kod: this.hyolKod,
        Hat: this.hyolHat,
        TedarikciKodu: kirp(this.hyolForm.TedarikciKodu),
        MuhasebeKodu: kirp(this.hyolForm.MuhasebeKodu),
      };

      let silinen = [];
      if (kirp(this.hyolKayitli.TedarikciKodu) !== "" && istek.TedarikciKodu === "")
        silinen.push("tedarikçi cari kodu (ARP_CODE)");
      if (kirp(this.hyolKayitli.MuhasebeKodu) !== "" && istek.MuhasebeKodu === "")
        silinen.push("tedarikçi muhasebe kodu (GL_CODE)");

      if (silinen.length === 0) return this.HavayoluKoduGonder(istek);

      return this.$refs.onaydialog
        .open(
          this.hyolKod +
            " kartının " +
            this.hyolHatTanimi.ad.toLocaleLowerCase("tr") +
            " " +
            silinen.join(" ve ") +
            " silinecek. Kart müşterinin TÜM şirketlerinde ortaktır ve bu " +
            "kartla üretilen belgeler kodsuz çıkar. Onaylıyor musunuz?",
          1
        )
        .then((onay) => {
          if (onay !== true) return;
          return this.HavayoluKoduGonder(istek);
        });
    },

    /**
     * Kayit istegini atar ve yanitini isler. HavayoluKoduKaydet'ten AYRI:
     * kod silmede once onay aliniyor ve istek o zaman onaydan SONRA gidiyor;
     * tek govdede kalsaydi onay dali istegi kopyalamak zorunda kalirdi.
     */
    HavayoluKoduGonder(istek) {
      return tool
        .api_post(this, "DisMuhasebeAktarim/HavayoluKodlariKaydet", istek)
        .then(
          () => {
            this.hyolDialog = false;
            this.Uyar("Havayolu tedarikçi kodu kaydedildi.");

            return this.KodlarDegisti(true);
          },
          (response) => {
            // 400 (bos / uzun kod, gecersiz hat) ve 404 (kart yok) metin
            // govdeyle geliyor; mesaji taban cozup OLDUGU GIBI gosteriyor.
            // Pencere ACIK KALIR: kullanici degeri duzeltip yeniden
            // kaydedebilmeli.
            this.Hata(response, istek, "Havayolu tedarikçi kodu kaydedilemedi");
          }
        );
    },

    /**
     * Muhasebe kod ekranini acar ve kodlari yukler.
     *
     * Ekran secili tipin kumesiyle acilir (TIP_AYARLARI kodTur): faturada
     * Satis, maliyette Alis, iadede Satis Iadesi, alis iadesinde Alis
     * Iadesi. Onceki secim hatirlansaydi, maliyet aktaran kullanici satis
     * kodlarini alis sanip duzenleyebilirdi.
     *
     * Istek { IadeDahil: true }: sunucu iade satirlarini listeye YALNIZCA
     * bunu isteyen istemciye ekliyor. Eski paketler (acik kalmis sekme,
     * onbellekteki index.html) satirlari yalnizca AlisMi ile ayiriyor; iade
     * satirlarini alsalardi Satis/Alis kumesinde ayni adla ikinci kez
     * gosterir, oraya yazilan kodu da iade tablosuna gonderirlerdi. Eski
     * sunucu govdeyi yok sayar (iade kodu zaten yok).
     *
     * Iade satirinda MasterKodu null ise JSON'da YOK (NullValueHandling.
     * Ignore); bos metinle tamamlanir ki alan bos bir kutu olarak gorunsun
     * ve kayitta bos (= gelir/gider hesabi kullan) gitsin.
     *
     * kaydetbutonu :action'dan Promise bekledigi icin istek zinciri
     * DONDURULUYOR; yoksa dugme istek surerken pasif kalmaz.
     */
    MuhasebeKodlariAc() {
      this.kodTur = this.gorunumAyari.kodTur;
      this.kodDialog = true;
      this.kodYukleniyor = true;
      this.kodlar = [];

      return tool
        .api_post(this, "DisMuhasebeAktarim/MuhasebeKodListesi", { IadeDahil: true })
        .then(
          (response) => {
            this.kodYukleniyor = false;
            let kodlar = response.data || [];
            kodlar.forEach((k) => {
              if (
                k &&
                muhasebekodturu.IadeTuruMu(muhasebekodturu.SatirBelgeTuru(k)) &&
                (k.MasterKodu === null || k.MasterKodu === undefined)
              )
                k.MasterKodu = "";
            });
            this.kodlar = kodlar;
          },
          (response) => {
            this.kodYukleniyor = false;
            this.Hata(response, {}, "Muhasebe kodları getirilemedi");
          }
        );
    },

    /**
     * Kodlari kaydeder.
     *
     * Ekranda YALNIZCA secili kume gorunuyor ama istek LISTENIN TAMAMINI
     * gonderir. Yalnizca gorunenler gonderilseydi, sunucudaki "gelir kodu
     * bos = satiri sil" kurali yuzunden hat degistirip kaydeden kullanici
     * gormedigi satirlari silerdi.
     *
     * Basarida kalem penceresinden kayitla AYNI tazeleme (KodlarDegisti):
     * cekilmis kalemler eski kodu, maliyet listesi eski uyarilari
     * gosteriyordu.
     *
     * HER satira BelgeTuru yazilir (satirin kendi degeri, yoksa AlisMi'den
     * turetilen): sunucu satiri bununla satis/alis tablosuna ya da iade
     * tablosuna yonlendiriyor. Ekrandaki satirlar DEGISTIRILMEZ, istek
     * kopyalardan kurulur.
     */
    MuhasebeKodlariKaydet() {
      this.kodYukleniyor = true;

      let istek = this.kodlar.map((k) =>
        Object.assign({}, k, { BelgeTuru: muhasebekodturu.SatirBelgeTuru(k) })
      );

      return tool
        .api_post(this, "DisMuhasebeAktarim/MuhasebeKodKaydet", istek)
        .then(
          () => {
            this.kodYukleniyor = false;
            this.kodDialog = false;
            this.Uyar("Muhasebe kodları kaydedildi.");

            return this.KodlarDegisti(false);
          },
          (response) => {
            this.kodYukleniyor = false;
            this.Hata(response, istek, "Muhasebe kodları kaydedilemedi");
          }
        );
    },

    /**
     * Kalem tipinin adi. Sira MuhasebeEntegrasyon.Core.Model.SatirTipi ile
     * AYNI olmali; bilinmeyen tipte numara gosterilir, bos hucre degil.
     */
    KodSatirTipiAdi(tip) {
      // "Vergi / harç": kalem tablosundaki satir sunucunun adiyla
      // (SatirTipiAdi) bu sekilde gorunuyor. Kalem kod penceresi de
      // kombinasyon adini buradan yaziyor; iki yerde iki ayri ad olmasin.
      const adlar = [
        "Bilet bedeli",
        "Vergi / harç",
        "Servis ücreti",
        "Diğer servis",
        "İskonto",
        "Ek saha",
        "KDV masrafı",
        "Özel işlem",
        "Ceza",
        "Alan vergisi",
      ];

      return adlar[tip] || String(tip);
    },

    /**
     * Arama karsilastirmasi icin metni sadelestirir.
     *
     * Turkce harfler duz karsiliklarina indirgeniyor: kullanici "unvan"
     * yazip "ÜNVAN" bulabilsin. toLowerCase tek basina yetmiyor - "I" ve
     * "İ" JavaScript'te Turkce kurallarina gore donmuyor ve
     * toLocaleLowerCase("tr") de ters yonde ("ISTANBUL" -> "ıstanbul")
     * kullaniciyi sasirtiyor.
     */
    AramaAnahtari(metin) {
      if (metin === null || metin === undefined) return "";

      const esler = {
        İ: "i", I: "i", ı: "i",
        Ş: "s", ş: "s",
        Ğ: "g", ğ: "g",
        Ü: "u", ü: "u",
        Ö: "o", ö: "o",
        Ç: "c", ç: "c",
      };

      return String(metin)
        .replace(/[İIıŞşĞğÜüÖöÇç]/g, (h) => esler[h])
        .toLowerCase()
        .trim();
    },

    /**
     * Listeyi durum suzgecine ("T" / "N" / "A") ve SADELESTIRILMIS aramaya
     * (AramaAnahtari'ndan gecmis) gore suzer. Sayac (suzulmusFaturalar) ile
     * tablo (TabloSuz) bu TEK kurali kullanir.
     *
     * Aranan alanlar acikca sayili ve tipe gore (TIP_AYARLARI
     * aramaAlanlari); ekrandaki arama etiketiyle ayni liste. Hicbir suzgec
     * yoksa listenin KENDISI doner: gereksiz kopya tabloyu her cizimde
     * yeniden hesaplatirdi.
     */
    ListeyiSuz(liste, durum, a) {
      if (!a && durum === "T") return liste;

      let alanlar = this.gorunumAyari.aramaAlanlari;

      return liste.filter((f) => {
        if (durum === "A" && !f.EntegreEdildi) return false;
        if (durum === "N" && f.EntegreEdildi) return false;

        if (!a) return true;

        return alanlar.some((alan) => this.AramaAnahtari(f[alan]).indexOf(a) >= 0);
      });
    },

    /**
     * Tablonun custom-filter'i: Vuetify (items, search, filter, headers)
     * ile cagirir. search, tabloSuzgeci'nin "durum|arama" degeridir; ilk "|"
     * isaretinden bolunur (aramanin kendisi "|" icerebilir).
     *
     * Vuetify fonksiyonu tablonun this'iyle cagiriyor; Vue metotlari
     * sayfaya bagli oldugu icin this yine sayfadir.
     */
    TabloSuz(items, search) {
      let metin = search === null || search === undefined ? "" : String(search);
      let ayrac = metin.indexOf("|");
      if (ayrac < 0) return items;

      return this.ListeyiSuz(items, metin.slice(0, ayrac), metin.slice(ayrac + 1));
    },

    /**
     * Atlanan satirin neden kodu. Sayi olmayan, 0 ya da eksik kod 0
     * ("nedeni bildirilmedi") sayilir.
     */
    AtlananNedenKodu(atlanan) {
      let kod = Number(atlanan ? atlanan.NedenKodu : 0);
      return Number.isInteger(kod) && kod > 0 ? kod : 0;
    },

    /**
     * Neden kodunun ekrandaki adi, secili tipin tablosundan (maliyet ve
     * iade kodlari ayni sayilarla farkli nedenler). Bilinmeyen kod
     * (sunucuya sonradan eklenmis bir neden) numarasiyla yazilir; ayrintisi
     * ornek numaranin ipucunda.
     */
    AtlananNedenAdi(kod) {
      if (!kod) return ATLANAN_NEDEN_YOK;

      let adlar = this.gorunumAyari.nedenAdlari;
      return (
        (Object.prototype.hasOwnProperty.call(adlar, kod) && adlar[kod]) ||
        "başka bir neden (kod " + kod + ")"
      );
    },

    /**
     * Satir ayrinti penceresini acar ve kalemleri ceker.
     *
     * Kalemler liste yanitinda GELMIYOR: bir aylik listede 337 faturaya
     * karsilik 1873 kalem cikiyor ve bunlarin ezici cogunlugu hic
     * acilmiyor. Uc, faturanin kendi gunune daraltilmis bir sorgu
     * calistiriyor. Maliyet belgesi de ayni yoldan: kalemleri tek biletin
     * satis gunune daraltilmis ayri bir uctan geliyor. Iade dekontu ise
     * gune DARALTILMAZ: IadeKalemleri dekontu listenin istegiyle (Hat,
     * tarih araligi, havayolu, Tur; bkz. KalemIstegi) yeniden kurar, cunku
     * bir dekont gun asabilir ve havayolu suzgeci satirlarini degistirir.
     *
     * Bir kez cekilen kalemler satir nesnesinde SAKLANIR; ayni satir
     * tekrar acildiginda istek atilmaz. Liste tazelendiginde nesneler
     * yenilendigi icin onbellek de kendiliginden dusuyor.
     */
    SatirlariAc(fatura) {
      this.satirFatura = fatura;
      this.satirDialog = true;

      if (fatura.Satirlar) return Promise.resolve();

      return this.KalemleriCek(fatura);
    },

    /**
     * Bir satirin kalemlerini sunucudan ceker ve nesnesine yazar.
     *
     * Istek KalemIstegi'nden: satirin secim anahtari (+ maliyette Hat ve
     * BspHaric; iadede listenin Hat'i, tarih araligi, havayolu ve Tur). Uc
     * secili tipten gelir.
     *
     * Yanit geldiginde pencere BASKA bir satira gecmis olabilir; kalemler
     * yine de kendi satirina yaziliyor, gosterim ise Vue'nun tepkimesine
     * birakiliyor.
     */
    KalemleriCek(fatura) {
      let uclar = this.uclar;
      if (!uclar) return Promise.resolve();

      this.kalemYukleniyor = true;

      let istek = this.KalemIstegi(fatura);

      return tool
        .api_post(this, uclar.kalem, istek)
        .then(
          (response) => {
            this.kalemYukleniyor = false;
            // $set: alan fatura nesnesinde YOK, dogrudan atama tepkimeli
            // olmazdi ve pencere bos kalirdi.
            this.$set(fatura, "Satirlar", response.data || []);
          },
          (response) => {
            this.kalemYukleniyor = false;
            this.Hata(response, istek, "Kalemler alınamadı");
          }
        );
    },


    /**
     * Carinin duzenleme sayfasi adresi.
     *
     * Rota /cari/duzenle/:id (router.js'te "duzenle"). Hesap kodu
     * encodeURIComponent'ten geciriliyor cunku kod "/" icerebiliyor ve
     * bolunmemis bir "/" rotayi ikiye bolerdi. Projede ayni is
     * cari/goster.vue'da val.replace("/", "%2f") ile yapiliyor; oradaki
     * kalip yalnizca ILK "/" isaretini degistirdigi icin burada
     * kullanilmadi.
     *
     * KOD alir, satir DEGIL: ayni baglanti dort tabloda birden kullaniliyor
     * (fatura CariKod, maliyet MusteriKodu, iade CariKod ve MusteriKodu) ve
     * her tablonun alan adi ayni degil. Tedarikci kodu buraya VERILMEZ: o,
     * havayolu kartindaki Logo hesap kodudur, ArkmanNext carisi degil.
     */
    CariAdresi(kod) {
      return "#/cari/duzenle/" + encodeURIComponent(kod);
    },

    /**
     * Hat etiketi: tam olarak "I" ic hat, tam olarak "B" BSP, KALAN HER SEY
     * dis hat. uzun = true ise pencere basliklarinin bicimi ("İç hat").
     *
     * KURAL AKTARIMINKIYLE BIREBIR: AlisFaturaDonusturucu.IcHatMi kirpmiyor
     * ve buyuk / kucuk harfe bakmiyor (icDis == "I"). Ekran daha hosgorulu
     * olsaydi bir satiri "İç" gosterir, aktarim onu dis hat alanlarindan
     * (Reserved7/8) okurdu.
     *
     * BSP AYRI GOSTERILIR: B_Ic_Dis / I_Ic_Dis alaninin ucuncu degeri "B"
     * ve eskiden "Dış" diye gorunuyordu. Hat olarak dis hattir, farki
     * KARTTADIR (bkz. HatIpucu). Kisa ve uzun bicimi AYNI: "BSP hat" diye
     * bir sey yok.
     *
     * Esleme TEK YERDE: yedi ayri yerde (uc tablo hucresi, uc satir
     * penceresi basligi, kalem kod penceresi) ayni ternary yaziliydi ve
     * biri degistiginde otekiler sessizce ayrisirdi.
     */
    HatAdi(icDis, uzun) {
      if (icDis === "I") return uzun ? "İç hat" : "İç";
      if (icDis === "B") return "BSP";
      return uzun ? "Dış hat" : "Dış";
    },

    /**
     * Hat hucresinin ipucu; YALNIZCA BSP satirinda dolu.
     *
     * BSP bileti hat olarak dis hattir - tedarikci kodlari Reserved7/8'den
     * okunur - ama KART farklidir: BSP_TEKHESAP_YAZ acikken (uretimde hep
     * acik) kodlar havayolunun kendi kartindan degil sabit "BS" kartindan
     * gelir. Ozet bunu ayri bir alanda tasiyor (HavayoluKartKodu) ve
     * tedarikci hucresindeki kalem simgesi o karti aciyor; ipucu ikisi
     * arasindaki bagi kuruyor.
     *
     * Bos metin donmek ONEMLI: tarayici bos title'da ipucu gostermez,
     * yani ic / dis hat satirlarinda bos bir kutucuk cikmaz.
     */
    HatIpucu(icDis) {
      return icDis === "B"
        ? "BSP bileti: tedarikçi kodları dış hat alanlarından (Reserved7/8) " +
          "ve BS kartından okunur."
        : "";
    },

    /**
     * Iade satirinin KARSI TARAF kodu: satis iadesinde musterinin carisi
     * (Iade.Carikod), alis iadesinde havayolunun tedarikci carisi
     * (Havayolu.Reserved5 / Reserved7 -> TedarikciKod).
     *
     * Tek yerde toplandi cunku ayni hucre hem metni hem cari kart
     * baglantisini kuruyor; iki yerde ayri ayri yazilsaydi biri
     * degistirilip oteki unutulunca baglanti baska bir kodu acardi.
     */
    IadeKarsiTaraf(satir) {
      return this.alisIadeMi ? satir.TedarikciKod : satir.CariKod;
    },

    /**
     * Faturanin e-Fatura detay sayfasi adresi.
     *
     * Projedeki diger listelerle ayni bicim (bkz. faturalistesi.vue):
     *   #/fatura/faturadetay/id?guid=<GUID>&creditnote=<0|1>
     *
     * creditnote burada her zaman 0: bu ekran satis faturalarini listeliyor,
     * iade/alacak dekontu ayri bir islem tipi.
     */
    FaturaDetayAdresi(fatura) {
      return (
        "#/fatura/faturadetay/id?guid=" +
        encodeURIComponent(fatura.EFaturaGuid) +
        "&creditnote=0"
      );
    },

    /**
     * Maliyet ve iade satirinin bilet ekrani adresi.
     *
     * Adres bicimi kalemtablosu'ndaki BiletAdresi'nden geliyor (tek kaynak);
     * maliyet ve iade ozetinde ucus tipi IcDis adini tasidigi icin burada
     * eslestiriliyor. Iadede IcDis dekontun ACILIS satirinin ham I_Ic_Dis
     * degeri.
     */
    MaliyetBiletAdresi(belge) {
      return kalemtablosu.methods.BiletAdresi(this.MaliyetBiletParcalari(belge));
    },

    /** Bilet ekrani acilabilir mi; kural yine kalemtablosu'nda. */
    MaliyetBiletAcilabilir(belge) {
      return kalemtablosu.methods.BiletAcilabilir(
        this.MaliyetBiletParcalari(belge)
      );
    },

    MaliyetBiletParcalari(belge) {
      return {
        HavayoluKodu: belge.HavayoluKodu,
        BiletNo: belge.BiletNo,
        UcusTipi: belge.IcDis,
      };
    },

    /**
     * Bir satirin sunucudaki kimligi, secili tipe gore.
     *
     * Fatura: seri + no + TARIH. Fatura numaralari her yil basa dondugu
     * icin seri + no tek basina tekil degil; yil sinirini asan bir aralikta
     * ayni seri/numaraya sahip iki fatura olabilir ve tarih olmadan
     * kullanicinin secmedigi fatura da aktarilip damgalanirdi.
     *
     * Maliyet: havayolu + bilet no + SATIS tarihi + Anahtar. Belge bilet
     * basina bir tane; satis faturasi seri/no burada kullanilamaz, cunku bir
     * faturada cok bilet olur ve faturalanmamis biletlerde bos gelir.
     * Anahtar sunucunun liste satirina verdigi tam kimlik ("|n" ekiyle):
     * ayni havayolu / bilet no / gunden iki belge cikarsa (kirli veri) taban
     * alanlar ikisini ayirmiyor - biri secilince ikisi de aktarilip
     * damgalaniyor, ikincinin kalemleri birincinin kalemleri gorunuyordu.
     * Sunucu Anahtar varsa onunla, yoksa taban alanlarla eslestiriyor.
     *
     * Iade: Anahtar + DekontNo + IADE tarihi (acilis satirinin Iade_Tar'i).
     * Dekont numarasi da tek basina tekil degil (ayni numara farkli gunde);
     * tarih sunucudan geldigi gibi, saatiyle birlikte gider.
     *
     * Alanlar ve sirasi TIP_AYARLARI secimAlanlari'nda. Kalem istegi de ayni
     * kimligi kullanir (bkz. KalemIstegi).
     */
    SecimAnahtari(satir) {
      let secim = {};

      this.gorunumAyari.secimAlanlari.forEach((alan) => {
        secim[alan] = satir[alan];
      });

      return secim;
    },

    /** Secili satirlari sunucunun bekledigi hafif kimlige cevirir. */
    Secimler() {
      return this.secilenler.map((s) => this.SecimAnahtari(s));
    },

    /**
     * Bir satirin kalem isteginin govdesi.
     *
     * Fatura: secim anahtari. Maliyet: secim anahtari + LISTEYI URETEN
     * suzgeclerin Hat ve BspHaric'i. Sunucu kalemleri belgeyi yeniden
     * kurarak uretiyor; suzgecsiz (Hat=Hepsi, BSP dahil) kurulan belge
     * listelenen / aktarilan belgeden farkli kalem tasiyabiliyordu. Form
     * degil anlik goruntu: kullanici listeledikten sonra Hat'i degistirmis
     * olabilir. Anlik goruntu yoksa (liste hic cekilmemis) form kullanilir.
     *
     * Iade: secim anahtari + listenin Hat'i, tarih araligi (BaslangicTarihi,
     * BitisTarihi) ve havayolu (HavayoluKodu) + Tur. Sunucu dekontu listeyle
     * AYNI istekle kuruyor; yalnizca Hat gonderilince dekont tek gunde ve
     * havayolusuz kuruluyor, pencere aktarilmayacak baska havayolu satirlarini
     * gosterip gun sinirini asan dekontun ikinci gununu gostermiyordu. Degerler
     * anlik goruntuden OLDUGU GIBI kopyalanir: tarihler liste istegindeki
     * bicimde, havayolu Filtreler()'in kirpilmis / null degeri.
     *
     * Fatura tarihli maliyet (MF): secim anahtari + Hat ve BspHaric + SATIRIN
     * FaturaTarihi'si + TarihOlcutu. Sunucu o olcutte dar kosuyu FATURA gunune
     * uyguluyor; alan gitmezse satis gunune dusuyor ve fatura gunu satis
     * gununden farkli bilette pencere BOS aciliyordu
     * (MaliyetKalemIstegi.FaturaTarihi).
     *
     * Hangi suzgeclerin eklendigi TIP_AYARLARI kalemSuzgecleri'nde, satirdan
     * kopyalanan alanlar kalemSatirAlanlari'nda.
     */
    KalemIstegi(satir) {
      let istek = this.SecimAnahtari(satir);

      // Suzgec DEGIL, belgenin kendi degeri: anlik goruntuden degil satirdan
      // gelir.
      this.gorunumAyari.kalemSatirAlanlari.forEach((alan) => {
        istek[alan] = satir[alan];
      });

      let alanlar = this.gorunumAyari.kalemSuzgecleri;
      if (alanlar.length > 0) {
        let filtre = this.listeFiltresi || this.Filtreler();
        alanlar.forEach((alan) => {
          // BspHaric her zaman boolean gitsin (eski anlik goruntude eksik
          // olabilir).
          istek[alan] =
            alan === "BspHaric" ? filtre[alan] === true : filtre[alan];
        });
      }

      // Istek eki (Tur / TarihOlcutu) suzgeci olmayan tipte de gitmeli.
      return this.IstekEkiEkle(istek);
    },

    /**
     * Basarisiz istek. 500'de taban ayrintili dialogu acar (sunucunun tam
     * yaniti + gonderilen istek + Arkman'a bildirme dugmesi); digerlerinde
     * kisa mesaji snackbar'da gosterir.
     */
    Hata(cevap, istek, baslik) {
      // Istek surerken sayfadan cikilmis olabilir; o zaman taban da yok,
      // gosterilecek bir ekran da. Korumasiz birakilirsa asil hatanin
      // uzerine TypeError biniyor ve konsolda gercek sebep kayboluyor.
      var taban = this.$refs ? this.$refs.taban : null;
      if (!taban) return;

      taban.Hata(cevap, istek, baslik);
    },

    /**
     * Sunucunun GERCEKTEN yazdigi fatura sayisi.
     *
     * Secili satir sayisi kullanilmamali: sunucu secilen bir faturayi
     * araliktan dusmus bulabilir ve daha azini aktarabilir. Gercek sayi
     * X-Fatura-Sayisi basliginda geliyor; baslik okunamazsa secim sayisina
     * dusulur ki mesaj hic cikmamaktansa yaklasik ciksin.
     */
    AktarilanFaturaSayisi(response) {
      let sayi = this.BaslikSayisi(response, "X-Fatura-Sayisi");

      return sayi === null ? this.secilenler.length : sayi;
    },

    /**
     * Yanit basligindaki tam sayi; baslik yoksa ya da okunamazsa null.
     *
     * null ile 0 ayri tutuluyor: sunucunun yazdigi SIFIR gercek bir bilgi
     * ("hic belge aktarilmadi"), yok sayilirsa mesaj yanlis sayiya duser.
     */
    BaslikSayisi(response, ad) {
      try {
        var sayi = parseInt(response.headers.get(ad), 10);
        if (!isNaN(sayi)) return sayi;
      } catch (e) {
        // baslik okunamadi
      }

      return null;
    },

    /**
     * Aktarim sonrasi mesaj; ayar aktarimin YAPILDIGI tipin ayari.
     *
     * Fatura mesaji ONCEKI haliyle ayni (ayar.damga null). Maliyette bir
     * belge ile damgalanan bilet sayisi ayni sey degil (S ve Ia satirlari
     * tek belgede birlesiyor); iadede bir dekont birden cok Iade kaydini
     * damgaliyor. Bu yuzden damgalanan kayit sayisi (X-Damgalanan-Bilet)
     * tipin sozcuguyle ayrica yazilir; sunucu uyari bildirdiyse o da eklenir
     * ki kullanici dosyayi kontrol etsin.
     */
    AktarimMesaji(response, isaretle, ayar) {
      let sayi = this.AktarilanFaturaSayisi(response);

      if (!ayar || !ayar.damga) {
        return isaretle
          ? sayi + " fatura aktarıldı ve işaretlendi."
          : sayi + " fatura aktarıldı; işaret KONULMADI.";
      }

      let ad = ayar.sozcukler.ad;
      let metin;
      if (isaretle) {
        let damga = this.BaslikSayisi(response, "X-Damgalanan-Bilet");
        metin =
          sayi +
          " " +
          ad +
          " aktarıldı ve işaretlendi" +
          (damga === null ? "." : " (" + damga + " " + ayar.damga + " damgalandı).");
      } else {
        metin = sayi + " " + ad + " aktarıldı; işaret KONULMADI.";
      }

      return metin + this.UyariEki(response);
    },

    /** Sunucu uyari bildirdiyse mesajin sonuna eklenen cumle; yoksa bos. */
    UyariEki(response) {
      let uyari = this.BaslikSayisi(response, "X-Uyari-Sayisi");
      return uyari > 0 ? " Aktarımda " + uyari + " uyarı oluştu." : "";
    },

    /**
     * Yanit basligindaki metin, kirpilmis; baslik yoksa, bossa ya da
     * okunamazsa null.
     */
    BaslikMetni(response, ad) {
      try {
        let deger = response.headers.get(ad);
        if (deger === null || deger === undefined) return null;

        deger = String(deger).trim();
        return deger === "" ? null : deger;
      } catch (e) {
        return null;
      }
    },

    /**
     * Dosya uretilip damga konamadiginda (X-Damga-Hatasi) gosterilen mesaj.
     *
     * Sunucu damgalamayi tek islemde yapiyor: hata varsa HICBIR belge
     * isaretlenmedi, ama dosya kullanicinin elinde. Asil risk, belgeleri
     * listede hala "Aktarılmadı" goren kullanicinin dosyayi muhasebe
     * programina aldiktan sonra ayni belgeleri ikinci kez gondermesi; mesaj
     * bunu acikca soyler. Sunucu mesajinin sonundaki nokta atilir, cumle
     * ikinci noktayla bitmesin.
     */
    DamgaHatasiMesaji(response, hata) {
      let s = this.belgeSozcukleri;
      let mesaj = String(hata).replace(/[.\s]+$/, "");

      return (
        "Dosya üretildi ama " +
        s.cogul +
        " işaretlenemedi: " +
        mesaj +
        ". Aynı " +
        s.belirtme +
        " tekrar aktarmadan önce muhasebe programına aktarılıp aktarılmadığını kontrol edin." +
        this.UyariEki(response)
      );
    },

    /** Kisa bilgi mesaji; snackbar'i taban ciziyor. */
    Uyar(metin) {
      this.durum.text = metin;
      this.durum.show = true;
    },

    /**
     * Secili tipin listesini FORMDAKI suzgeclerle ceker; onceki secim
     * birakilir. Asil is ListeIste'de.
     */
    Listele() {
      return this.ListeIste(this.Filtreler(), false);
    },

    /**
     * Ekrandaki listeyi, onu URETEN suzgeclerle (listeFiltresi) yeniden
     * ceker ve SECIMI KORUR. Kod kaydindan sonra kullaniliyor: kullanici
     * formu listeledikten sonra degistirmis olabilir, tazeleme baska bir
     * liste getirmemeli; sectiklerini de kaybetmemeli.
     *
     * Liste hic cekilmemisse istek atilmaz.
     */
    ListeyiTazele() {
      if (!this.listeFiltresi) return Promise.resolve();
      return this.ListeIste(this.listeFiltresi, true);
    },

    /**
     * Liste istegini atar ve yaniti yazar.
     *
     * koru false: istek atilirken secim bosaltilir (Listele).
     * koru true : secim ve acik satir penceresi yeni satirlara tasinir
     *             (bkz. SecimiTasi).
     *
     * GEC YANIT: istek surerken tip degisebilir (Temizle) ya da yeni bir
     * liste istegi atilabilir (tazeleme surerken Listele). Sira numarasi ya
     * da tip degismisse yanit HIC ISLENMEZ - basari da hata da: yazilsaydi
     * fatura satirlari maliyet basliklariyla cizilir ya da eski suzgecin
     * listesi yenisinin uzerine yazilirdi; hata dali ise yeni listeyi
     * silerdi.
     */
    ListeIste(istek, koru) {
      let uclar = this.uclar;
      let ayar = this.tipAyari;
      if (!ayar || !uclar) return Promise.resolve();

      let tip = this.tip;
      let no = (this.listeIstekNo += 1);
      let eski = () => this.tip !== tip || this.listeIstekNo !== no;

      this.yukleniyor = true;
      if (!koru) this.secilenler = [];

      return tool.api_post(this, uclar.liste, istek).then(
        (response) => {
          if (eski()) return;
          this.yukleniyor = false;

          if (ayar.zarf) {
            // Maliyet ve iade yaniti bir zarf: belgeler + atlanan kayitlar.
            // Alan adlari tipe gore (ayar.zarf). Atlananlar ve
            // GenelUyarilar eski maliyet yanitinda YOK; dizi degilse bos
            // sayilir. Iadede numara listesi yok, numaralar Atlananlar'da.
            let a = ayar.zarf;
            let zarf = response.data || {};
            this.faturalar = zarf[a.belgeler] || [];
            this.atlananBiletSayisi = Number(zarf[a.atlananSayisi]) || 0;
            this.atlananBiletler = (a.atlananNumaralari && zarf[a.atlananNumaralari]) || [];
            this.atlananlar = Array.isArray(zarf.Atlananlar) ? zarf.Atlananlar : [];
            this.genelUyarilar = Array.isArray(zarf.GenelUyarilar)
              ? zarf.GenelUyarilar.filter((u) => u && String(u).trim())
              : [];
          } else {
            this.faturalar = response.data || [];
          }

          // Liste bu filtrelerle uretildi; aktarim da bunlari kullanacak.
          this.listeFiltresi = istek;
          if (this.faturalar.length === 0) this.Uyar(ayar.bosListeMesaji);

          return koru ? this.SecimiTasi() : undefined;
        },
        (response) => {
          if (eski()) return;
          this.yukleniyor = false;
          this.faturalar = [];
          this.listeFiltresi = null;
          // Listeye ait bilgiler de: bos tablonun ustunde ONCEKI listenin
          // atlanan biletleri ve uyarilari kalmasin.
          this.atlananBiletSayisi = 0;
          this.atlananBiletler = [];
          this.atlananlar = [];
          this.genelUyarilar = [];
          if (koru) {
            // Liste gitti: korunacak secim de, pencerenin gosterecegi
            // guncel satir da yok.
            this.secilenler = [];
            this.satirDialog = false;
            this.satirFatura = null;
          }
          this.Hata(response, istek, "Liste alınamadı");
        }
      );
    },

    /**
     * Tazelemeden sonra secimi ve acik satir penceresini YENI satir
     * nesnelerine tasir; eslestirme tablonun anahtariyla (maliyette
     * Anahtar).
     *
     * Eski nesneler birakilamaz: aktarim secimi yeni listeden gondermeli ve
     * pencere yeni belgenin Uyarilar'ini gostermeli. Yeni listede olmayan
     * secim duser. Pencerenin satiri yeni listede yoksa pencere kapanir -
     * eski veriyi guncelmis gibi gostermesin; varsa pencere yeni satira
     * gecer ve (aciksa) kalemleri yeniden cekilir, cunku yeni nesnede
     * kalem yok.
     *
     * Anahtari bos satir eslesmez; ayni anahtarli iki satirda ilki alinir.
     */
    SecimiTasi() {
      let anahtar = this.tabloAnahtari;
      let dizin = {};

      this.faturalar.forEach((f) => {
        let k = f[anahtar];
        if (k === null || k === undefined || k === "") return;
        if (!Object.prototype.hasOwnProperty.call(dizin, k)) dizin[k] = f;
      });

      let bul = (eski) =>
        eski && Object.prototype.hasOwnProperty.call(dizin, eski[anahtar])
          ? dizin[eski[anahtar]]
          : null;

      let secim = [];
      this.secilenler.forEach((s) => {
        let yeni = bul(s);
        if (yeni && secim.indexOf(yeni) < 0) secim.push(yeni);
      });
      this.secilenler = secim;

      if (!this.satirFatura) return Promise.resolve();

      let pencereSatiri = bul(this.satirFatura);
      if (!pencereSatiri) {
        this.satirDialog = false;
        this.satirFatura = null;
        return Promise.resolve();
      }

      this.satirFatura = pencereSatiri;
      return this.satirDialog ? this.KalemleriCek(pencereSatiri) : Promise.resolve();
    },

    /**
     * Aktarim secenek penceresini acar. Istek ATMAZ.
     *
     * Isaretleme secenegi her aciliste ACIK basliyor: olagan kullanim
     * aktarip damgalamak. Onceki secim hatirlansaydi, bir kez damgasiz
     * cikti alan kullanici sonraki gercek aktarimda faturalari
     * damgalamayi kacirirdi.
     */
    AktarimiAc() {
      if (this.secilenler.length === 0) return;

      this.aktarimIsaretle = true;
      // TL secenegi de her aciliste varsayilanina doner; ayni gerekce.
      this.aktarimTlAktar = true;
      this.aktarimDialog = true;
    },

    /**
     * Secilen faturalari / maliyet belgelerini aktarir.
     *
     * Isaret ile dosya BIRBIRINDEN BAGIMSIZ: sunucu dosyayi her durumda
     * uretiyor, Isaretle yalnizca damgayi belirliyor (dosya damgadan ONCE
     * uretiliyor, uretim basarisizsa hicbir sey isaretlenmiyor).
     *
     * Satis tarihli maliyette TlAktar da gider; faturada, iadede ve fatura
     * tarihli maliyette bu alan yok ve gonderilmez (ayar.tlAktar). Iadede
     * Tur, fatura tarihli maliyette TarihOlcutu anlik goruntuyle zaten
     * gidiyor; yine de ayardan yeniden yazilir (bkz. IstekEkiEkle).
     *
     * DAMGA HATASI: sunucu dosyayi urettikten sonra damgalama basarisiz
     * olursa yine 200 + dosya dondurur ve X-Damga-Hatasi basligini koyar
     * (damga tek islemde; hicbir belge isaretlenmemistir). O zaman dosya
     * YINE indirilir (kaybolmasin), liste TAZELENMEZ (secim dursun; belgeler
     * zaten "Aktarılmadı") ve kullaniciya ayni belgeleri tekrar gondermeden
     * once muhasebe programini kontrol etmesi soylenir - snackbar'da ve
     * kapatilana kadar duran bir uyarida (damgaHatasi).
     */
    Aktar() {
      if (this.secilenler.length === 0) return Promise.resolve();

      // Formun o anki degerleri DEGIL, listeyi ureten filtreler.
      if (!this.listeFiltresi) return Promise.resolve();

      let uclar = this.uclar;
      let ayar = this.tipAyari;
      if (!uclar || !ayar) return Promise.resolve();

      let isaretle = this.aktarimIsaretle;

      let istek = this.IstekEkiEkle(Object.assign({}, this.listeFiltresi));
      istek.Secimler = this.Secimler();
      if (ayar.tlAktar) istek.TlAktar = this.aktarimTlAktar === true;
      istek.Hedef = 0; // Logo. Sunucu digerlerini henuz kabul etmiyor.
      istek.Isaretle = isaretle;

      // Onceki aktarimin damga uyarisi bu aktarimin sonucu sanilmasin.
      this.damgaHatasi = "";

      return tool
        .api_post_FileDownload(this, uclar.aktar, istek)
        .then(
          (response) => {
            this.aktarimDialog = false;
            tool.CreateDownloadLink(response, uclar.dosya);

            let damgaHatasi = this.BaslikMetni(response, "X-Damga-Hatasi");
            if (damgaHatasi !== null) {
              this.damgaHatasi = this.DamgaHatasiMesaji(response, damgaHatasi);
              this.Uyar(this.damgaHatasi);
              return Promise.resolve();
            }

            this.Uyar(this.AktarimMesaji(response, isaretle, ayar));

            // Liste yalnizca damga degistiyse tazeleniyor: aksi halde
            // listede degisen bir sey yok ve tazeleme secimi de siliyor -
            // kullanici ayni secimle baska bir cikti almak isteyebilir.
            return isaretle ? this.Listele() : Promise.resolve();
          },
          (response) => {
            this.Hata(response, istek, "Aktarım yapılamadı");
          }
        );
    },

    /**
     * Secilenlerin aktarim damgasini kaldirir; once onay alinir.
     *
     * Fatura ucu yalnizca tarih araligini ve secimi istiyor. Maliyet ve iade
     * uclarinin sozlesmesi liste isteginin TAMAMINI + secimi istiyor (Hat,
     * havayolu, BspHaric / Tur dahil), bu yuzden anlik goruntu oldugu gibi
     * gider (ayar.geriAlTumSuzgec).
     *
     * Sunucu kac kaydin damgasinin kalktigini soyluyorsa (maliyette
     * EtkilenenBilet, iadede EtkilenenSatir; ayar.etkilenen) mesajda
     * yazilir: belge ile kayit sayisi ayni olmayabilir.
     */
    GeriAl() {
      if (this.secilenler.length === 0) return Promise.resolve();
      if (!this.listeFiltresi) return Promise.resolve();

      let uclar = this.uclar;
      let ayar = this.tipAyari;
      if (!uclar || !ayar) return Promise.resolve();

      // Suzgecte gorunmeyen secimler de gidiyor; onay metninde soylenir.
      let gizli = this.gizliSecimSayisi;

      // Damgayi kaldirmak kayit degistiren bir islem; once onay alinir.
      return this.$refs.onaydialog
        .open(
          this.secilenler.length +
            " " +
            this.belgeSozcukleri.tamlayan +
            " aktarım işareti kaldırılacak" +
            (gizli > 0 ? " (" + gizli + " tanesi şu anki süzgeçte görünmüyor)" : "") +
            ". Onaylıyor musunuz?",
          1
        )
        .then((onay) => {
          if (onay !== true) return;

          // Tarihler de listeyi ureten anlik goruntuden; sunucu damgayi
          // bu aralik icinde ariyor.
          let geriAlIstegi = ayar.geriAlTumSuzgec
            ? Object.assign(this.IstekEkiEkle(Object.assign({}, this.listeFiltresi)), {
                Secimler: this.Secimler(),
              })
            : {
                BaslangicTarihi: this.listeFiltresi.BaslangicTarihi,
                BitisTarihi: this.listeFiltresi.BitisTarihi,
                Secimler: this.Secimler(),
              };

          return tool
            .api_post(this, uclar.geriAl, geriAlIstegi)
            .then(
              (response) => {
                let e = ayar.etkilenen;
                let etkilenen =
                  e && response && response.data ? Number(response.data[e.alan]) : NaN;

                this.Uyar(
                  isNaN(etkilenen)
                    ? "Aktarım işareti kaldırıldı."
                    : "Aktarım işareti kaldırıldı (" + etkilenen + " " + e.sozcuk + ")."
                );
                return this.Listele();
              },
              (response) => {
                this.Hata(response, geriAlIstegi, "İşaret kaldırılamadı");
              }
            );
        });
    },
  },
};
</script>

<style scoped>
/* Tipe gore dagilim seridi: tek bakista hangi kalemin agir bastigini
   gosterir. Vuetify'nin renk siniflari parcalara class olarak veriliyor,
   burada yalnizca gecmis/olcu tanimlaniyor. */
.satir-serit {
  display: flex;
  width: 100%;
  height: 14px;
  border-radius: 7px;
  overflow: hidden;
  background: #eee;
}

.satir-serit-parca {
  height: 100%;
}

/* Atlanan bilet ornegi: ipucunda (title) satirin ayrintili nedeni var. */
.atlanan-ornek {
  cursor: help;
  border-bottom: 1px dotted currentColor;
}

/* Aktar / Geri Al pasifken: Vuetify'nin varsayilani yazi rgba(0,0,0,.26),
   zemin rgba(0,0,0,.12) - beyaz kartta kontrast ~1.4 ve dugme GORUNMUYOR
   sanilıyor. Secim yapilincaya kadar da dugmenin orada oldugu bilinmeli,
   bu yuzden pasif halde cerceveli ve daha koyu yaziyla gosteriliyor.
   Vuetify kurali !important tasidigi icin burada da gerekiyor. */
.theme--light.v-btn.v-btn--disabled.aktarim-dugmesi:not(.v-btn--icon):not(.v-btn--flat):not(.v-btn--outline) {
  background-color: transparent !important;
  color: rgba(0, 0, 0, 0.54) !important;
  border: 1px solid rgba(0, 0, 0, 0.38);
}

.theme--light.v-btn.v-btn--disabled.aktarim-dugmesi .v-icon {
  color: rgba(0, 0, 0, 0.54) !important;
}

/* ------------------------------------------------------------------
   Ana liste: yatay kaydirma cubugunu kaldiran daraltma

   Liste islem tipine gore 12-17 kolon cikariyor (en genisi MF: 16 baslik
   + secim kutusu) ve Vuetify'nin varsayilanlariyla 2254.59px eninde
   olculdu (alis iadesi 2135.40, iade 2139.28, maliyet 1956.19, fatura
   1423.82). 1280'lik ekranda kullanilabilir alan 1020px (1280 - 245 menu
   - 15 dikey cubuk), yani MF'de 1235px tasma; 1920'de bile 595px tasip
   yatay cubuk cikariyordu. Yani sorun ekranin kucuklugu degil tablonun
   kendi eni: cubugun kalkmasi icin 2515px'lik bir pencere gerekiyordu
   (olculdu: 2514'te 2px tasma, 2515'te 0).

   Once GORUNMEYEN israf temizleniyor, veri en son kirpiliyor: 2254.59px'in
   611.91px'i yalnizca hucre yan boslugu (17 kolon x 2 x 18px - stil
   kapaliyken tabloya YALNIZCA dolgu kurali eklenince 2254.59 -> 1642.68
   olculdu), geri kalani da v-btn ile v-chip'in kendi asgari olculeri.

   Bu blok bittiginde olculen: MF tablosu 2254.59 -> 1179.45px, iade ve
   alis iadesi 1178.04, maliyet 1027.17, fatura 809.83. Satir yuksekligi
   bes tipte de 48px (stil kapaliyken iade/fatura satirlari 97.9 - 137.33px
   araligindaydi, cunku unvan uc satira boluniyordu).

   ESIK: tablonun 1179.45px'lik ASGARI eni kabine sigdigi anda cubuk
   kalkiyor, yani pencere >= 1179.45 + 245 + 15. Olculdu: 1438'de 1px
   tasma var, 1439 ve 1440'ta 0. Bunun altinda kalan genisliklerde is
   asagidaki MEDYA SORGUSUNA devrediliyor (bkz. blogun sonu).

   Kurallar .aktarim-tablosu'na BAGLI: global v-data-table'a yazilsaydi
   uygulamadaki onlarca listeyi sessizce degistirirdi.

   >>> SART: stil scoped ama th / td VDataTable'in KENDI sablonunda
   uretiliyor, scoped niteligi (data-v-...) onlara islenmiyor - ".aktarim-
   tablosu th" seklindeki duz bir scoped kural HIC tutmaz. Ayni derin
   secici deseni fatura/copergelenfatura.vue:3649 ve coper/raporlar/
   transferoperasyon.vue:3044,3143,3147'de de kullaniliyor. (Kardes dosya
   entegrasyon/kalemtablosu.vue burada EMSAL DEGIL: orada >>> hic gecmiyor,
   cunku o bilesen v-data-table degil kendi <table class="kalem-tablo">
   etiketini basiyor ve scoped niteligi hucrelere dogrudan isleniyor.)

   OZGULLUK: derin secici tek basina YETMIYOR. Vuetify'nin kendi kurallari
   da cogu zaman iki sinif + uc etiket tasiyor; ayni ozellige daha zayif
   bir secici ile dokunan kural sessizce OLU kalir - dosyada durur, testten
   gecer, tarayicida hicbir sey yapmaz. Bu blokta ozgullugu yukseltmenin
   yolu !important degil, secicinin kendisi: Vuetify'nin kuralinda gecen
   sinifi/etiketi secicimize de yazmak.
   ------------------------------------------------------------------ */

/* TAVANLAR - kolon eni tavanlarinin degistigi TEK YER.
     --kod-tavani : kod / belge / tarih gibi SABIT BICIMLI kolonlar
                    (Belge No, Fatura No, Bilet No, Tedarikci, Musteri,
                     tarihler). "320.09.02.001" bu tavana sigmaz, tam
                     degeri title ipucunda.
     --ad-tavani  : serbest metin kolonlari (.uzun-metin: Yolcu, Unvan).
                    Daha genis, cunku bir ad 10 karakterde taninmaz.
   Ikisi de max-width, yani GENIS EKRAN (esik ustu) davranisi icin baglayici
   bir tavan; tablo kabini doldurunca tarayici kalan yeri kolonlara dagitiyor
   ve kirpma kendiliginden hafifliyor. Olculdu (MF, Belge No hucresinin
   kirpimi): 1520'de 34px, 1920'de 7px, 2560'ta 0.
   Esigin ALTINDA bu tavanlar kalkiyor ve --ad-tavani bir TABANA donusuyor
   (bkz. blogun sonundaki medya sorgusu) - sayilar yine buradan geliyor. */
.aktarim-tablosu {
  --kod-tavani: 80px;
  --ad-tavani: 110px;
}

/* 24px -> 6px: kazancin en buyuk parcasi. Stil kapaliyken tabloya YALNIZCA
   bu kural eklendiginde MF 2254.59 -> 1642.68px olculdu, yani 611.91px
   (17 kolon x 2 kenar x 18px). Recetenin tamami acikken tek basina
   kaldirilinca tablo 1179.45 -> 1537.56px oluyor (+358.11): aradaki fark
   tavanlarin bir kismini zaten baglamasindan.

   "table.v-table thead/tbody" SART, susleme degil. Vuetify'nin dolgu
   kurali (_tables.styl:49) "table.v-table thead td:not(:first-child)"
   gibi yaziliyor: ozgullugu (0,2,3). Bu kural bir sure ".aktarim-tablosu
   >>> th, .aktarim-tablosu >>> td" seklinde duruyordu - ozgullugu (0,2,1),
   yani Vuetify KAZANIYORDU ve getComputedStyle(td).paddingLeft tarayicida
   24px okunuyordu: recetenin en buyuk parcasi hic uygulanmiyordu. Bu eski
   secici yeniden olculdu: dosyaya konuldugunda dolgu 24px kaliyor ve tablo
   2254.59px'ten hic kimildamiyor. Bu haliyle (0,3,3) olup yeniyor;
   !important gerekmiyor. */
.aktarim-tablosu >>> table.v-table thead th,
.aktarim-tablosu >>> table.v-table thead td,
.aktarim-tablosu >>> table.v-table tbody th,
.aktarim-tablosu >>> table.v-table tbody td {
  padding: 0 6px;
}

/* Vuetify th'e nowrap veriyor; bu yuzden dar kolonlarin enini DEGER degil
   BASLIK belirliyordu ("Satis Tarihi", "Havayolu", "Doviz"). Sarma serbest
   birakilip yazi 11px'e indirilince baslik satiri YUKSELMEDEN 14.67px
   kazaniliyor: bu kural kapatildiginda MF tablosu 1179.45 -> 1194.12px.
   Kazanc kucuk gorunuyor cunku asagidaki tavanlar kolonlarin cogunu zaten
   80px'te tutuyor; kural yine de gerekli, tavansiz kolonlarda (Havayolu,
   Hat, Doviz) eni belirleyen tek sey baslik. */
.aktarim-tablosu >>> thead th {
  white-space: normal;
  font-size: 11px;
}

/* Siralama oku gorunmezken de (Vuetify opacity: 0 veriyor) 16px yer
   kapliyor; stil kapaliyken Havayolu (113px) / Hat (83px) / Doviz (94px)
   kolonlarinin enini buyuten paylardan biriydi.

   DURUSTCE: bugun EN'e katkisi 0. Olculdu (MF, 1280): receteden tek
   basina cikarildiginda tablo 1179.45px'ten hic kimildamiyor, cunku
   ustteki thead th kurali oku zaten kendi satirina sardirip enden
   dusuruyor. Kalmasinin nedeni ikisi: gorunmeyen bir ok basligin yaninda
   yer tutmamali, ve ustteki kural bir gun kalkarsa bu kural o payi tek
   basina geri kazaniyor.

   Yer yalnizca siralamanin ETKIN oldugu kolonda ayriliyor, yani gosterge
   kaybolmuyor (tiklanan baslikta ok 16.01px olarak ciziliyor - olculdu).

   ".sortable.active" SART, yalniz ".active" DEGIL. Etkin baslik Vuetify'de
   iki sinifi birden tasiyor (olculdu: "column sortable active desc
   text-xs-left"), yani her iki secici de ona uyuyor. ".active" ile
   yazilsaydi ikisi de (0,4,2) ozgullukte olur ve kazanani yalnizca
   DOSYADAKI SIRA belirlerdi: kurallari yeniden siralayan biri oku sessizce
   yok ederdi. Olculdu - ustteki kural bu kuraldan sonra tekrarlandiginda
   etkin basliktaki okun eni 16.01px -> 0px'e dusuyor ve hicbir test
   dusmuyor. ".sortable.active" (0,5,2) siradan bagimsiz kazaniyor. */
.aktarim-tablosu >>> thead th.sortable .v-icon {
  width: 0;
  overflow: hidden;
}

.aktarim-tablosu >>> thead th.sortable.active .v-icon {
  width: auto;
  overflow: visible;
}

/* Secim kutusu kolonu stil kapaliyken 80px'ti, kutunun ikonu 24px. Kural
   olmadan kontrol 32px / kolon 44px; 28px verilince kontrol 28px / kolon
   40px ve hucre hic kirpmiyor. 24px denendi: hucre 2px kirpiyor (olculdu),
   o yuzden 28 = 24 + tasma payi. */
.aktarim-tablosu >>> .v-input--selection-controls {
  width: 28px;
}

/* Kalem dugmesi ve durum rozeti kolon enini iceriklerinden degil kendi
   asgari olculerinden aliyordu: v-btn'in min-width'i 80px oldugu icin
   icerigi tek hane olan Kalem kolonu 135.98px, "Aktarilmadi" rozeti de
   Durum kolonunu 146.15px yapiyordu (stil kapaliyken olculen degerler;
   simdi 63.38 ve 87.98px). Uc kural birlikte 58.76px: ayri ayri
   kapatildiklarinda MF tablosu 1179.45 -> 1216.05 / 1189.63 / 1191.43px
   oluyor.

   .v-chip'te YUKSEKLIK VERILMIYOR, bilerek. Denendi ve OLU cikti:
   Vuetify'nin ".v-chip--small { height: 24px !important }" kurali
   kazaniyor, rozetin olculen yuksekligi 23.99px. "height: 22px" satiri
   dosyada dururken silindiginde tarayicida HICBIR SEY degismedi (rozet
   23.99px, Durum kolonu 87.98px, tablo 1179.45px - ucu de ayni), o yuzden
   satir kaldirildi: bu blokta olu bildirim birakilmiyor. Kayip ozgullukte
   degil !important'ta oldugu icin ozgulluk testi de bunu yakalayamazdi.

   .v-chip__content'teki 22px ise CANLI ve gerekli: silindiginde icerik
   kutusu 21.99 -> 31.99px'e ciktigi olculdu, yani 24px'lik rozetin
   disina tasiyor.

   Dugmede KENAR BOSLUGU VERILMIYOR, o da denenip olu cikti: sablondaki
   kaydetbutonu zaten Vuetify'nin "ma-0" siniflarini tasiyor ve o sinif
   margin'i !important ile sifirliyor. "margin: 0" satiri silindiginde
   getComputedStyle(dugme).margin yine 0px, Kalem kolonu 67.63px, tablo
   1259.55px - hicbiri kimildamadi. Kenar boslugu gerekiyorsa sablondaki
   ma-0'a bakilmali. */
.aktarim-tablosu >>> tbody td .v-btn--small {
  min-width: 0;
  padding: 0 6px;
}

.aktarim-tablosu >>> tbody td .v-chip {
  font-size: 11px;
}

.aktarim-tablosu >>> tbody td .v-chip .v-chip__content {
  padding: 0 6px;
  height: 22px;
}

/* Deger KAYBOLMUYOR: kirpilan her hucrenin tam degeri title ipucunda
   (bkz. sablondaki :title'lar). Sarmanin kapatilmasi ayrica iade ve fatura
   satirlarini 97.9-137.33px araligindan 48px'e indiriyor - Unvan artik uc
   satira bolunmuyor. Bu kural tek basina kapatildiginda MF tablosu
   1179.45 -> 1204.87px.

   DIKKAT: buradaki nowrap yalnizca GENIS ekranin davranisi. Esigin
   altinda asagidaki medya sorgusu bunu sarmaya ceviriyor. */
.aktarim-tablosu >>> tbody td {
  font-size: 12px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

/* Para kolonlari (.text-xs-right) kirpma DISINDA: bir tutarin ucu noktaya
   dusmesi degeri okunamaz degil YANLIS okunur hale getirir ("14.252,33"
   yerine "14.252..."). Kalem dugmesinin hucresi de bu siniftadir.
   Tavanin kazanci 122.18px (kapatildiginda MF tablosu 1179.45 ->
   1301.63px). */
.aktarim-tablosu >>> tbody td:not(.text-xs-right) {
  max-width: var(--kod-tavani);
}

/* Yolcu adi ve unvan serbest metin: listenin en genis kolonlari (stil
   kapaliyken Yolcu 297.81px olculdu). Kodlardan daha genis bir tavan
   aliyorlar; tam ad title'da. Bedeli 30px: bu kural kapatilip Yolcu da
   80px tavanina dusseydi MF tablosu 1179.45 -> 1149.45px olurdu.

   Araya giren "tr" ozgulluk icindir: bu kural bir ustteki tavani EZMELI.
   "tbody td.uzun-metin" ile "tbody td:not(.text-xs-right)" ozgullukce
   ESIT olurdu (0,3,2) ve hangisinin kazandigini yalnizca dosyadaki sira
   belirlerdi - kurallar bir gun yer degistirse Yolcu kolonu sessizce
   80px'e duserdi. "tr" ile (0,3,3) oluyor, siradan bagimsiz. */
.aktarim-tablosu >>> tbody tr td.uzun-metin {
  max-width: var(--ad-tavani);
}

/* Durum rozeti TAVANSIZ - ama SIGORTA olarak, bugunku bir hatayi
   duzelttigi icin DEGIL. Yeniden olculdu: tavan geri konsa (80px) rozet
   yine kirpilmiyordu - "Aktarilmadi" rozeti 68.01px, hucrenin ic kutusu
   80px, yani 11.99px pay kaliyor. Kirpan kutu PADDING kutusu oldugu icin
   6px'lik yan dolgular hala gorunur alan; kural yazildiginda varsayilan
   24px dolguyla hesaplanan "ic kutu 33px" rakami bu yuzden gecerli degil.

   Sinifin BUGUNKU bedeli olculdu: kaldirilinca Durum kolonu 87.98 ->
   80px, MF tablosu 1179.45 -> 1171.46px, yani 7.99px. Buna ragmen
   kaliyor, cunku pay yalnizca 11.99px: rozetin metni ~12px uzarsa
   (orn. "Kismen aktarildi") tavanli halde ortadan bicilir ve rozette
   title YOKTUR - metin degerin kendisidir, hicbir yerden okunamaz.
   Kural olu degil: yukaridaki genel tavani gercekten eziyor (kaldirma
   olcumu bunu gosteriyor).
   "tr": bkz. bir ustteki ozgulluk notu. */
.aktarim-tablosu >>> tbody tr td.durum-hucresi {
  max-width: none;
}

/* Tedarikci / karsi taraf kolonu, kalem simgesi kadar DAHA GENIS.
   Simge hucrenin icinde duruyor ve 24px (20 ikon + 4 bosluk) yiyor; tavan
   80px te birakilsaydi degere 44px kalirdi, yani ~6 karakter:
   "320.09.02.001" nin yarisi. Olculdu (1520, simge eklendikten sonra,
   tavan 80px iken): MF 31px, alis iadesi 30px kirpiliyordu. Tavani
   simgenin eni kadar buyutmek degere ESKI alanini geri veriyor.
   Tablonun asgari eni yalnizca bu kadar buyur; sarma esigi (1519) zaten
   bunun cok ustunde. "tr": bkz. ozgulluk notu. */
.aktarim-tablosu >>> tbody tr td.tedarikci-hucresi {
  max-width: calc(var(--kod-tavani) + 24px);
}

/* Tedarikci / karsi taraf hucresindeki DUZENLEME (kalem) SIMGESI.
   v-btn kendi olculeriyle gelir - ikon kipinde 36x36px kutu ve 6px kenar
   boslugu - ve bir hucrenin icinde hem kolonu sisirir hem satiri 48px in
   ustune cikarirdi. Burada 20x20px e iniyor ve kenar bosluklari yalnizca
   degerle arasinda 4px kaliyor.
   Olculdu (1520): simge 20x20px, satir bes tipte de 48px, tasma 0.
   1280 de de bes tipte tasma 0; satir yuksekligi simge yuzunden yalnizca
   maliyette 54.99 -> 56.45px degisti, otekiler ayni kaldi. */
.aktarim-tablosu >>> tbody td .hucre-dugmesi {
  width: 20px;
  height: 20px;
  margin: 0 4px 0 0;
}

/* Ikonun kendisi de kuculmeli: v-icon small 16px, ama v-btn--icon ic
   kutusu 36px lik alani doldurmaya calisiyor. */
.aktarim-tablosu >>> tbody td .hucre-dugmesi .v-btn__content {
  width: 20px;
  height: 20px;
}

/* ------------------------------------------------------------------
   DAR EKRAN: kirpma yerine SARMA

   Yukaridaki receteyle tablo 1179.45px'e kadar iniyor ama daha asagi
   inemiyor - kolonlarin tavani zaten baglamis durumda. Kullaniciya
   "bu ekrani hangi genislikte kullaniyorsunuz?" diye soruldu, yanit
   "degisken (dizustu + harici monitor)" (2026-09-22). Yani cubuk HER
   genislikte kalkmali, ama duz sarmayi her yerde acmak genis monitorde
   bedava bedel odetir.

   Bolunme noktasi: esigin USTUNDE bugunku davranis surer (satirlar 48px,
   uzun degerler uc noktaya duser, tam degeri ipucunda); ALTINDA uzun
   metin hucreleri alt satira sarar, hicbir deger gizlenmez, cubuk
   cikmaz, bedeli yalnizca satirlarin yukselmesi olur.

   ESIK NEDEN 1519px:
   Medya sorgusu PENCEREYI olcer; olculdu - dikey kaydirma cubugu varken
   bile matchMedia 1280px'lik pencerede 1280 goruyor (document.document-
   Element.clientWidth 1265 iken). Kabin ise pencere - 245 (sol menu) -
   15 (dikey cubuk).
   Tablonun asgari eni SABIT DEGIL, veriye bagli: para kolonlari tavansiz
   ve nowrap (bir tutar ne kirpilabilir ne bolunebilir), dolayisiyla
   rakam buyudukce tablo genisliyor. MF'de olculdu:
       tutar < 1.000.000       -> 1179.45px  (cubuk 1439'dan itibaren yok)
       1.401.437,90            -> 1205.99px  (... 1466'dan itibaren)
       14.014.379,00           -> 1229.39px  (... 1490'dan itibaren)
       99.999.999,99           -> 1236.14px  (... 1497'den itibaren)
       999.999.999,99          -> 1256.38px  (... 1517'den itibaren)
   Esik 1439'a kurulsaydi, milyonlu tutarlari olan bir sirkette cubuk
   1440-1516 arasinda GERI GELIRDI ve kullanicinin sikayeti aynen surerdi.
   1519 en kotu olculen halin (1256.38 + 245 + 15 = 1516.38) ustunde ve
   en kucuk yaygin harici monitor enin (1600) altinda. Iki hatanin bedeli
   esit degil: esik dusuk kalirsa cubuk geri geliyor, yuksek kalirsa
   yalnizca 1440-1519 bandinda satirlar birkac piksel yukseliyor
   (olculdu: 1438'de 48 -> 55.44px).

   SOL MENU KAPATILABILIYOR. O zaman kabin pencere - 15 oluyor, yani
   esigin altindaki bir pencerede bile tablo rahat sigar ve sarma
   "gereksiz" acilir. Olculdu (1280, menu kapali, kabin 1265): bes tipte
   de tasma 0, en yuksek satir 48 / 48 / 55.44 / 55.44 / 55.44px - yani
   bedeli en fazla 7.44px, hicbir deger de gizlenmiyor. Ters yonde risk
   yok: esik menu ACIKKEN (kabin = pencere - 260) hesaplandi, menu
   kapanmasi kabini yalnizca buyutur.
   ------------------------------------------------------------------ */
@media (max-width: 1519px) {
  /* Kirpma -> sarma. "overflow-wrap: anywhere" SART, "break-word" degil:
     tablonun daralabilmesi icin hucrenin ASGARI icerik eninin dusmesi
     gerekiyor ve bunu yalnizca "anywhere" yapiyor. Bilet / belge
     numaralari bosluksuz tek bir belirtec, break-word ile satir
     bolunmezdi ve tablo yine 1179.45px'te kalirdi.

     DISARIDA KALANLAR - ucu de bilerek:
     .text-xs-right : para kolonlari. Bolunmus bir tutar ("14.252," /
                      "33") okunamaz degil YANLIS okunur; kirpma
                      yasagiyla ayni gerekce.
     .tarih-hucresi : "01.09.2026" bosluksuz tek belirtec, anywhere ile
                      "01.09." / "2026" diye ikiye bolunurdu.
     .hat-hucresi   : "BSP" uc harflik tek belirtec; anywhere onu da
                      "BS" / "P" diye boluyordu (olculdu: 1280'de
                      hucre iki satira dusuyordu). Kolonun tabana
                      katkisi ~25px, olculen tasma yine 0.
     Bu iki kume (bir de secim kutusu, Kalem dugmesi, Durum rozeti) nowrap
     kaldigi icin tablonun bir TABANI var. Sarma modunda olculen asgari
     enler: fatura 724.84, maliyet 887.76, MF 1003.24, iade 980.18, alis
     iadesi 1005.45px. Yani cubuk 1266px pencereden itibaren tamamen
     kalkiyor (olculdu: 1265'te alis iadesinde 1px, 1266'da bes tipte de
     0) - oncesinde bu esik 1439'du. 1024 ve 800'de cubuk KALKMIYOR:
     o genisliklerde kabin bu tabanin altinda kaliyor (bkz. rapor).

     TAVANLAR KALKIYOR (max-width: none). Tavanlarin isi kirpmayi
     zorlamakti; sarma modunda hicbir sey gizlenmedigi icin tavan
     yalnizca YERI OLAN kolonu ac birakir. Olculdu (tavan acik -> kapali,
     en yuksek satir): 1280'de fatura 72.9 -> 48px; 1518'de fatura
     54.9 -> 48, maliyet 55.44 -> 48, iade ve alis iadesi 90.89 ->
     55.44px. Hicbir tip ve hicbir genislikte kotulesmiyor, cunku tavan
     kalkinca tarayici bos yeri uzun kolonlara dagitiyor.

     Ozgulluk: yukaridaki "tbody td" kurali (0,2,2) nowrap, "tbody tr
     td.uzun-metin" (0,3,3) ise 110px tavan veriyor; bu secici (0,4,2)
     oldugu icin ikisini de siradan bagimsiz yeniyor. */
  .aktarim-tablosu >>> tbody td:not(.text-xs-right):not(.tarih-hucresi):not(.hat-hucresi) {
    white-space: normal;
    overflow-wrap: anywhere;
    max-width: none;
  }

  /* Ad kolonlarina (Yolcu / Unvan) TABAN. overflow-wrap: anywhere bir
     hucrenin asgari icerik enini TEK KARAKTERE indiriyor, yani taban
     olmazsa tarayici yer sikistiginda once serbest metni eziyor.
     Olculdu (1280, taban var -> yok; en yuksek satir / ad kolonunun eni):
       alis iadesi  90.89 -> 108.89px  (Unvan 113.20 -> 81.21px)
       iade         90.89 -> 90.89     (118.58 -> 86.49)
       MF           91.43 -> 90.89     (115.53 ->  76.53)
       maliyet/fatura degismiyor.
     Yani kazanc alis iadesinde bir tam satir; MF'de 0.54px'lik fark ters
     yonde ama ayni satir sayisi (bes). Iki ad kolonunu birden tasiyan
     alis iadesi belirleyici oldugu icin taban kaliyor.
     Taban DEGERI --ad-tavani: genis ekrandaki tavan ile dar ekrandaki
     taban ayni sayi olsun ki kolon eni hala TEK YERDEN ayarlansin.
     Bedeli var: taban tabloyu genisletiyor, yani 1024 gibi zaten tasan
     genisliklerde tasmayi artiriyor. Ama alternatifi okunaksiz: olculdu
     (1024/alis iadesi) taban kaldirilinca tasma 241 -> 103px'e duserken
     satirlar 90.89 -> 270.87px'e cikiyor, yani Unvan on bes satira
     boluniyor. Cubuk zaten orada; okunakligi korumak secildi. */
  .aktarim-tablosu >>> tbody tr td.uzun-metin {
    min-width: var(--ad-tavani);
  }
}

</style>
